var _defs, _rect, _path, _g, _rect2, _circle, _g2, _g3, _g4, _g5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35 {\n        stroke-width: 0px;\n      }\n\n      .cls-36 {\n        fill: url(#Degradado_sin_nombre_373);\n        stroke-width: .49px;\n      }\n\n      .cls-36, .cls-37 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-37 {\n        fill: url(#Degradado_sin_nombre_370);\n        stroke-width: .25px;\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        filter: url(#drop-shadow-19);\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-32 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-18);\n      }\n\n      .cls-5 {\n        filter: url(#drop-shadow-14);\n      }\n\n      .cls-6 {\n        filter: url(#drop-shadow-22);\n      }\n\n      .cls-7 {\n        filter: url(#drop-shadow-20);\n      }\n\n      .cls-8 {\n        filter: url(#drop-shadow-21);\n      }\n\n      .cls-9 {\n        filter: url(#drop-shadow-26);\n      }\n\n      .cls-10 {\n        filter: url(#drop-shadow-29);\n      }\n\n      .cls-11 {\n        filter: url(#drop-shadow-25);\n      }\n\n      .cls-12 {\n        filter: url(#drop-shadow-28);\n      }\n\n      .cls-13 {\n        filter: url(#drop-shadow-27);\n      }\n\n      .cls-14 {\n        filter: url(#drop-shadow-23);\n      }\n\n      .cls-15 {\n        filter: url(#drop-shadow-30);\n      }\n\n      .cls-16 {\n        filter: url(#drop-shadow-16);\n      }\n\n      .cls-17 {\n        filter: url(#drop-shadow-15);\n      }\n\n      .cls-18 {\n        filter: url(#drop-shadow-11);\n      }\n\n      .cls-19 {\n        filter: url(#drop-shadow-13);\n      }\n\n      .cls-20 {\n        filter: url(#drop-shadow-12);\n      }\n\n      .cls-39 {\n        opacity: .42;\n      }\n\n      .cls-21 {\n        fill: url(#Degradado_sin_nombre_137);\n      }\n\n      .cls-22 {\n        fill: #f0ffe9;\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-23 {\n        filter: url(#drop-shadow-8);\n      }\n\n      .cls-24 {\n        filter: url(#drop-shadow-6);\n      }\n\n      .cls-25 {\n        filter: url(#drop-shadow-9);\n      }\n\n      .cls-26 {\n        filter: url(#drop-shadow-7);\n      }\n\n      .cls-27 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-28 {\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-40 {\n        filter: url(#drop-shadow-17);\n      }\n\n      .cls-41 {\n        filter: url(#drop-shadow-24);\n      }\n\n      .cls-42 {\n        filter: url(#drop-shadow-10);\n      }\n\n      .cls-43 {\n        filter: url(#drop-shadow-31);\n      }\n\n      .cls-29 {\n        fill: #f9d656;\n      }\n\n      .cls-30 {\n        fill: #e1991c;\n      }\n\n      .cls-31 {\n        fill: #fdebb6;\n      }\n\n      .cls-33 {\n        fill: #eeae1a;\n      }\n\n      .cls-34 {\n        fill: #fbde7f;\n      }\n\n      .cls-35 {\n        fill: #f1bb16;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 8.58,
    dy: 6.13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 12.26
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ffb600",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_370",
    "data-name": "Degradado sin nombre 370",
    x1: 31.09,
    y1: 37.3,
    x2: 31.09,
    y2: 9.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#eebdc7",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#eebec8",
    stopOpacity: 0.23
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#efc1cc",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f2c7d3",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f5cfdd",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#f9d9e9",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fadaea",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_373",
    "data-name": "Degradado sin nombre 373",
    x1: 33.06,
    y1: 20.74,
    x2: 33.06,
    y2: 52.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fff",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#fff",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#fff",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m46.89,29.72l-33.01.16c-2.71.01-4.9,2.22-4.89,4.93l.1,20.16c.01,2.71,2.22,4.9,4.93,4.89h1.05s18.39-12.61,18.39-12.61c2.24-1.53,5.29-.96,6.83,1.27l7.61,11.1c2.29-.42,4.03-2.44,4.02-4.85l-.1-20.16c-.01-2.71-2.22-4.9-4.93-4.89Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_137",
    "data-name": "Degradado sin nombre 137",
    x1: 39.35,
    y1: 42.76,
    x2: 52,
    y2: 42.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c1e5e",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#970d7c",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#920392",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90009c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.64,
    dy: 1.96
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 4.66
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff83fc",
    floodOpacity: 0.61
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m22.36,29.84l20.67-.1s-1.17-9.29-8.21-9.6-10.89,3.51-10.89,3.51l-1.57,6.2Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-10",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-11",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-10",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-12",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-11",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-11",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-13",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-12",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-12",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-14",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-13",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-13",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-15",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-14",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-14",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-16",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-15",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-15",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-17",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-16",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-16",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-18",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-17",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-17",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-19",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-18",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-18",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-20",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-19",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-19",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-21",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-20",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-20",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-22",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-21",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-21",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-23",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-22",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-22",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-24",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-23",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-23",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-25",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-24",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-24",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-26",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-25",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-25",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-27",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-26",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-26",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-28",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-27",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-27",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-29",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-28",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-28",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-30",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-29",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-29",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-31",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.47,
    dy: 1.39
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-30",
    stdDeviation: 2.78
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#a46f15",
    floodOpacity: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-30",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 16.98,
    y: 26.23,
    width: 28.23,
    height: 22.14,
    rx: 4.23,
    ry: 4.23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m16.95,29.93h28.26c2.18,0,3.95,1.77,3.95,3.95v15.47c0,2.18-1.77,3.95-3.95,3.95h-24.32c-2.18,0-3.95-1.77-3.95-3.95v-19.42h0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("image", {
    width: 99,
    height: 100,
    transform: "translate(-14 -19)",
    xlinkHref: "data:image/png;base64,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"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 39.35,
    y: 39.06,
    width: 12.65,
    height: 7.39,
    rx: 2.71,
    ry: 2.71
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 43.17,
    cy: 42.92,
    r: 1.77
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.86,23.59h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.44,23.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.99,36.09h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.73,27.66l.88-1.88c-.1.16-.19.32-.28.49-.24.44-.43.91-.6,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.28,29.77h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.19,23.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.23,36.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.28,23.37h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.73,23.18h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.2,35.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.84,35.66h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.4,35.42h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.76,36.02h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.32,34.61l-.03-.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.92,32.67s-.01-.02-.02-.04c0,.01.01.02.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.04,32.92h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.98,32.8v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.17,34.46s-.02-.02-.04-.04c.01.01.02.02.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.11,33.05h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.05,24.12h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.24,34.26l-.02.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "37.7 26.47 37.69 26.47 37.69 26.47 37.7 26.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.06,33.27h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.59,33.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.53 24.71 36.52 24.7 36.52 24.7 36.52 24.7 36.53 24.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "35.49 23.82 35.51 23.83 35.49 23.82 35.49 23.82 35.49 23.82 35.49 23.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.4,24.58h0s.03.03.05.05c-.02-.02-.03-.03-.05-.05,0-.01-.02-.02-.03-.03.01.01.02.02.03.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.94,31.46s0,.03-.01.04c0-.01,0-.03.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.32,23.71s-.02-.01-.03-.02c-.06-.04-.11-.07-.17-.11.06.03.12.07.17.11.01,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.03,24.23h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.71,23.98s.09.07.14.1l.03.02h0s0,0,0,0c.03.02.05.04.08.07h0s-.06-.04-.08-.07l-.03-.02s-.09-.07-.14-.1c-.01,0-.03-.02-.04-.03-.05-.04-.11-.08-.16-.12.06.04.11.08.16.12.01,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.16,27.96s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38,27.29s0,.03.01.05c0-.02,0-.03-.01-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.07,27.53h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.85,26.86s.01.03.02.04c0-.01-.01-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.94,27.09s0,.02.01.03c0-.01,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.12,27.75s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.78,26.66s.01.03.02.05c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.01,31.23h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.13,30.73h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.08,30.97v.03s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.18,30.48h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.52,26.11s-.03-.05-.04-.07h0s0,0,0,0c.01.02.03.05.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.01,29.8c0-.06,0-.13,0-.19,0,.06,0,.13,0,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.41,21.91s.05-.02.08-.03c-.03,0-.05.02-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.02,30.06c0-.07,0-.15,0-.22,0,.07,0,.15,0,.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.02,29.58c0-.07,0-.14,0-.21,0,.07,0,.14,0,.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.29,31.93c-.01-.05-.03-.11-.04-.16.01.05.03.11.04.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.35,32.17c-.02-.05-.03-.1-.04-.16.01.05.03.1.04.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.02,29.37c0-.07,0-.15.01-.22,0,.07-.01.15-.01.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.89,22.13s.04-.02.06-.03c-.02,0-.04.02-.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.06,22.05s.05-.02.07-.03c-.02,0-.05.02-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.24,21.98s.05-.02.08-.03c-.03,0-.05.02-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.72,22.21h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27,23.34c.14-.12.29-.24.45-.36-.15.11-.3.23-.45.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.49,36.19h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.46,32.51c-.03-.1-.07-.2-.1-.3.03.1.06.2.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.84,35.94c-.07-.06-.14-.12-.21-.18.07.06.14.12.21.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.08,36.76s-.08-.05-.13-.07c.04.02.08.05.13.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.62,35.75c-.07-.06-.14-.13-.21-.19.07.07.14.13.21.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.54,32.73c-.02-.05-.04-.1-.06-.15.02.05.04.1.06.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.56,37s-.05-.02-.07-.03c.02.01.05.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.34,36.89s-.05-.03-.08-.04c.03.01.05.03.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.61,34.66s-.06-.09-.1-.13c.03.04.06.09.1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.87,33.49s-.05-.1-.07-.14c.02.05.05.1.07.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.37,34.33c-.06-.09-.12-.18-.18-.28.06.09.12.19.18.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.7,33.11c-.05-.1-.09-.21-.13-.32.04.11.09.21.13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.77,33.27s-.05-.1-.07-.15c.02.05.04.1.07.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.16,33.99s-.05-.09-.08-.14c.03.05.05.09.08.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.04,33.8c-.05-.09-.1-.19-.15-.29.05.1.1.19.15.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.57,23.73c.14-.13.28-.26.42-.39-.14.12-.29.25-.42.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.03,37.44c-.08.02-.16.03-.25.05.08-.01.16-.03.25-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.78,37.49c-.07.01-.15.02-.22.03.07-.01.15-.02.22-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.15,37.22s.03,0,.05.01c.05.02.09.03.14.04-.05-.01-.09-.03-.14-.04-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.56,21.86c.08.03.17.06.25.09-.08-.03-.17-.06-.25-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.28,37.39c-.07.02-.15.03-.22.05.08-.02.15-.03.22-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.49,36.47c-.05.03-.11.06-.16.09.05-.03.11-.06.16-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.49,37.53c-.06,0-.12.02-.18.02.06,0,.12-.01.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.51,36.28h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.53,37.34s.05.01.08.02c.03,0,.06.02.09.02-.03,0-.06-.02-.09-.02-.03,0-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.99,36.26h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.9,37.58s-.07,0-.11,0c-.03,0-.06,0-.09,0,.03,0,.06,0,.09,0,.04,0,.07,0,.11,0,.03,0,.06,0,.09,0,.04,0,.08,0,.11,0-.04,0-.08,0-.11,0-.03,0-.06,0-.09,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.36,37.51s.02,0,.03,0c.02,0,.04,0,.05,0-.02,0-.04,0-.05,0,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.91,37.43s-.04,0-.06-.01c.02,0,.04,0,.06.01.03,0,.06.01.09.02.04,0,.07.01.11.02-.04,0-.07-.01-.11-.02-.03,0-.06-.01-.09-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.55,21.45h0c.08,0,.16,0,.24-.01-.08,0-.16,0-.24.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.14,21.69s.06-.01.08-.02c-.03,0-.06.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.32,21.64s.06-.01.08-.02c-.03,0-.06.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.58,21.59c.09.02.17.04.25.06-.08-.02-.17-.04-.25-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.51,21.6s.06-.01.08-.02c-.03,0-.06.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.77,21.79s.05-.02.08-.03c-.03,0-.06.02-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.95,21.74s.06-.02.08-.02c-.03,0-.06.02-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.7,21.56s.06-.01.08-.02c-.03,0-.06.01-.08.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.7,21.46c.19.02.39.04.58.07-.19-.03-.38-.05-.58-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.59,21.85s.05-.02.08-.03c-.03,0-.05.02-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.28,21.53c.08.01.17.03.25.05-.08-.02-.17-.03-.25-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.09,21.5s.05,0,.08-.01c-.03,0-.05,0-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.29,21.47s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.89,21.53s.05,0,.08-.01c-.03,0-.05,0-.08.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.47,34.48s-.06-.09-.09-.13c.03.04.06.09.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.85,25.08s.07.09.11.14l.02.02h0s.01.02.01.02h0s0,0,0,0c.04.05.07.1.11.15h0s0,0,0,0c.01.01.02.03.03.04h0s.04.06.06.09c.02.03.04.06.06.09h0c.04.06.07.12.1.18h0s.02.03.02.04l.65-1.39-.02-.03-.02-.02c-.05-.06-.1-.13-.15-.19-.01-.02-.03-.03-.04-.05-.04-.05-.09-.11-.13-.16,0-.01-.02-.02-.03-.03-.03-.03-.06-.06-.09-.1l-.61,1.31s-.06-.08-.09-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.35,30.74h0s0,.02,0,.03c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "25.6 31.85 25.6 31.86 25.6 31.85 25.6 31.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.47,25.14s-.02-.04-.03-.06c-.01-.02-.03-.04-.04-.07.01.02.03.04.04.07.01.02.02.04.03.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.04,26.35v.02s0-.02,0-.02c-.02-.07-.05-.13-.08-.2,0-.02-.02-.04-.02-.06,0,.02.02.04.02.06.03.07.05.13.08.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.3,30.38h0s0,0,0,0c0,.02,0,.03,0,.05,0-.02,0-.03,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.28,29.97h0c0,.06,0,.12,0,.17,0-.06,0-.12,0-.17h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "37.44 23.76 37.44 23.76 37.42 23.74 37.44 23.76 37.44 23.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.18,22.75h0s0,0,0,0c-.02,0-.04,0-.06,0,.02,0,.04,0,.06,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.76,32.3s0-.02-.01-.03c.02.05.04.09.06.14-.01-.03-.03-.07-.04-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.84,32.49h0s.02.03.02.05c0-.01-.01-.03-.02-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.68,32.1c.02.06.04.11.06.17h0s0,0,0,0c-.02-.06-.04-.11-.06-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.65,23.03h-.01s-.05-.05-.08-.07c.03.02.05.04.08.06h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.66,32.05h0s.01.03.02.04c0-.01-.01-.03-.02-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.77,22.43h-.01s-.09-.06-.13-.08c.04.02.09.05.13.07h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.14,23.12s.03.01.05.02c-.02,0-.03-.01-.05-.02-.03-.01-.06-.02-.1-.03h.01s.06.02.09.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.06,22.07s-.04-.02-.06-.03c-.03-.01-.07-.03-.1-.04.03.01.07.03.1.04.02,0,.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.05,34.45s-.07.06-.1.09c-.18.17-.38.32-.58.47-.03.02-.07.05-.1.07-.13.09-.26.18-.39.26l-.85,1.82c-.24.08-.48.15-.72.21.72-.18,1.39-.45,2.02-.81-.12.07-.24.13-.36.19l1.08-2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.88,37.59l.65-1.39c-.18.03-.37.05-.56.06-.07,0-.14,0-.22.01l-.61,1.31s.03,0,.05,0c.04,0,.08,0,.12,0,.03,0,.06,0,.09,0,.04,0,.08,0,.12,0,.03,0,.05,0,.08,0,.05,0,.09,0,.14,0,.02,0,.05,0,.07,0,.07,0,.14,0,.21-.01.08,0,.16-.01.24-.02-.08,0-.16.02-.24.02-.04,0-.09,0-.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.99,23.07h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.19,23.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.9,23.46h0s.03.02.05.02c-.02,0-.03-.02-.05-.02h-.03s.03,0,.03,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "34.71 23.37 34.71 23.37 34.71 23.37 34.72 23.37 34.71 23.37 34.69 23.36 34.71 23.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.95,22.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.53,22.77h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.28,22.76s.02,0,.04,0c-.01,0-.02,0-.04,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.38,27.54v-.03s-.01-.04-.02-.06c0,.02,0,.04.01.06v.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.69,22.79h0s.06,0,.09.01c.03,0,.05,0,.07,0,.02,0,.05,0,.07.01h0s-.05,0-.08-.01c-.02,0-.05,0-.07,0-.03,0-.06,0-.09-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.62,22.78s.05,0,.08,0c-.03,0-.05,0-.08,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.26,28.72c0,.11.02.23.02.35,0,.21,0,.43-.01.64l1.08-2.31s0,.04.01.06c-.02-.07-.03-.14-.05-.21,0-.02,0-.03-.01-.05-.02-.08-.04-.16-.07-.25,0-.02-.01-.04-.02-.06-.02-.07-.04-.13-.06-.2,0-.02-.01-.04-.02-.06-.03-.08-.05-.16-.08-.23l-.85,1.82c.02.16.04.33.06.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.48,28.1s0,.07.01.11l-1.64,3.51c-.13.37-.3.72-.49,1.05-.01.02-.02.04-.03.05l-1.65,3.53c-.06.04-.11.07-.17.11,2.48-1.51,4.13-4.35,4.04-7.49,0-.09,0-.18-.01-.27,0-.02,0-.05,0-.07,0-.08-.01-.16-.02-.24v-.03c-.01-.09-.02-.18-.03-.26,0-.02,0-.04,0-.07,0-.05-.02-.1-.02-.15,0,.05.02.1.02.15,0,.02,0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "34.29 23.18 34.3 23.19 34.29 23.18 34.29 23.18 34.29 23.18 34.29 23.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.11,26.17c.3-.65.69-1.26,1.16-1.8l.3-.64c-1.43,1.4-2.37,3.31-2.53,5.42l.52-1.11c.09-.64.29-1.27.56-1.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.15,22.81c.14-.02.29-.04.44-.05h.02s.05,0,.07,0c.03,0,.05,0,.08,0,.02,0,.04,0,.06,0,.04,0,.08,0,.12,0,.02,0,.05,0,.07,0h0s0,0,0,0h.02s.05,0,.07,0l.6-1.29c-.3-.02-.6-.03-.9-.02l-.64,1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.8,34.06h0s-.03-.05-.05-.07h0s0-.01,0-.01h0s-.02-.03-.03-.04c-.02-.02-.04-.05-.06-.08,0-.01-.02-.03-.03-.04v-.02s-.03-.02-.03-.02h0s-.02-.03-.03-.04h-.01s-.01-.03-.02-.04c-.01-.01-.02-.03-.03-.04v-.02s-.03-.02-.04-.03l-.02-.02s-.03-.05-.05-.08h-.01s0-.03,0-.03h0s-.01-.02-.01-.02c-.02-.04-.05-.07-.07-.11h0s-.02-.04-.03-.06h0s0-.02,0-.02l-.64,1.37c.24.32.51.62.8.89-.07-.07-.14-.13-.2-.2l.6-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.15,22.82c.12-.07.25-.14.38-.2l.19-.41c-.45.22-.88.48-1.28.77l-.22.47c.29-.23.6-.45.93-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.79,37.09h0s0,0,0,0c.02,0,.04.02.07.03-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.99,35.16h-.02s0-.01,0-.01c-.01,0-.03-.02-.04-.03h-.02s-.06-.06-.09-.08c-.01,0-.02-.02-.03-.03l-.02-.02-.03-.02s-.04-.03-.06-.05l-.03-.02h-.01s-.57,1.22-.57,1.22c-.08-.06-.15-.12-.23-.18.33.27.68.51,1.04.71-.16-.09-.31-.19-.47-.29l.57-1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.28,29.56c.06-2.03.98-3.87,2.4-5.13h0s.68-1.46.68-1.46c-.03.02-.06.04-.09.06-.31.21-.61.42-.89.67-.17.15-.33.3-.49.46l-2.87,6.14h0c.03.51.1,1.01.22,1.49l1.04-2.22h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.19,22.86s-.05,0-.07-.01c-.03,0-.06-.01-.09-.02.03,0,.06.01.09.02.02,0,.05,0,.07.01.03,0,.06.01.09.02.02,0,.05,0,.07.01h0s0,0,0,0c.03,0,.06.01.09.02h0s0,0,0,0c.02,0,.05.01.07.02.03,0,.06.02.1.02.02,0,.04.01.06.02.03,0,.07.02.1.03.02,0,.04.01.05.02-.02,0-.04-.01-.05-.02-.03,0-.06-.02-.09-.03l.57-1.22c.08.03.17.05.25.08-.22-.08-.44-.14-.67-.2l-.57,1.23s-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.33,32.83s.02-.04.03-.05c-.01.02-.02.04-.03.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 38,
    y: 31.23,
    width: 0,
    height: 0,
    transform: "translate(-2.49 59.16) rotate(-74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.13,34.43s.02.02.04.04h0s-.02-.02-.04-.04h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 38.18,
    y: 30.48,
    width: 0,
    height: 0,
    transform: "translate(1.71 62.98) rotate(-80.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.24,26.98s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m38.07,31v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.92,31.5s0-.03.01-.04h0s0,.03-.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.85,31.72h0c-.13.37-.3.72-.49,1.05.19-.34.35-.69.49-1.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.13,25.46s.04.06.06.09c-.02-.03-.04-.06-.06-.09l-.02-.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.25,27.07s0,.03,0,.04h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.04,30.14s-.02,0-.03,0c.01,0,.03,0,.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.94,30.14s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.1,30.15h-.03s.02,0,.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.25,30.18s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.13,30.16s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.19,30.17s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.33,30.21h-.02s.02,0,.03,0h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.27,27.17s0,.04,0,.05h0s0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.27,27.27s0,.06,0,.1h0s0-.06,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.85,30.14s.04,0,.06,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.8,34.05s-.03-.04-.05-.06c.02.02.03.04.05.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 37.05,
    y: 33.27,
    width: 0,
    height: 0,
    transform: "translate(-11.27 45.29) rotate(-55.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.33,24.99h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 38.13,
    y: 30.73,
    width: 0,
    height: 0,
    transform: "translate(.66 62.27) rotate(-78.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.08,26.44s.01.03.02.04h0s-.01-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.04,26.36s0,.02.01.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.69,26.46h0s0,0,0,0h0s0,0,0,0v-.03s-.03-.05-.04-.07v-.02s.02.06.03.09c0,0,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34,26.27v.02s.02.01.02.01c0-.01-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "34.19 26.75 34.19 26.76 34.18 26.74 34.19 26.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "34.17 26.7 34.18 26.71 34.18 26.71 34.17 26.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.38,25.85s.05.09.08.14c-.03-.05-.05-.09-.08-.14,0-.02-.02-.03-.03-.05h0s.02.03.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.96,26.19h0s0,.03,0,.03c0,0-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.56,26.18s-.02-.03-.02-.05c0,0,0-.02-.01-.03.01.02.03.05.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.67,24.87v.02s.03.02.04.03c0,0-.02-.02-.02-.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.16,26.65v.02s0-.04,0-.05c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.87,35.35c.13-.08.27-.17.39-.26-.13.09-.26.18-.39.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m35.95,34.55c-.18.17-.38.32-.58.47.2-.15.39-.3.58-.47Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.22 34.28 36.24 34.26 36.22 34.28 36.22 34.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.05,34.45h0s-.07.06-.1.09c.03-.03.07-.06.1-.09Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 36.57,
    y: 33.89,
    width: 0.01,
    height: 0,
    transform: "translate(-12.97 39.52) rotate(-49.29)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "34.21 26.85 34.21 26.85 34.21 26.85 34.21 26.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "35.34 23.72 35.34 23.72 35.32 23.7 35.34 23.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.95 26.17 33.95 26.17 33.95 26.16 33.95 26.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "34.22 26.89 34.22 26.91 34.23 26.91 34.22 26.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.92 26.11 33.92 26.12 33.93 26.14 33.92 26.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.7 30.15 31.7 30.15 31.72 30.15 31.7 30.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "34.2 26.79 34.2 26.81 34.2 26.81 34.2 26.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.89,32.19s.03.04.04.05c-.02-.02-.03-.04-.05-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.32,30.51s0,.03,0,.04c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.84,32.49s.01.03.02.05c0,.01.01.03.02.04v-.02s-.03-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.67,31.58s0-.06,0-.08c0,.03,0,.06,0,.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 25.36,
    y: 30.92,
    width: 0.02,
    height: 0,
    transform: "translate(-6.09 6.23) rotate(-12.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.94,32.26s.02.02.02.03l.02.02s-.03-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.34,32.57s.04.02.05.02h.02s-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.06,32.38s.02.02.03.03h.02s-.03-.01-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31,32.32s.04.04.05.05c-.02-.02-.04-.04-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.12,32.43s.04.03.06.04h0s-.04-.03-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.28,32.54s.03.02.05.03c-.02-.01-.04-.02-.07-.04h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.19,32.48s.04.03.06.04c-.02-.01-.04-.02-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.76,32.31h0s0-.01,0-.01c.01.03.03.07.04.1v.02s-.02-.07-.03-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.91,32.66s-.01-.02-.02-.03h0s.01.03.02.04c0,.01.01.02.02.04h0s0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "26.6 33.81 26.62 33.83 26.61 33.82 26.6 33.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "26.38 33.49 26.38 33.49 26.38 33.49 26.38 33.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.5,33.67s.02.03.03.04c0-.01-.02-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "26.55 33.74 26.56 33.76 26.56 33.75 26.55 33.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.4,33.52s.03.05.05.08c-.01-.02-.03-.04-.04-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.35,33.45s-.01-.02-.02-.03c-.01-.02-.02-.04-.03-.05.02.04.05.07.07.11v-.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.95,32.74h0s.01.02.02.03v.02s.01,0,.01,0c0-.01-.01-.02-.02-.03,0,0,0-.02-.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.02,32.88s.01.02.02.04h0s0,.03,0,.03c-.01-.02-.02-.04-.03-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.1,33.03h0s0,.02,0,.02v.02s.01,0,.01,0c0-.01-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.26,33.31s.02.03.03.05v-.02s-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 29.98,
    y: 36.08,
    width: 0,
    height: 0,
    transform: "translate(-12.5 55.99) rotate(-75.38)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.3,
    y: 34.57,
    width: 0,
    height: 0.04,
    transform: "translate(-16.57 30.47) rotate(-46.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 30.23,
    y: 36.14,
    width: 0,
    height: 0,
    transform: "translate(-11.27 58.46) rotate(-78.36)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.32 30.12 31.3 30.12 31.33 30.12 31.32 30.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "30.97 36.26 30.99 36.26 30.99 36.26 30.97 36.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.18,30.09s-.02,0-.03,0c.02,0,.03,0,.05.01h-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 30.48,
    y: 36.18,
    width: 0,
    height: 0.02,
    transform: "translate(-10.48 59.88) rotate(-79.95)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 28.19,
    y: 35.29,
    width: 0,
    height: 0.01,
    transform: "translate(-16.74 39.92) rotate(-57.26)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.58 30.14 31.57 30.14 31.58 30.14 31.58 30.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.44,30.13h-.02s.02,0,.03,0h-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.74 36.02 29.76 36.02 29.76 36.02 29.74 36.02"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 28.83,
    y: 35.64,
    width: 0,
    height: 0.02,
    transform: "translate(-15.92 45.67) rotate(-63.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.7,31.79s.01.04.02.07c0-.02-.01-.04-.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.76,31.96v.03s.02.02.03.03c0-.02-.02-.04-.03-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.73,31.86h0s.02.05.03.07c0-.02-.02-.05-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.84,32.11s.02.04.03.05c-.01-.02-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.8,32.03s.02.05.04.07c-.01-.02-.03-.04-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.9,26.09h0s-.01-.01-.02-.02v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.96,30.03h0s-.03-.01-.05-.02c.02,0,.04.01.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.68,31.69s0,.04.01.06v.02s0-.05-.01-.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.5,
    y: 36.27,
    width: 0,
    height: 0.02,
    transform: "translate(-4.99 67.54) rotate(-89.62)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.08,30.07h-.01s-.02-.01-.04-.01h0s.04,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.68,31.68s0-.05-.01-.07c0,.03,0,.05.01.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "27.74 34.97 27.77 34.99 27.77 34.99 27.74 34.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.7,33.93v-.02s-.04-.03-.05-.05c.02.03.04.05.06.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.45,29.32s.03.02.04.04c-.02-.02-.04-.04-.07-.05h0s.02.02.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.52,29.37s.05.05.08.07c-.03-.02-.05-.05-.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.75,29.6h0s-.04-.04-.06-.06c.02.02.03.04.05.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.82,29.69l.02.02s-.05-.06-.07-.08c.01.02.03.03.04.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.06,30.04s.03.05.04.07c-.01-.02-.03-.05-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.11,30.14s.03.07.05.1c-.02-.03-.03-.07-.05-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.62,29.46s.04.04.06.06c-.02-.02-.04-.04-.06-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.99,29.91s.04.06.06.09c-.02-.03-.04-.06-.06-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.71,25.82s.03.03.04.05c-.01-.02-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.35 29.24 33.33 29.23 33.34 29.24 33.35 29.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.96,26.28s.02,0,.04,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.8,25.94h0s-.03-.03-.04-.05c.01.02.02.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.26,29.18s-.02-.01-.03-.02h.02s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.32,29.22s-.03-.02-.05-.03h.02s.02.03.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.17,30.25s.03.06.04.09c-.01-.03-.02-.06-.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.02,26.29s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.41,29.29s-.03-.02-.05-.04h.02s.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.08,26.3s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.31,30.66s0,.03.01.04c0-.03-.01-.06-.02-.09,0,.02,0,.03.01.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.95,29.86s.02.03.04.05c-.02-.03-.04-.06-.06-.09,0,0,.01.02.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.14,26.58s-.01-.04-.02-.06c0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.55,27.63s0,.05,0,.08h0s0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.27,25.4s.03.03.05.04c-.02-.01-.03-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.85,26.01h0s-.02-.02-.03-.04c0,.01.02.02.02.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.87 26.04 33.87 26.04 33.88 26.05 33.87 26.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.11,25.3s.03.02.05.03c-.02-.01-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.82,25.15s.02.01.04.02h0s.03.02.04.02c-.03-.01-.06-.03-.09-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.38,31.57c0,.06-.02.13-.03.19.01-.06.02-.13.03-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.33,30.73s.01.06.02.1c0-.03-.01-.06-.02-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.35,30.85s.01.08.02.11c0-.04-.01-.08-.02-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.26,30.48s.02.07.03.11c-.01-.04-.02-.07-.03-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.22,26.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.89,29.77l.02.02s-.03-.04-.05-.07c0,.01.02.02.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.22,30.37s.02.06.03.08c0-.03-.02-.06-.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.37,30.99s0,.06,0,.09c0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.38,31.12s0,.08,0,.12c0-.04,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.19,29.14h.01s-.05-.02-.07-.03h.02s.03.03.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.57,27.79v.02s0,0,0,0c0-.02,0-.04,0-.06,0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31,28.55s-.03-.03-.05-.04c.02.01.03.03.05.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.41,25.52s.02.02.03.03h0s-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.94,28.5s-.04-.04-.05-.05c.02.02.04.04.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.68,34.92s.04.03.06.05c-.02-.02-.04-.03-.06-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.06,28.6h0s-.03-.02-.05-.03c.01.01.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.87,28.43s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.59,25.68h0s.03.04.03.04c-.01-.01-.02-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.14,
    y: 28.65,
    width: 0,
    height: 0,
    transform: "translate(-9.53 40.34) rotate(-58.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.7,28.19h0s0,.02,0,.02c0-.01-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.82,28.37s-.03-.04-.05-.06c.01.02.03.04.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.67,28.14s-.01-.02-.02-.03c0,.01.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.51 25.61 33.52 25.61 33.51 25.6 33.51 25.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.63,28.04h0s0,.02,0,.02c0-.01,0-.03-.01-.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.52,25.62h0s.02.03.02.03c-.01-.01-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.97,35.14h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.46 25.56 33.46 25.56 33.49 25.58 33.46 25.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.74,28.26h0s.02.02.02.03c-.01-.02-.02-.03-.03-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.59,27.88h0s0,.01,0,.01c0-.02,0-.03-.01-.05,0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.01 29.04 32.99 29.03 33 29.04 33.01 29.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.02,25.25s.04.02.05.03c-.02-.01-.04-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.39 25.5 33.39 25.5 33.41 25.52 33.39 25.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.19,25.35s.03.02.05.03c-.02-.01-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.89,26.27s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.74,26.27s.04,0,.07,0c-.02,0-.04,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.83,26.27s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.1,29.09h.01s-.06-.03-.1-.04c.01,0,.03.01.04.02.01,0,.03.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.53,36.2h0c-.18.03-.37.05-.56.06-.07,0-.14,0-.22.01.07,0,.14,0,.22-.01.19-.01.37-.03.56-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.83,35.04h0s.06.04.09.06c-.03-.02-.06-.04-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.65,25.75h0s.02.03.03.04c-.01-.01-.02-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.61,27.96v.02s0,0,0,0c0-.01,0-.03-.01-.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.93,25.2h.01s0,0,0,0c.02,0,.03.02.05.02-.02-.01-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "33.58 25.68 33.58 25.68 33.58 25.68 33.58 25.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.98,29.03s-.04-.02-.06-.03c.01,0,.02,0,.03.01h.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m33.38,25.49h0s-.03-.02-.05-.03c.01.01.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m34.71,23.37h-.02c-.72-.24-1.5-.34-2.3-.28-3.59.25-6.41,3.48-6.31,7.2,0,.23.02.46.05.68-.02,0-.04-.02-.06-.02.02,0,.04.02.06.02.03.2.06.4.1.6,0,.02,0,.04.01.07.1.43.24.84.41,1.23,1.02.52,2.23.78,3.52.69.07,0,.13-.01.2-.02-.01,0-.02-.02-.03-.03-.01-.01-.03-.02-.04-.03-.01,0-.02-.02-.03-.02-.01-.01-.03-.02-.04-.04h-.01s-.07-.08-.11-.11h-.01s-.03-.04-.05-.06l-.02-.02s-.03-.03-.04-.05l-.02-.02s-.03-.03-.04-.05l-.02-.02s-.03-.04-.04-.05h-.01c-.08-.13-.16-.25-.22-.38h0s-.02-.06-.03-.08h0s-.02-.06-.03-.09h0c-.06-.14-.1-.29-.13-.44h0c-.03-.15-.05-.31-.06-.47l.29-.02.99-.07.16.06c.01.48.28.88.67,1.07h0c.13.04.27.06.42.05s.29-.05.42-.11c.06-.03.11-.05.16-.09.03-.02.07-.05.1-.07.11-.09.21-.19.29-.31.02-.03.04-.07.06-.11.06-.11.1-.23.13-.35.02-.08.03-.17.03-.25,0-.02,0-.04,0-.07,0-.2-.05-.38-.14-.54-.02-.04-.04-.07-.06-.1-.12-.18-.28-.33-.47-.43-.13-.04-.28-.06-.43-.05-.37.03-.72-.03-1.04-.16l-.16-.06h.03s-.02,0-.03,0h0s-.05-.02-.08-.04h0c-.26-.12-.49-.28-.69-.48h-.01c-.07-.09-.14-.17-.21-.25h0s-.06-.08-.08-.12v-.02s-.07-.08-.09-.13h0s-.05-.09-.08-.14v-.02s-.05-.08-.06-.12c0,0,0-.02-.01-.03-.12-.28-.18-.59-.19-.92-.03-1.18.7-2.21,1.72-2.61.03-.01.06-.02.09-.03v-.14s-.02-.63-.02-.63l.32-.02.93-.06.16.06.02.75c.1.03.19.06.29.1h0s.02.01.02.01c-.02,0-.04-.02-.06-.02l.16.06c.88.35,1.51,1.2,1.54,2.25l-1.28.09-.16-.06h0s0-.06,0-.09v-.02s0-.06-.02-.09h0s-.01-.07-.02-.09h0s-.02-.07-.03-.1v-.02c-.03-.06-.05-.11-.08-.16h0s-.03-.06-.05-.09h0s-.03-.05-.05-.08h0s-.04-.05-.06-.07h0c-.04-.05-.09-.09-.13-.13h0c-.07-.06-.14-.1-.22-.14-.13-.04-.28-.06-.42-.05-.67.05-1.21.66-1.19,1.36.01.48.28.88.67,1.07h.03s0,.01,0,.01c.06.02.12.03.18.04h.01s.06,0,.09,0h.02s.06,0,.09,0c.04,0,.08,0,.12,0,.01,0,.03,0,.04,0,.03,0,.05,0,.08,0,.02,0,.03,0,.05,0,.02,0,.05,0,.07,0,.02,0,.03,0,.05,0,.02,0,.05,0,.07,0,.02,0,.03,0,.05,0,.02,0,.04,0,.07.01.02,0,.03,0,.05,0,.02,0,.04,0,.07.01.02,0,.03,0,.05.01.02,0,.04.01.07.02.02,0,.03,0,.05.01.03,0,.05.02.08.03.02,0,.05.02.07.03.02,0,.03.01.05.02h-.03s.16.05.16.05c.88.35,1.51,1.21,1.54,2.26,0,.14,0,.28-.02.41,1.28-1.17,2.06-2.79,2.02-4.52-.02-.82-.22-1.58-.56-2.27h0s-.01-.03-.01-.03c-.02-.05-.05-.1-.08-.14,0-.01-.01-.02-.02-.04,0-.01-.01-.03-.02-.04-.02-.04-.05-.09-.08-.13h0c-.03-.06-.06-.11-.09-.16,0-.01-.02-.03-.03-.04-.03-.05-.07-.1-.1-.15h0c-.04-.06-.07-.11-.11-.15,0-.01-.02-.03-.03-.04-.03-.04-.07-.09-.11-.13v-.02c-.05-.05-.1-.09-.14-.14-.01-.01-.02-.02-.03-.04-.04-.04-.07-.08-.11-.12l-.02-.02s-.04-.04-.06-.06h.01c.06.04.11.07.17.1-.03-.02-.05-.03-.08-.05-.03-.02-.06-.03-.09-.05-.02,0-.03-.02-.05-.02h0s-.03-.01-.03-.01c-.05-.03-.1-.05-.14-.07h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.03,24.23s.02.02.04.03c.04.04.08.07.12.11.01.01.02.02.03.03-.01-.01-.02-.02-.03-.03-.04-.04-.08-.08-.12-.11-.01-.01-.02-.02-.04-.03-.02-.02-.05-.04-.07-.06h0s.05.04.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.74,33.98h0s.03.05.05.07h0s0,.01,0,.01c-.02-.03-.05-.06-.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m33.63,33.2c.07-.08.14-.16.2-.24-.06.08-.13.16-.2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.96,33.71h0c-.06.03-.12.06-.18.09h0c.16-.07.32-.16.46-.26-.09.06-.18.12-.28.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.13,34.43s.02.02.04.04h0s-.03-.03-.05-.05h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "31.01 33.87 31.01 33.87 31.03 33.88 31.01 33.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "32.6 34.29 32.58 33.87 32.6 33.87 32.58 33.87 32.6 34.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.29,34.58l.03.03h0s-.02-.02-.04-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.46,33.6s-.03-.05-.05-.07c.01.02.03.04.04.06l.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.51,33.68s.02.02.02.03c0,0,.01.02.02.03h0s-.04-.04-.05-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.68,33.84h0s.06-.02.09-.04h0s-.06.03-.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.83,35.04s.06.04.09.06c-.03-.02-.06-.04-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.99,34.27h0s.02.03.03.04c-.02-.02-.03-.04-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m25.88,32.58h0s0-.01-.01-.02v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "26.02 32.88 26.02 32.88 26.02 32.88 26.02 32.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.52,35.95h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m25.93,32.7h0s.01.03.02.04h0s-.02-.03-.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.61,34.61v-.14s0,.14,0,.14Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "26.12 33.07 26.13 33.08 26.12 33.06 26.12 33.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.36,33.46v.02s.02.02.02.02h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.61,33.82h0s.02.04.03.05c.01.02.03.03.04.05-.03-.03-.05-.07-.08-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m31.33,33.96h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "31.11 33.9 31.1 33.9 31.13 33.91 31.11 33.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.19 35.29 28.2 35.3 28.2 35.3 28.17 35.28 28.19 35.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m33.56,33.27c-.08.07-.15.14-.24.21.08-.06.16-.13.24-.21Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "29.04 35.76 29.06 35.76 29.05 35.76 29.04 35.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "25.77 32.33 25.76 32.31 25.76 32.31 25.77 32.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.77,34.99s-.06-.05-.09-.07c.02.02.04.03.06.05l.03.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m32.53,36.2h0c.84-.13,1.63-.43,2.34-.86.13-.08.27-.17.39-.26.03-.02.07-.05.1-.07.2-.15.39-.3.58-.47.03-.03.07-.06.1-.09.06-.06.12-.11.18-.17l.02-.02c.12-.12.23-.24.34-.37h0c.17-.21.32-.41.47-.63h0c.1-.15.19-.29.28-.44.01-.02.02-.04.03-.05.19-.34.35-.69.49-1.05.03-.07.05-.15.08-.22,0-.01,0-.03.01-.04.02-.07.05-.15.07-.22h0c.02-.08.04-.16.06-.23v-.03c.03-.08.05-.16.06-.24h0c.02-.09.03-.17.05-.25h0c.04-.26.07-.52.09-.79.01-.21.02-.42.01-.64,0-.12,0-.23-.02-.35-.01-.17-.03-.33-.06-.5h0c-.01-.07-.02-.14-.04-.22,0-.01,0-.03,0-.04-.01-.06-.02-.12-.04-.18,0-.01,0-.03,0-.04-.02-.07-.03-.14-.05-.21h0c-.02-.07-.03-.14-.05-.2,0-.02,0-.03-.01-.05-.02-.06-.03-.11-.05-.17,0-.01,0-.02-.01-.03-.02-.06-.04-.13-.07-.19,0-.01-.01-.03-.02-.04-.02-.05-.04-.1-.06-.15,0-.02-.01-.03-.02-.05-.03-.06-.05-.12-.08-.18h0s0,0,0,0h0s0-.02-.01-.03c-.01-.03-.03-.06-.04-.09-.01-.02-.02-.05-.03-.07,0-.01-.01-.03-.02-.04,0-.02-.01-.03-.02-.05-.01-.02-.03-.05-.04-.07-.01-.02-.03-.05-.04-.07h0s-.01-.04-.02-.05c-.03-.05-.05-.09-.08-.14,0-.02-.02-.03-.03-.05-.03-.06-.07-.11-.1-.17h0s-.04-.06-.06-.09c-.02-.03-.04-.06-.06-.09l-.02-.02-.02-.02h0c-.03-.05-.07-.1-.11-.15h0s-.01-.02-.01-.02l-.02-.02s-.07-.09-.11-.14c-.01-.01-.02-.03-.03-.04l-.02-.02s-.06-.07-.09-.11c0,0-.02-.02-.02-.03v-.02s-.03-.02-.04-.03c-.03-.03-.06-.07-.09-.1-.01-.01-.02-.02-.03-.03h0s-.05-.05-.07-.07c-.02-.02-.03-.03-.05-.05h0s-.02-.02-.03-.03c-.04-.04-.09-.08-.13-.13h-.01s-.02-.03-.03-.04c-.04-.04-.08-.08-.12-.11-.01-.01-.02-.02-.04-.03-.02-.02-.05-.04-.08-.06-.03-.02-.05-.04-.08-.07h0s-.03-.02-.03-.02c-.04-.04-.09-.07-.13-.1-.01-.01-.03-.02-.04-.03-.05-.04-.11-.08-.16-.12l-.02-.02h0s-.1-.07-.15-.1h-.02s-.02-.03-.02-.03c-.06-.04-.11-.07-.17-.11h0c-.06-.04-.11-.07-.17-.1h-.01s.04.03.06.05l.02.02s.07.08.11.12c.01.01.02.02.03.04.04.05.08.09.12.14v.02c.05.04.09.09.12.13.01.01.02.03.03.04.04.05.08.1.11.15h0c.04.05.07.1.1.15,0,.01.02.03.03.04.03.05.06.1.09.15h0c.03.05.05.1.08.14,0,.01.01.03.02.04,0,.01.01.02.02.04.03.05.05.1.08.14v.02s.02,0,.02,0c.35.69.54,1.45.56,2.27.04,1.73-.74,3.35-2.02,4.52-.13,1.03-.84,1.9-1.78,2.23l.02.77-1.25.09-.16-.06h0s-.02-.75-.02-.75c-.09-.02-.17-.05-.25-.08l-.16-.06h0s0,0,0,0c-.02,0-.04-.01-.05-.02-.01,0-.02,0-.03-.01-.02,0-.04-.02-.06-.03h-.03s-.05-.04-.08-.05c-.01,0-.02-.01-.03-.02-.02,0-.03-.02-.05-.03-.01,0-.03-.02-.04-.02-.01,0-.03-.02-.04-.03-.01,0-.03-.02-.04-.03-.01,0-.03-.02-.04-.03-.01,0-.03-.02-.04-.03h0c-.07,0-.13.01-.2.02-1.29.09-2.5-.17-3.52-.69.62,1.38,1.68,2.48,3,3.12.03,0,.05.02.08.02h.02c.07.03.15.05.22.07h0c.08.02.16.04.24.06h0c.08.02.16.03.23.05h.02c.16.03.32.05.48.07h.02c.16.02.33.02.49.03h.02c.08,0,.17,0,.25,0,.07,0,.14,0,.22-.01.19-.01.37-.03.56-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.62,35.55h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.29,33.35h0s0,0,0,0h0s.02.05.03.06c-.01-.02-.03-.04-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m26.7,33.94h0s.02.03.03.04c-.01-.01-.02-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m34.33,31.9c-.02.1-.05.19-.08.28.03-.09.06-.19.08-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m34.23,32.24c-.02.06-.04.11-.07.17.02-.06.05-.11.07-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m34.09,32.56c-.06.11-.12.21-.19.31.07-.1.13-.2.19-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.82,35.65h.02s0,.01,0,.01c-.01,0-.02-.01-.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.48,34.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.99,35.16h.02s-.02,0-.03-.01h.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "31.21 33.93 31.2 33.93 31.23 33.94 31.21 33.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m35.58,22.27l-.8-.32h.02s0,.01,0,.01c.03.01.07.03.1.04.03.01.07.03.1.04.02,0,.04.02.06.03.07.03.15.07.22.1h.01c.07.04.14.08.2.11.02,0,.04.02.06.03.02.01.04.03.07.04.04.02.09.05.13.07h.01c.07.05.14.09.21.13.02.01.04.02.05.03.06.04.12.08.18.12l.03.02c.07.05.13.09.2.14.02.01.03.02.05.04.03.02.05.04.08.06.03.02.05.04.08.06h.01s.02.03.02.03c.06.05.12.1.18.15.01.01.03.03.04.04.05.04.1.09.15.13.01.01.03.02.04.04.06.05.12.11.17.17.01.01.02.02.04.04.04.04.08.08.12.12l.02.02h0s.02.03.04.04c.03.03.05.06.08.08.03.03.06.06.09.1,0,.01.02.02.03.03.04.05.09.11.13.16.01.02.03.03.04.05.05.06.1.13.15.19l.02.02.02.03c.04.05.07.1.11.15.01.02.02.04.04.05.05.07.09.14.14.2h0c.03.05.06.1.08.15.01.02.03.04.04.07.01.02.02.04.03.06.04.07.08.13.11.2v.02c.05.07.09.15.12.22,0,.02.02.04.03.06.03.06.06.13.09.2,0,.01.01.02.02.03.03.08.07.15.1.23,0,.02.02.04.02.06.03.07.05.13.08.2v.02s.02.02.02.02h0c.03.08.06.16.08.24,0,.02.01.04.02.06.02.07.04.13.06.2,0,.02.01.04.02.06.02.08.05.16.07.25,0,.02,0,.03.01.05.02.07.03.14.05.21,0,.02,0,.04.01.06v.03c.02.08.04.15.05.23,0,.01,0,.03,0,.04,0,.02,0,.05.01.07,0,.05.02.1.02.15,0,.02,0,.04,0,.07.01.09.02.17.03.26v.03c.01.08.02.16.02.24,0,.02,0,.05,0,.07,0,.09,0,.18.01.27.09,3.14-1.56,5.98-4.04,7.49h-.02c-.05.04-.11.07-.16.11h0c-.63.36-1.31.64-2.02.81h-.03c-.07.02-.15.04-.22.06h-.02c-.08.02-.16.04-.25.05h0c-.07.01-.15.03-.22.04-.02,0-.04,0-.06,0-.06,0-.12.02-.18.02-.02,0-.04,0-.07,0-.08,0-.16.02-.24.02-.07,0-.14,0-.21.01-.02,0-.05,0-.07,0-.05,0-.09,0-.14,0-.03,0-.05,0-.08,0-.04,0-.08,0-.12,0-.03,0-.06,0-.09,0-.04,0-.08,0-.12,0-.02,0-.03,0-.05,0-.01,0-.03,0-.04,0-.04,0-.08,0-.11,0-.03,0-.06,0-.09,0-.04,0-.07,0-.11,0-.03,0-.06,0-.09,0-.04,0-.07,0-.11-.01-.03,0-.06,0-.09-.01-.02,0-.04,0-.05,0-.02,0-.04,0-.05,0,0,0-.02,0-.03,0-.02,0-.04,0-.06,0-.04,0-.07-.01-.11-.02-.03,0-.06-.01-.09-.02-.04,0-.07-.01-.11-.02-.03,0-.06-.01-.09-.02-.02,0-.04,0-.06-.01-.02,0-.03,0-.05-.01-.03,0-.06-.01-.08-.02h-.02s-.06-.02-.09-.03c-.03,0-.05-.01-.08-.02-.04-.01-.08-.02-.12-.03-.02,0-.05-.01-.07-.02-.05-.01-.09-.03-.14-.04-.02,0-.03,0-.05-.01-.06-.02-.12-.04-.18-.06-.02,0-.03-.01-.05-.02-.02,0-.05-.02-.07-.03-.02,0-.05-.02-.07-.03h0s.8.31.8.31c.99.39,2.09.58,3.23.5,4.29-.3,7.66-4.15,7.54-8.61-.09-3.26-2.04-5.94-4.76-7.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m26.66,32.87c-.17-.39-.31-.8-.41-1.23,0-.02-.01-.04-.01-.07-.04-.2-.08-.4-.1-.6-.02,0-.04-.02-.06-.02.02,0,.04.02.06.02-.03-.22-.05-.45-.05-.68-.11-3.73,2.72-6.95,6.31-7.2.81-.06,1.58.04,2.3.27-.05-.03-.11-.05-.16-.07-.02,0-.03-.01-.05-.02-.05-.02-.11-.05-.16-.07h-.03s0-.01,0-.01c-.03-.01-.07-.03-.1-.04-.02,0-.04-.01-.05-.02-.03-.01-.06-.02-.09-.03h-.01s-.04-.02-.06-.02h-.02s-.09-.04-.13-.05c-.02,0-.04-.01-.06-.02-.03,0-.07-.02-.1-.03-.02,0-.04-.01-.07-.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.02h0s-.06-.01-.09-.02h0s-.05-.01-.07-.02c-.03,0-.06-.01-.09-.02-.02,0-.05,0-.08-.01-.03,0-.06-.01-.09-.02-.03,0-.05,0-.08-.01h-.01s0,0,0,0c-.02,0-.05,0-.07,0-.03,0-.05,0-.08,0-.03,0-.06,0-.09-.01h0s-.05,0-.08,0c-.03,0-.06,0-.09,0-.03,0-.05,0-.08,0-.02,0-.04,0-.05,0-.01,0-.03,0-.04,0-.03,0-.05,0-.08,0-.03,0-.06,0-.1,0h0s-.05,0-.07,0h0s0,0,0,0c-.02,0-.05,0-.07,0h-.02s0,0,0,0c-.02,0-.05,0-.07,0-.04,0-.07,0-.11,0-.02,0-.04,0-.06,0-.03,0-.05,0-.08,0-.02,0-.05,0-.07,0h-.02c-.15.01-.29.03-.44.05-.33.05-.65.12-.96.21h0c-.16.05-.31.1-.46.16h0c-.15.06-.3.12-.44.19h0c-.15.07-.29.14-.43.22h0c-.14.08-.28.16-.41.25h0c-.13.09-.26.18-.39.28h0c-.13.1-.25.2-.37.31-1.42,1.26-2.34,3.1-2.4,5.13,0,.07,0,.13,0,.2h0c0,.08,0,.15,0,.22h0c0,.06,0,.12,0,.17,0,.02,0,.04,0,.05,0,.04,0,.08,0,.12,0,.02,0,.03,0,.05h0s0,.02,0,.02c0,.02,0,.03,0,.05,0,.02,0,.03,0,.05v.02s0,0,0,0c0,.01,0,.02,0,.04h0s0,.04,0,.05c0,.04.01.09.02.13h0s0,.02,0,.03c0,.02,0,.03,0,.05,0,.02,0,.03,0,.05h0s0,0,0,0h0s0,.03,0,.03h0s0,.03,0,.03h0s0,.03,0,.05c0,.02,0,.04.01.06,0,.03.01.06.02.09,0,.02,0,.04.01.07,0,.02,0,.04.01.05,0,.02,0,.04.01.06.02.07.03.14.05.2,0,.01,0,.03.01.04.01.04.02.08.03.12,0,.02.01.04.02.06.01.03.02.07.03.1h0s0,.02,0,.02v.02c.03.06.04.12.06.17h0s0,.03.02.04c.02.06.04.11.06.17h0s0,.02.01.03h0s0,.01,0,.01h0s.03.08.04.12c0,.02.02.04.02.06h0s0,0,0,0c0,.02.02.04.03.06,0,.01,0,.02.01.03,0,.01.01.03.02.04,0,.01.01.02.02.03,0,.01,0,.02.01.03,0,.02.02.03.02.05,0,0,0,.02.01.03,0,.01.01.02.02.03.01.02.02.05.04.07h0s.02.04.03.06c.02.03.03.06.05.09,0,.01.01.02.02.03h0c.04.08.08.16.13.23h0s0,0,0,0h0s.01.03.02.04h0s.03.06.04.08c0,.01.01.02.02.03h0s.01.03.02.04h0s0,.01,0,.01h.01s.01.03.01.03c.02.02.03.05.05.07h0s.02.03.02.05v.02s.02,0,.02,0c.02.02.04.05.05.07h0s.02.03.03.04h0s.01.02.01.02h0s.05.07.08.11v.02s.02,0,.02,0c.01.01.02.03.03.04h0s0,0,0,0c.02.03.05.06.07.09.05.07.11.13.17.19.02.02.03.04.05.05.03.03.06.07.1.1.02.02.03.03.05.05.04.04.07.07.11.11.01.01.02.02.04.04.05.05.1.09.15.14h0c.06.05.11.1.17.15h0s.01,0,.01,0l.03.02h0s.06.05.09.07h0s0,0,0,0l.02.02s.02.02.03.03h0s.06.04.09.06h.02s.03.03.04.04h0s.02.02.03.02c.06.04.11.08.17.12l.03.02c.06.04.13.08.19.12h0c.07.04.14.08.21.12h.02c.06.04.13.07.19.11.01,0,.02.01.03.02.06.03.13.06.2.09h0s0,0,0,0c.14.06.29.12.44.17h.02s.1.04.15.05c-1.32-.64-2.39-1.74-3-3.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m32.33,24.99c.05.01.11.02.16.04l-.02-.75-.16-.06.02.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m32.31,30.2h-.03s-.02-.02-.03-.02h-.03s-.02-.01-.03-.02h-.03s-.02-.01-.03-.01h-.03s-.02,0-.04,0h-.03s-.03,0-.04,0h-.03s-.03,0-.04,0h-.02s-.04,0-.06,0h0s-.08,0-.11,0h-.02s-.02,0-.02,0c-.03,0-.05,0-.08,0-.01,0-.02,0-.03,0h-.01s-.06,0-.1,0h-.02s-.02,0-.03,0c-.02,0-.04,0-.05,0-.01,0-.03,0-.04,0h-.03s-.03,0-.04-.01c-.02,0-.04,0-.06-.01-.02,0-.03,0-.05-.01h-.03s-.03-.01-.05-.02c-.02,0-.04-.01-.05-.02-.02,0-.04-.01-.06-.02h0s-.04-.01-.05-.02c-.02,0-.04-.02-.06-.02h-.03s.16.05.16.05c.32.13.67.19,1.04.16.15-.01.29,0,.43.05-.03-.02-.06-.03-.09-.04-.01,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m30.67,31.6s0,.05.01.07h0s.01.06.02.09v.02s.02.04.02.07h0s.02.06.03.09v.02s.03.04.03.06h0s.02.06.04.08v.02s.03.04.04.05h0s.03.06.05.08h0s.03.04.04.06h.01s.04.05.05.07h0s.03.04.05.05h.02s.04.04.06.06h0s.04.03.06.04h.02s.04.03.07.05h0s.05.02.07.03c.03.01.06.02.09.03-.39-.19-.66-.59-.67-1.07l-.16-.06s0,.06,0,.08v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m31.33,33.96s-.06-.01-.09-.02h0s-.02,0-.02,0c-.02,0-.04-.01-.06-.02h-.02s-.02-.01-.02-.01c-.02,0-.03-.01-.05-.02h-.02s-.02-.02-.02-.02c-.02,0-.03-.01-.05-.02-.01,0-.02,0-.03-.01h0s.16.06.16.06c.08.03.17.06.25.08v-.03s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m32.91,25.19h.02s.04.03.06.04c.01,0,.02.01.03.02.02,0,.04.02.05.03.01,0,.02.01.03.02.02.01.03.02.05.03.01,0,.02.01.03.02.02.01.03.02.05.03l.03.02s.03.03.05.04l.03.02s.03.02.05.04h0s.02.02.02.02h0s.03.03.04.04h0s.03.03.03.03l.02.02h.01s0,.02,0,.02c.01.01.02.02.03.03l.02.03h0s0,0,0,0c.01.01.02.02.03.04l.02.03h0s.02.03.04.05c0,0,.02.02.02.03.01.02.03.03.04.05,0,0,.01.02.02.03.01.02.03.04.04.05h0s.01.02.01.02c.01.02.02.03.03.05v.02s.02.02.02.02h0s.01.03.02.04v.02s.02.02.02.02c0,0,.01.02.02.03h0s.01.03.01.03c0,0,.01.02.02.03,0,.01.01.02.02.03v.02s.02.02.03.03c0,.01.01.02.02.03v.02s.02.03.03.04c0,.01,0,.02.01.03h0s.01.05.02.06c0,0,0,.02.01.03h0s.01.04.02.06c0,0,0,.02,0,.03h0s.01.04.02.06c0,.01,0,.02,0,.03h0s0,.04,0,.04v.02s.01.02.01.03v.02s.01.02.01.04h0s0,.03,0,.04v.03s.01.03.01.04c0,.01,0,.02,0,.03,0,.01,0,.02,0,.03,0,.01,0,.03,0,.04v.02s0,.03,0,.04c0,.01,0,.03,0,.04v.02s0,.04,0,.06c0,.01,0,.02,0,.03h0s0,.07,0,.11l-1.28.09.16.06,1.28-.09c-.03-1.05-.66-1.91-1.54-2.25l-.16-.06s.04.02.06.02h.02s.06.03.09.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.05,33.24s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.11,33.3s-.03-.03-.05-.05c.02.02.03.03.05.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.98,33.17s-.03-.03-.04-.05c.01.02.03.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.23,33.41s-.07-.06-.11-.1c.03.03.07.07.11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.35,33.52s-.03-.02-.04-.03c.01.01.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.93,33.1s-.03-.04-.04-.05c.01.02.03.04.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.28,33.46s-.03-.02-.04-.04c.01.01.03.02.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.34,32.57c.06-.03.11-.05.16-.09-.05.03-.1.06-.16.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.5,32.49s.07-.05.1-.07c-.03.03-.06.05-.1.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.97,30.78s-.04-.07-.06-.1c.02.03.04.07.06.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.97,26.21s.02.03.02.05c0-.01-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.57,32.49c-.06-.14-.1-.28-.13-.44.03.15.08.3.13.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.65,32.66s-.02-.05-.03-.07c.01.02.02.05.03.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.61,32.57s-.02-.05-.03-.08c.01.03.02.05.03.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.87,33.03c-.08-.11-.16-.23-.22-.36.06.13.14.25.22.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.38,31.59c0,.16.02.32.06.47l.23-.49-.29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.03,30.05s-.04-.01-.06-.02c.02,0,.04.01.06.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.39,32.59s.07.03.11.04h0s-.06-.02-.09-.03h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.79,29.97s-.05-.02-.08-.03c.02.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.95,30.03c-.05-.02-.1-.03-.15-.05.01,0,.02,0,.03.01.02,0,.04.02.06.02.02,0,.03.01.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.1,26.48s0,.02.01.04c0,0,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.01,26.29s.01.03.02.05c0-.01-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.22,26.91s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.06,26.39s.01.03.02.04c0-.01,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.24,27.01s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "34.28 27.37 34.28 27.37 33 27.46 33 27.46 33 27.46 34.28 27.37 34.28 27.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.26,27.11s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.82,25.15h-.02s-.02-.02-.02-.02c.03.01.05.02.08.03-.01,0-.02-.01-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.95,29.01s-.02,0-.03-.01h-.02s.04,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.59,25.69s.03.03.05.05l-.02-.03-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.99,27.34v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.95,29.85s-.01-.02-.02-.03l-.02-.03-.02-.02s.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.15,29.12h-.02s-.03-.03-.03-.03h-.01s.04.01.06.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "30.56 27.71 30.56 27.73 30.56 27.71 30.56 27.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.33,26.38h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.44,26.33h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.27,26.4h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.38,26.35h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.05,29.06s-.03-.01-.04-.02h0s-.01,0-.01,0c.02,0,.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.61,27.97v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.31,30.66s0-.03-.01-.05v-.02s-.03-.07-.04-.11v-.02s-.03-.06-.04-.08c0-.01,0-.02-.01-.03-.01-.03-.02-.06-.04-.09v-.02s-.04-.07-.05-.1v-.03s-.04-.05-.05-.07c0,0-.01-.02-.02-.03-.02-.03-.04-.06-.06-.09h0s-.02-.04-.04-.05c.16.24.28.51.36.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.22,26.43h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.64,28.05h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.69,26.99v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.14,28.65h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.67,27.05v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.71,28.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.17,26.46h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.72,26.94v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.88,29.76s-.02-.02-.02-.03l-.02-.02-.02-.02s.04.05.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.75,26.89l.02-.03-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.81,29.68s-.03-.03-.04-.05h-.01s0-.02,0-.02c.02.02.04.05.06.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.34,29.24h-.01s-.01-.02-.01-.02c-.01,0-.02-.01-.03-.02.02.01.04.03.06.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.44,29.31h0s-.03-.02-.03-.02c-.01,0-.02-.02-.03-.02.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.75,29.6s-.03-.04-.05-.05l-.02-.02s-.04-.04-.06-.06l-.02-.02s-.05-.05-.08-.07l-.02-.02s-.03-.02-.04-.04c.11.08.2.18.29.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.78,26.84l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.07,26.53h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.02,26.57l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.82,26.79l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.12,26.49h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.98,26.61l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.94,26.65l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.86,26.74l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.9,26.69l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.64,28.9s.03,0,.05.01c-.01,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.68,26.65h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.74,26.73h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.55,26.52h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.8,26.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.62,27.16s0-.02.01-.03c0,.01,0,.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.6,27.22s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.59,27.28s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.41,28.77h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.85,26.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.93,27.07v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.7,29.07s-.05-.08-.08-.13c.03.04.05.09.08.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.8,29.21s-.06-.08-.08-.12c.03.04.05.08.08.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.53,28.79s-.04-.08-.06-.12c.02.04.04.08.06.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.62,28.94s-.05-.09-.08-.14c.02.05.05.09.08.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.96,27.16h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.57,27.35s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.98,27.26h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.05,28.81s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.76,28.94s.05.02.07.03c-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.52,28.87s.03,0,.05.01c-.02,0-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.64,27.11v-.03s0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.25,29.18h-.02s-.02-.03-.02-.03h-.01s.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.55,27.54s0-.03,0-.04c0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.57,27.81v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.01,29.45c-.07-.07-.14-.15-.21-.23.06.08.13.16.21.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.55,27.62s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.56,27.47s0-.03,0-.04c0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.6,28.81h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.7,28.81h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.56,27.41s0-.02,0-.04c0,.01,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.93,28.81s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.17,28.81s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.29,28.83s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.41,28.84s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.59,27.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.68,33.84s.06-.02.08-.03c-.03.01-.06.02-.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.67,33.72s-.02-.01-.03-.02c.01,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.58,33.67s-.03-.02-.04-.02c.01,0,.03.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.87,33.82s-.02,0-.03-.01c.01,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.43,33.57s-.03-.02-.04-.03c.01,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.51,33.62s-.03-.02-.04-.03c.01,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.78,33.8c.06-.03.12-.06.18-.09-.06.03-.12.06-.18.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.78,33.78h-.03s.03,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.32,28.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.37,30.13s-.03,0-.05,0h0s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.12,30.08s-.04-.01-.06-.02h.01s.03.01.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.26,30.11s-.05,0-.08-.01h.02s.04.01.06.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.62,30.14s-.02,0-.03,0h0s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.48,30.14s-.02,0-.04,0h.01s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.73,30.15s-.02,0-.03,0h.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.72,31.85s-.01-.04-.02-.07v-.02s0-.02,0-.02c0,.04.02.08.03.12h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.75,31.94s-.02-.05-.03-.07c.01.04.03.08.04.11v-.03s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.11,32.42h-.02s.06.03.09.06c-.02-.01-.04-.03-.06-.04h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.25,32.52s-.04-.02-.06-.04h0s0,0,0,0c.03.02.07.04.1.06h-.02s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.05,32.37s-.04-.04-.05-.05h-.01s-.02-.03-.02-.03c.04.04.08.09.13.12-.01,0-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.88,32.17s-.02-.04-.03-.05v-.02s-.03-.04-.05-.07h0s-.01-.04-.02-.05c.03.07.07.14.12.21h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.14,33.91s-.02,0-.04-.01h.02s.02.01.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.05,33.89s-.02,0-.04-.01h.01s.02.01.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.24,33.94s-.02,0-.03,0h.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.92,33.84h0s.02.01.03.01c-.01,0-.02,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.32,25.44s-.03-.03-.05-.04l-.03-.02s-.03-.02-.05-.03c-.01,0-.02-.01-.03-.02-.02-.01-.03-.02-.05-.03-.01,0-.02-.01-.03-.02-.02-.01-.04-.02-.05-.03-.01,0-.02-.01-.03-.02-.02,0-.03-.02-.05-.02.16.08.3.18.43.29-.01-.01-.03-.02-.04-.03l-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.18,26.71h0s0,.02.01.03h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.41,25.52h-.02s.04.02.06.03c-.01,0-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.88,26.05h0s.02.02.03.03v-.02s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.49,25.58l-.02-.02s.03.03.05.05h0s-.02-.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.75,25.87s-.02-.03-.04-.05c0,0-.02-.02-.02-.03-.01-.01-.02-.02-.03-.04.05.06.1.12.15.19-.01-.02-.02-.03-.04-.05,0,0-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.91,25.19s-.03-.01-.04-.02c.03.01.05.02.07.04h-.01s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.2,26.81h0s0,.02,0,.04h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.27,27.23h0s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.55,25.65l-.02-.02s.03.03.05.05h0s-.02-.03-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m34.15,26.61s0,.02.01.04c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.81,25.96s.02.03.03.05c0-.01-.02-.02-.02-.04h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.93,26.14h0s.02.02.03.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "32.61 34.61 32.6 34.47 32.52 34.65 31.35 34.73 31.35 34.73 32.61 34.64 32.61 34.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.25,33.29c-.04-.07-.08-.14-.13-.22h0s-.01-.03-.01-.03h0s0-.02,0-.02c-.02-.03-.03-.06-.05-.09v-.02s-.01,0-.01,0c0-.01-.01-.02-.02-.04h0s-.02-.05-.04-.07h0s0-.03,0-.03c0-.01-.01-.03-.02-.04,0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.04,0-.01-.01-.02-.02-.04h0s-.01-.03-.02-.04h0s-.01-.04-.02-.05c0-.02-.02-.04-.02-.05,0-.02-.02-.04-.02-.06v-.02s-.05-.09-.07-.14h0c-.02-.06-.04-.11-.06-.17,0-.01-.01-.03-.02-.04h0c-.02-.06-.04-.11-.06-.17v-.02s-.01-.02-.01-.02c-.01-.03-.02-.07-.03-.1,0-.02-.01-.04-.02-.06-.01-.04-.02-.08-.03-.12,0-.01,0-.03-.01-.04-.02-.07-.03-.14-.05-.2,0-.02,0-.04-.01-.06,0-.02,0-.04-.01-.05,0-.02,0-.04-.01-.07,0-.03-.01-.06-.02-.09,0-.02,0-.04-.01-.06,0-.02,0-.03,0-.05v-.02s0,0,0,0v-.03s0,0,0,0h0s0-.04,0-.06c0-.02,0-.03,0-.05,0,0,0-.02,0-.03h0s-.01-.09-.02-.13c0-.01,0-.03,0-.04h0s0-.04,0-.05v-.02s0-.03,0-.05c0-.02,0-.03,0-.05v-.02s0-.03,0-.05c0-.04,0-.08,0-.12,0-.02,0-.04,0-.05,0-.06,0-.12,0-.17h0c0-.07,0-.14,0-.2h0c0-.08,0-.14,0-.21h0s-1.04,2.22-1.04,2.22h0c.01.05.03.11.04.16,0,.03.01.05.02.08.01.05.03.1.04.16,0,.02,0,.03.01.05.03.1.06.2.1.3,0,.02.02.04.02.07.02.05.04.1.06.15,0,.02.02.04.03.07.04.11.09.21.13.32h0c.02.06.04.11.07.16.01.02.02.04.03.07.02.05.05.1.07.14v.03c.06.1.11.19.17.29.01.02.02.04.03.06.03.05.05.09.08.14.01.02.02.04.03.06.06.09.12.19.18.28v.02s.07.09.1.13c.01.02.03.04.04.06.03.04.06.09.1.13h0s.64-1.37.64-1.37h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.29,22.05c-.68.23-1.33.54-1.92.92l-.68,1.46h0c.12-.11.24-.21.37-.31h0c.13-.1.26-.19.39-.28h0c.13-.09.27-.17.41-.25h0c.14-.08.28-.15.43-.22h0c.15-.07.29-.13.44-.19h0c.15-.06.3-.11.46-.16h0c.31-.09.63-.16.96-.21h0s.64-1.37.64-1.37c-.08,0-.16,0-.24.01-.07,0-.13,0-.19.02-.02,0-.04,0-.06,0-.04,0-.09,0-.13.01-.03,0-.05,0-.08.01-.04,0-.08.01-.12.02-.03,0-.05,0-.08.01-.04,0-.07.01-.11.02-.03,0-.06.01-.08.02-.04,0-.07.01-.11.02-.03,0-.06.01-.08.02-.03,0-.07.01-.1.02-.03,0-.06.01-.08.02-.03,0-.07.02-.1.02-.03,0-.06.01-.08.02-.03,0-.07.02-.1.03-.03,0-.06.02-.08.02-.03,0-.07.02-.1.03-.03,0-.06.02-.08.03-.03.01-.07.02-.1.03-.03,0-.05.02-.08.03-.03.01-.07.02-.1.03-.03,0-.05.02-.08.03-.03.01-.07.03-.1.04-.03,0-.05.02-.08.03-.03.01-.07.03-.1.04-.02,0-.05.02-.07.03-.04.02-.07.03-.11.05-.02,0-.04.02-.06.03-.05.02-.1.05-.15.07h-.02s0,0,0,0l-.19.41c.56-.28,1.15-.47,1.76-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.64,34.89h0c-.06-.05-.11-.09-.17-.14h0c-.05-.05-.1-.09-.15-.14h0s0,0,0,0l-.03-.03h0s0,0,0,0c-.04-.04-.07-.07-.11-.11h0s0,0,0,0c-.01-.01-.02-.02-.04-.04h0s-.01-.01-.01-.01c-.03-.03-.06-.07-.1-.1-.01-.01-.02-.02-.03-.04h0s0-.02,0-.02c-.06-.06-.11-.13-.17-.19h0s-.6,1.29-.6,1.29c.07.07.14.14.2.2h0c.07.07.14.13.21.19h0c.07.07.14.13.21.19h0c.07.07.15.13.23.18l.57-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.09,22.75h0s0,0,0,0h.01s.04,0,.06,0h0s.06,0,.1,0h0s.02,0,.04,0c.01,0,.02,0,.04,0h0s.03,0,.04,0c.02,0,.04,0,.06,0,.03,0,.05,0,.08,0h0s.06,0,.09,0h0s.05,0,.08,0c.03,0,.06,0,.09.01.03,0,.05,0,.07,0,.03,0,.05,0,.08.01h.01s0,0,0,0c.02,0,.05,0,.07.01.03,0,.06.01.09.02.02,0,.05,0,.07.01.03,0,.05,0,.08.02l.57-1.23h0c-.08-.02-.17-.04-.25-.06-.02,0-.04,0-.05-.01-.08-.02-.17-.03-.25-.05h0c-.19-.03-.38-.06-.58-.07h0s-.6,1.29-.6,1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m38.27,29.7h0c-.02.26-.05.52-.09.78h0s0,0,0,0h0c-.01.08-.03.16-.05.25h0s0,0,0,0h0c-.02.08-.04.16-.05.24v.03c-.03.08-.05.15-.07.23h0s0,0,0,0h0c-.02.08-.04.15-.07.22h0s0,.03-.01.04c-.02.07-.05.15-.08.22l1.64-3.51s0-.07-.01-.11c0-.02,0-.04,0-.07,0-.05-.02-.1-.02-.15,0-.02,0-.05-.01-.07,0-.01,0-.03,0-.04-.01-.08-.03-.15-.04-.23v-.03s-.01-.04-.02-.06c0-.02,0-.04-.01-.06l-1.08,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m37.33,32.83h0c-.09.15-.18.3-.28.44h0s0,0,0,0h0c-.14.21-.3.42-.47.61h0s0,.01,0,.01h0c-.11.13-.22.25-.34.37l-.02.02h0c-.06.06-.12.12-.18.17l-1.08,2.31c.12-.06.24-.13.36-.19h0c.05-.03.11-.07.16-.1h.02c.06-.05.11-.08.17-.12l1.65-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.37,24.26c.26-.28.54-.55.83-.79l.02-.02.22-.47h0c-.15.11-.3.23-.45.36h0c-.14.12-.29.25-.42.39h0s-.3.64-.3.64c.03-.04.06-.08.1-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.9,24.15c-.1.1-.2.21-.3.32-.37.41-.7.85-.99,1.32l-.88,1.88c-.08.23-.15.46-.21.69.01-.11.02-.21.04-.32l-.52,1.11h0c0,.07-.01.15-.01.22h0c0,.08,0,.14,0,.22v.02c0,.06,0,.13,0,.19,0,.01,0,.03,0,.04,0,.07,0,.15,0,.22h0c0,.08,0,.15.01.23h0s2.87-6.14,2.87-6.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m28.85,37.11s.05.02.07.03c.02,0,.03.01.05.02.06.02.12.04.18.06.02,0,.03,0,.05.01.05.02.09.03.14.04.02,0,.05.01.07.02.04.01.08.02.12.03.03,0,.05.01.08.02.03,0,.06.02.09.02h.02s.06.02.08.03c.02,0,.03,0,.05.01.02,0,.04,0,.06.01.03,0,.06.01.09.02.04,0,.07.01.11.02.03,0,.06.01.09.02.04,0,.07.01.11.02.02,0,.04,0,.06,0,0,0,.02,0,.03,0,.02,0,.04,0,.05,0,.02,0,.04,0,.05,0,.03,0,.06,0,.09.01.04,0,.07,0,.11.01.03,0,.06,0,.09,0,.04,0,.07,0,.11,0,.03,0,.06,0,.09,0,.04,0,.08,0,.11,0,.01,0,.03,0,.04,0l.61-1.31c-.08,0-.17,0-.25,0h0s-.02,0-.02,0h0c-.17,0-.33,0-.49-.02h0s-.02,0-.02,0c-.16-.01-.32-.04-.48-.06h0s-.02,0-.02,0h0c-.08-.01-.16-.03-.23-.05h0s0,0,0,0h0c-.08-.02-.16-.04-.24-.06h0s0,0,0,0h0c-.07-.02-.15-.04-.22-.06h0s-.02,0-.02,0c-.03,0-.05-.02-.08-.02-.05-.02-.1-.03-.15-.05h-.02c-.15-.06-.3-.12-.44-.18h-.02c-.07-.04-.13-.07-.2-.1h0s0,0,0,0h-.02s0-.01,0-.01h0c-.06-.03-.13-.07-.19-.1h-.02c-.07-.05-.14-.09-.21-.13h0c-.06-.04-.13-.08-.19-.12h0s0,0,0,0h0s0,0,0,0h-.01c-.06-.05-.11-.09-.17-.12h-.02s-.57,1.2-.57,1.2c.15.1.31.2.47.29.02.01.04.02.07.04.04.02.08.05.13.07.06.03.12.06.18.09.03.01.05.03.08.04.05.02.1.05.15.07.02.01.05.02.07.03.07.03.15.06.22.09h0s.04.02.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m33.69,22.98s.06.02.09.03c.02,0,.04.01.05.02.05.01.1.03.14.05h.01s0,0,0,0c.02,0,.04.01.06.02.03.01.06.02.1.03.02,0,.03.01.05.02h0s.07.03.1.04h0s.01,0,.01,0h.01s0,0,0,0c.06.02.11.05.16.07h0s.03.01.05.02h0c.05.02.11.05.16.07h.02s0,.01,0,.01h0s0,0,0,0c.05.02.1.05.14.07h.03s.03.03.05.04h0s.06.03.09.05c.03.02.06.03.08.05h0c.06.04.12.07.17.11.01,0,.02.01.03.02h.01s0,0,0,0h0s.1.06.15.1h0s.02.02.02.02c.06.04.11.08.16.12.01,0,.03.02.04.03.05.03.09.07.14.1l.03.02s.06.05.08.07c.02.02.05.04.07.06h0s.02.02.04.03c.04.04.08.07.13.11.01,0,.02.02.03.03h.01c.04.05.09.1.13.14h0s.02.02.03.03c.02.02.03.03.05.05.02.02.05.05.07.07h0s.01.02.01.02l.02.02s.06.07.09.1c.01.02.03.03.04.05l.02.03s.06.07.09.11l.02.02h0s.02.03.03.04c.03.04.06.08.09.11l.61-1.31s-.05-.06-.08-.08c-.01-.01-.02-.03-.04-.04h0s-.02-.03-.02-.03c-.04-.04-.08-.08-.12-.12-.01-.01-.02-.02-.04-.04-.06-.06-.11-.11-.17-.17-.01-.01-.03-.02-.04-.04-.05-.05-.1-.09-.15-.13-.01-.01-.03-.03-.04-.04-.06-.05-.12-.1-.18-.15l-.02-.02h-.01s-.05-.05-.08-.07c-.03-.02-.05-.04-.08-.06-.02-.01-.03-.02-.05-.04-.06-.05-.13-.09-.2-.14l-.03-.02c-.06-.04-.12-.08-.18-.12-.02-.01-.04-.02-.05-.03-.07-.04-.14-.08-.21-.13h-.01s-.09-.06-.13-.08c-.02-.01-.04-.03-.07-.04-.02-.01-.04-.02-.06-.03-.07-.04-.14-.07-.2-.1h-.01c-.07-.04-.15-.08-.22-.11-.02,0-.04-.02-.06-.03-.03-.01-.07-.03-.1-.04-.03-.01-.07-.03-.1-.04h0s0,0,0,0c-.08-.03-.17-.06-.25-.09-.02,0-.04-.01-.05-.02-.08-.03-.17-.06-.25-.08l-.57,1.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m37.38,25.85h0c.03.06.06.12.09.17h0s.03.06.04.09c0,0,0,.02.01.03,0,.02.02.03.02.05,0,.02.02.03.02.05,0,.01.01.03.02.04.01.02.02.05.03.07v.02s.03.05.04.07v.03s.01,0,.01,0h0s0,0,0,0h0c.03.07.05.13.08.19,0,.02.01.03.02.05.02.05.04.1.06.15,0,.01.01.03.02.04.02.06.05.13.07.19,0,.01,0,.02.01.03.02.06.04.11.05.17,0,.02,0,.03.01.05.02.06.04.13.05.19h0c.02.08.03.15.05.22,0,.01,0,.03,0,.04.01.06.02.12.04.18,0,.01,0,.03,0,.04.01.07.03.14.04.22h0s.85-1.82.85-1.82h0s0-.03,0-.03v-.02c-.03-.07-.06-.13-.09-.2,0-.02-.02-.04-.02-.06-.03-.08-.06-.15-.1-.23,0-.01-.01-.02-.02-.03-.03-.07-.06-.13-.09-.2,0-.02-.02-.04-.03-.06-.04-.07-.07-.15-.11-.22v-.02c-.05-.07-.08-.13-.12-.2-.01-.02-.02-.04-.03-.06-.01-.02-.03-.04-.04-.07-.03-.05-.06-.09-.08-.14h0c-.04-.08-.09-.14-.14-.21-.01-.02-.02-.04-.04-.05-.04-.05-.07-.1-.11-.15l-.65,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m34.87,35.35h0c-.71.43-1.5.72-2.34.86l-.65,1.39s.09,0,.13,0c.08,0,.16-.01.24-.02.02,0,.04,0,.07,0,.06,0,.12-.01.18-.02.02,0,.04,0,.06,0,.07-.01.15-.02.22-.03h0c.08-.02.16-.03.25-.05h.02c.08-.02.15-.04.22-.05h.03c.24-.07.48-.14.72-.22l.85-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m28.53,22.62c-.13.06-.25.13-.38.2-.33.18-.63.4-.93.63l-.02.02c-.3.24-.57.51-.83.79-.03.04-.07.07-.1.11-.47.54-.86,1.15-1.16,1.8-.27.6-.46,1.23-.56,1.87-.02.11-.03.21-.04.32.06-.23.14-.47.21-.69.17-.48.36-.94.6-1.39.09-.17.18-.33.28-.49.29-.47.62-.91.99-1.32.1-.11.2-.21.3-.32.16-.16.32-.31.49-.46.28-.24.58-.46.89-.67.03-.02.06-.04.09-.06.6-.38,1.24-.69,1.92-.92-.61.1-1.2.3-1.76.57Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 31.42,
    cy: 29.31,
    r: 5.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m35.53,27.41c0,.09-.16.17-.36.19l-3.2.22c-.2.01-.45.04-.55.05-.1.01-.27-.07-.18-.25l.81-1.65c.09-.18.31-.26.5-.17l2.63,1.29c.18.09.34.24.35.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m31.57,25.32c.08.04.07.22-.02.41l-1.41,2.88c-.09.18-.16.33-.16.33,0,0-.03.07-.07.16-.04.09-.19.2-.31.03l-1.03-1.52c-.11-.17-.07-.4.1-.52l2.43-1.64c.17-.11.37-.18.46-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m27.78,27.7c.07-.05.23.05.34.22l1.79,2.66c.11.17.21.31.21.31,0,0,.05.06.11.14.06.08.08.27-.13.28l-1.84.13c-.2.01-.38-.14-.4-.35l-.2-2.92c-.01-.2.04-.41.11-.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m27.95,32.18c0-.09.16-.17.36-.19l3.2-.22c.2-.01.37-.03.37-.03h.18c.19-.07.26.04.17.23l-.81,1.65c-.09.18-.31.26-.5.17l-2.63-1.29c-.18-.09-.34-.24-.35-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m31.91,34.27c-.08-.04-.07-.22.02-.41l1.41-2.88c.09-.18.16-.33.16-.33,0,0,.03-.07.07-.16.04-.09.19-.2.31-.03l1.03,1.52c.11.17.07.4-.1.52l-2.43,1.64c-.17.11-.37.18-.46.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m35.7,31.88c-.07.05-.23-.05-.34-.22l-1.79-2.66c-.11-.17-.21-.31-.21-.31,0,0-.05-.06-.11-.14-.06-.08-.08-.27.13-.28l1.84-.13c.2-.01.38.14.4.35l.2,2.92c.01.2-.04.41-.11.46Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m31.65,28.5c-.77.05-1.35.72-1.29,1.49s.72,1.35,1.49,1.29h0c.22-.02.42-.08.6-.18-.31-.02-.57-.27-.59-.59-.02-.35.24-.65.59-.67.3-.02.56.17.65.45.05-.16.07-.32.05-.49-.05-.77-.72-1.35-1.49-1.29Zm-.43,1.36c-.17.01-.31-.12-.33-.28s.12-.31.28-.33.31.12.33.28-.12.31-.28.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 31.21,
    cy: 29.55,
    r: 0.36
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.33,13.58h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.14,13.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.76,20.76h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.77,16.91l.11-1.31c-.02.12-.04.23-.06.35-.04.32-.06.64-.05.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.56,18.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20,12.95h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.92,20.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.53,13.35h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.76,13.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.52,20.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.98,20.76h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.67,20.72h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.61,20.77h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.84,20.47h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.58,19.63s-.01-.01-.02-.02c0,0,.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.71,19.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.65,19.69h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.72,20.42s-.02,0-.03-.01c0,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.78,19.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.97,14.07h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.08,18.3h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "25.22 13.34 25.22 13.34 25.22 13.34 25.22 13.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.34,17.52h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.2,17.99h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "24.14 12.55 24.13 12.55 24.13 12.55 24.13 12.55 24.14 12.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "23.32 12.25 23.34 12.25 23.32 12.25 23.32 12.25 23.32 12.25 23.32 12.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.03,12.5h0s.03.01.04.02c-.01,0-.03-.01-.04-.02,0,0-.02,0-.02-.01,0,0,.02,0,.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.47,16.25s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.2,12.22s-.02,0-.02,0c-.04,0-.08-.02-.13-.02.04,0,.08.02.13.02,0,0,.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.74,12.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.49,12.3s.07.02.1.03h.02s0,0,0,0h0s.04.01.06.02h0s-.04-.01-.07-.02h-.02s-.07-.03-.1-.04c-.01,0-.02,0-.03,0-.04-.01-.08-.02-.12-.03.04.01.08.02.12.03.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.83,14.12s0,.01.01.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.58,13.76s.01.02.02.03c0,0-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.67,13.89h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.4,13.53s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.5,13.66s0,.01.01.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.75,14.01s0,.01.01.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.31,13.43s.02.02.02.03c0,0-.02-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.46,16.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.42,15.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.44,15.93v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.39,15.61h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.03,13.16s-.03-.02-.04-.03h0s0,0,0,0c.01.01.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.82,18.34s-.03-.08-.04-.11c.01.04.03.08.04.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.29,12.46s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.88,18.49s-.03-.09-.05-.13c.02.04.03.09.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.77,18.21s-.03-.08-.04-.13c.01.04.03.08.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.45,19.55s-.04-.06-.06-.09c.02.03.04.06.06.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.54,19.67s-.04-.06-.06-.08c.02.03.04.06.06.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.73,18.08s-.03-.09-.04-.14c.01.05.03.09.04.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.02,12.7s.02-.02.03-.03c-.01,0-.02.02-.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.11,12.62s.02-.02.04-.03c-.01.01-.02.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.2,12.54s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.94,12.79h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.17,13.84c.06-.11.12-.21.19-.31-.07.1-.13.2-.19.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.08,20.71h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.68,19.86c-.04-.05-.08-.1-.12-.16.04.05.08.11.12.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.85,21.37c-.06-.02-.11-.04-.17-.06.06.02.11.04.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.77,21.58s-.06,0-.09-.01c.03,0,.06,0,.09.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.68,21.3c-.06-.02-.11-.04-.17-.07.06.02.11.05.17.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.78,19.97s-.04-.05-.07-.08c.02.03.04.05.07.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.11,21.61s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.96,21.6s-.04,0-.06,0c.02,0,.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.84,20.88s-.06-.04-.09-.06c.03.02.06.04.09.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.14,20.34s-.05-.05-.07-.07c.02.02.05.05.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.62,20.73c-.06-.04-.11-.08-.17-.13.06.04.11.09.17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.96,20.16c-.05-.05-.1-.1-.15-.16.05.05.1.11.15.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.04,20.24s-.05-.05-.07-.07c.02.02.05.05.07.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.42,20.58s-.05-.04-.08-.06c.03.02.05.04.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.31,20.49c-.05-.04-.1-.09-.15-.14.05.05.1.09.15.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18,14.16c.05-.11.11-.22.17-.32-.06.11-.11.21-.17.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.87,20.89s-.09.06-.14.08c.05-.03.09-.05.14-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.73,20.98s-.08.05-.13.07c.04-.02.08-.05.13-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.51,21.62s.02,0,.03,0c.03,0,.06,0,.09,0-.03,0-.06,0-.09,0-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.34,11.29c.06,0,.11,0,.17,0-.06,0-.11,0-.17,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25,20.81s-.08.05-.12.08c.04-.03.08-.05.12-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.12,19.77s-.05.06-.07.09c.03-.03.05-.06.07-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.57,21.07s-.07.04-.1.05c.03-.02.07-.03.1-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.71,20.54h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.76,21.6s.03,0,.05,0c.02,0,.04,0,.06,0-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.39,20.64h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.63,21.44s-.05.01-.07.02c-.02,0-.04,0-.06.01.02,0,.04,0,.06-.01.02,0,.05-.01.07-.02.02,0,.04-.01.05-.02.02,0,.05-.01.07-.02-.02,0-.05.01-.07.02-.02,0-.04.01-.05.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.29,21.53s.01,0,.02,0c.01,0,.02,0,.03,0-.01,0-.02,0-.03,0,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.01,21.58s-.03,0-.04,0c.01,0,.03,0,.04,0,.02,0,.04,0,.05,0,.02,0,.05,0,.07-.01-.02,0-.05,0-.07.01-.02,0-.04,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.46,11.71h0s.09-.04.14-.06c-.05.02-.09.04-.14.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.67,12.16s.03-.02.05-.03c-.02.01-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.77,12.1s.03-.02.05-.03c-.02.01-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.7,11.34c.05,0,.11-.02.16-.02-.05,0-.11.01-.16.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.87,12.03s.03-.02.05-.03c-.02,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.47,12.31s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.57,12.23s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.97,11.96s.03-.02.05-.03c-.02,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.14,11.46c.12-.03.24-.06.36-.09-.12.02-.24.05-.36.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.38,12.38s.03-.02.04-.03c-.01.01-.03.02-.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.5,11.38c.05-.01.11-.02.16-.03-.05,0-.11.02-.16.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.19,11.84s.03-.02.04-.02c-.01,0-.03.02-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.31,11.78s.02-.01.04-.02c-.01,0-.02.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.08,11.9s.03-.02.05-.03c-.02,0-.03.02-.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.72,20.8s-.06-.04-.08-.06c.03.02.06.04.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.41,12.7s.06.04.09.06h.02s0,0,0,0h.01s0,0,0,0h0s.06.04.1.06h0s0,0,0,0c0,0,.02.01.03.02h0s.04.03.05.04c.02.01.04.03.05.04h0s.07.05.1.08h0s.02.01.02.02l.08-.97h-.02s-.02-.02-.02-.02c-.04-.03-.09-.05-.13-.08-.01,0-.02-.01-.03-.02-.04-.02-.08-.04-.11-.07,0,0-.02,0-.02-.01-.02-.01-.05-.03-.07-.04l-.08.92s-.05-.03-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.82,18.6h0s0,.01,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "19.21 19.21 19.22 19.22 19.21 19.21 19.21 19.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.38,12.38s-.02-.02-.03-.03c-.01-.01-.03-.02-.04-.03.01.01.03.02.04.03.01,0,.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m25.99,12.97h.01s-.01,0-.01,0c-.03-.03-.06-.07-.09-.1,0,0-.02-.02-.03-.03,0,0,.02.02.03.03.03.03.06.07.09.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.71,18.4h0s0,0,0,0c0,0,0,.02.01.03,0,0,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.61,18.16h0s.03.07.04.1c-.01-.03-.03-.07-.04-.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "24.47 11.79 24.47 11.78 24.45 11.78 24.47 11.78 24.47 11.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.12,12.35h0s0,0,0,0c-.01,0-.02,0-.04.01.01,0,.02,0,.04-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.41,19.44s0,0-.01-.01c.02.02.04.05.06.07-.02-.02-.03-.03-.05-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.5,19.54h0s.02.01.03.02c0,0-.01-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.32,19.34s.05.06.08.09h0s0,0,0,0c-.03-.03-.05-.06-.08-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.84,11.53h0s-.04-.02-.06-.02c.02,0,.04.01.06.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m19.3,19.32h0s.01.02.02.02c0,0-.01-.02-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.18,11.36h0s-.06-.01-.1-.02c.03,0,.06,0,.1.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.36,12.13s.02,0,.03,0c-.01,0-.02,0-.03,0-.02,0-.04,0-.06,0h0s.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.68,11.3s-.03,0-.04,0c-.02,0-.05,0-.07,0,.02,0,.05,0,.07,0,.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26,18.45s-.03.05-.04.08c-.07.14-.15.28-.24.41-.01.02-.03.04-.04.06-.06.08-.12.16-.18.24l-.1,1.27c-.12.1-.25.2-.38.29.39-.26.73-.58,1.02-.93-.05.07-.11.13-.17.19l.13-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.22,21.23l.08-.97c-.1.06-.21.11-.32.16-.04.02-.08.04-.13.05l-.08.92s.02,0,.03,0c.02,0,.05-.02.07-.02.02,0,.03-.01.05-.02.02,0,.05-.02.07-.03.02,0,.03-.01.05-.02.03-.01.05-.02.08-.03.01,0,.03-.01.04-.02.04-.02.08-.03.12-.05.05-.02.09-.04.14-.06-.05.02-.09.04-.14.06-.02.01-.05.02-.07.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.26,12.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.4,12.13h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.89,12.17h0s.02,0,.03,0c-.01,0-.02,0-.03,0h-.02s.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "22.76 12.15 22.76 12.15 22.76 12.15 22.76 12.15 22.76 12.15 22.74 12.15 22.76 12.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.59,12.22h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.33,12.28h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.18,12.33s.01,0,.02,0c0,0-.01,0-.02,0h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.46,13.6v-.02s-.02-.02-.03-.03c0,.01.01.02.02.03v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.43,12.25h0s.04,0,.06-.01c.02,0,.03,0,.05-.01.01,0,.03,0,.04,0h0s-.03,0-.05,0c-.02,0-.03,0-.05.01-.02,0-.04,0-.06.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.38,12.27s.03,0,.05-.01c-.02,0-.03,0-.05.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.05,14.55c.03.07.06.13.09.2.05.13.1.25.13.38l.13-1.61s.01.02.02.03c-.02-.04-.05-.08-.08-.11,0,0-.01-.02-.02-.03-.03-.04-.06-.09-.09-.13,0,0-.01-.02-.02-.03-.03-.04-.05-.07-.08-.11,0,0-.02-.02-.02-.03-.03-.04-.07-.08-.1-.12l-.1,1.27c.05.09.1.19.14.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.64,13.92s.02.04.03.06l-.2,2.45c0,.25-.02.49-.06.73,0,.01,0,.03,0,.04l-.2,2.46s-.05.07-.08.1c1.14-1.45,1.49-3.5.75-5.34-.02-.05-.04-.11-.07-.16,0-.01-.01-.03-.02-.04-.02-.05-.04-.09-.07-.14v-.02c-.03-.05-.06-.1-.08-.15,0-.01-.01-.03-.02-.04-.02-.03-.03-.06-.05-.08.02.03.03.06.05.08,0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "22.47 12.13 22.48 12.14 22.47 12.13 22.47 12.13 22.47 12.13 22.47 12.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m17.67,15.94c.03-.45.13-.9.29-1.33l.04-.45c-.54,1.15-.68,2.49-.31,3.78l.06-.77c-.09-.4-.11-.82-.08-1.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.52,12.61c.08-.04.16-.09.25-.12h.01s.03-.02.04-.02c.02,0,.03-.01.05-.02.01,0,.02,0,.03-.01.02,0,.05-.02.07-.03.01,0,.03-.01.04-.02h0s0,0,0,0h.01s.03-.01.04-.02l.07-.9c-.18.05-.36.11-.54.19l-.08.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.42,20.26h0s-.03-.02-.05-.03h0s0,0,0,0h0s-.02-.01-.02-.02c-.02-.01-.03-.02-.05-.03,0,0-.02-.01-.03-.02h-.01s-.01-.01-.01-.01h0s-.02-.01-.02-.02h0s-.01-.01-.02-.02c0,0-.02-.01-.03-.02h-.01s-.01-.02-.02-.02h-.01s-.03-.03-.05-.04h0s0-.01,0-.01h0s-.01,0-.01,0c-.02-.02-.04-.03-.07-.05h0s-.02-.02-.03-.03h0s0,0,0,0l-.08.96c.21.14.44.26.67.36-.06-.02-.11-.05-.17-.08l.07-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.74,13.28c.06-.07.12-.14.18-.2l.02-.28c-.22.23-.42.48-.59.74l-.03.33c.12-.2.26-.4.41-.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.27,21.62h0s0,0,0,0c.02,0,.03,0,.05,0-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.37,20.65h-.01s0,0,0,0c0,0-.02,0-.03,0h-.01s-.04-.02-.06-.02c0,0-.02,0-.03,0h-.02s-.02-.01-.02-.01c-.02,0-.03-.01-.05-.02h-.02s0,0,0,0l-.07.86c-.06-.02-.12-.04-.17-.06.25.09.51.15.78.19-.11-.02-.23-.04-.34-.07l.07-.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m18.52,17.92c-.41-1.22-.27-2.52.29-3.58h0s.08-1.02.08-1.02c-.01.02-.03.03-.04.05-.14.19-.27.39-.38.59-.07.12-.13.25-.19.38l-.35,4.29h0c.13.3.28.58.46.84l.13-1.55h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.74,12.19s-.03,0-.05,0c-.02,0-.04,0-.06.01.02,0,.04,0,.06-.01.02,0,.03,0,.05,0,.02,0,.04,0,.06,0,.02,0,.03,0,.05,0h0s0,0,0,0c.02,0,.04,0,.06,0h0s0,0,0,0c.01,0,.03,0,.04,0,.02,0,.04,0,.06,0,.01,0,.03,0,.04,0,.02,0,.05,0,.07,0,.01,0,.02,0,.04,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0l.07-.85c.06,0,.11,0,.17,0-.15,0-.29.01-.44.03l-.07.86s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.41,17.2s0-.03,0-.04c0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 26.46,
    y: 16.1,
    width: 0,
    height: 0,
    transform: "translate(-1.15 2.06) rotate(-4.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.7,20.4s.02,0,.03.01h0s-.02,0-.03-.01h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 26.39,
    y: 15.61,
    width: 0,
    height: 0,
    transform: "translate(-2.44 5.16) rotate(-10.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.28,14.41s0,.01,0,.02h0s0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.44,15.95v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.47,16.28s0-.02,0-.03h0s0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26.47,16.43h0c0,.25-.02.49-.06.73.04-.24.06-.49.06-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.66,12.86s.04.03.05.04c-.02-.01-.04-.03-.05-.04h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.31,14.46s0,.02.01.02h0s0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.66,16.77s-.01,0-.02,0c0,0,.02,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.6,16.79s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.7,16.76h-.02s.01,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.8,16.75s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.72,16.76s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.76,16.75s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.85,16.75h-.01s.01,0,.02,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.33,14.51s0,.02.01.03h0s-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.36,14.57s.02.04.02.06h0s-.02-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.55,16.81s.02-.01.04-.02c-.01,0-.02,0-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.41,20.25s-.03-.02-.05-.03c.02,0,.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 26.34,
    y: 17.52,
    width: 0,
    height: 0,
    transform: "translate(3.06 38.95) rotate(-76.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.7,13.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 26.42,
    y: 15.78,
    width: 0,
    height: 0,
    transform: "translate(-2.21 4.49) rotate(-9.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.06,14.12s.01.01.02.02h0s-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.02,14.08s0,.01.01.01h0s-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.21,13.33h0s0,0,0,0h0s0,0,0,0h-.01s-.02-.03-.03-.05h-.01s.03.02.05.03c0,0,0,0,.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.98,14.04h.01s0,.02,0,.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.19 14.28 23.2 14.29 23.19 14.28 23.19 14.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.18 14.26 23.18 14.26 23.18 14.26 23.18 14.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.89,13.04s.05.04.08.06c-.02-.02-.05-.04-.08-.06,0,0-.02-.01-.03-.02h0s.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.94,14h0s0,.01,0,.01c0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.07,13.2s-.02-.01-.02-.02c0,0,0,0-.01-.01.01.01.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.26,12.61h.01s.01.01.02.02c0,0-.01,0-.02-.01h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.15,14.23h0s-.01,0-.02-.02c0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.5,19.24c.06-.08.12-.16.18-.24-.06.08-.12.16-.18.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m25.96,18.53c-.07.14-.15.28-.24.41.09-.13.17-.27.24-.41Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "26.07 18.31 26.08 18.3 26.07 18.31 26.07 18.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m26,18.45h0s-.03.05-.04.08c.01-.03.03-.05.04-.08Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 26.19,
    y: 18,
    width: 0,
    height: 0,
    transform: "translate(.21 36.3) rotate(-69.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.23 14.33 23.23 14.34 23.23 14.33 23.23 14.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.21 12.22 23.21 12.22 23.19 12.22 23.21 12.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.92 13.99 22.93 13.99 22.92 13.99 22.92 13.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.24 14.35 23.25 14.37 23.25 14.37 23.24 14.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.89 13.96 22.9 13.97 22.91 13.97 22.89 13.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.47 16.85 22.46 16.85 22.48 16.85 22.47 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.21 14.3 23.22 14.31 23.22 14.31 23.21 14.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.44,18.24s.02.02.04.02c-.01,0-.03-.02-.04-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m18.75,18.47s0,.02.01.03c0,0,0-.01-.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.5,19.54s.01.02.02.02c0,0,.01.01.02.02h-.01s-.02-.03-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.17,17.93s-.02-.03-.02-.05c0,.02.01.03.02.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 18.87,
    y: 18.7,
    width: 0.01,
    height: 0,
    transform: "translate(-7.13 13.24) rotate(-32.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.48,18.27s.01,0,.02.01h.02s-.02,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.78,18.37s.02,0,.04,0h.01s-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.58,18.32s.02,0,.03,0h.01s-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.53,18.3s.03.01.04.02c-.01,0-.03-.01-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.63,18.34s.03,0,.04.01h0s-.03,0-.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.75,18.36s.02,0,.04,0c-.02,0-.03,0-.05,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.68,18.35s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.41,19.45h0s0,0,0,0c.02.02.03.04.05.05h.01s-.03-.02-.05-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.58,19.62s-.01-.01-.02-.02h0s.01.01.02.02c0,0,.01.01.02.02h0s-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "20.24 20.15 20.26 20.16 20.25 20.16 20.24 20.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "20.04 20.01 20.04 20.01 20.04 20.01 20.04 20.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.15,20.09s.02.01.03.02c0,0-.01,0-.02-.01h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "20.2 20.12 20.21 20.13 20.21 20.13 20.2 20.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.06,20.03s.03.02.05.03c-.01,0-.02-.02-.04-.03h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.01,19.99s-.01,0-.02-.01c-.01,0-.02-.02-.03-.02.02.02.04.03.07.05h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.62,19.66h0s.01,0,.02.02h.01s0,.01,0,.01c0,0-.01-.01-.02-.02,0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.69,19.73s.01.01.02.02h0s0,.01,0,.01c-.01,0-.02-.02-.03-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.77,19.8h0s0,0,0,0h.01s0,0,0,0c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m19.93,19.93s.02.01.03.02h0s-.01-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 22.75,
    y: 20.76,
    width: 0,
    height: 0,
    transform: "translate(-1.97 2.38) rotate(-5.75)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 20.83,
    y: 20.45,
    width: 0,
    height: 0.02,
    transform: "translate(-6.2 31.52) rotate(-66.72)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 22.92,
    y: 20.74,
    width: 0,
    height: 0,
    transform: "translate(-2.88 3.72) rotate(-8.73)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.23 16.92 22.22 16.92 22.24 16.92 22.23 16.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.38 20.64 23.39 20.64 23.39 20.64 23.38 20.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.15,16.93s-.01,0-.02,0c.01,0,.02,0,.03,0h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 23.07,
    y: 20.71,
    width: 0.01,
    height: 0,
    transform: "translate(-3.34 4.47) rotate(-10.32)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 21.52,
    y: 20.68,
    width: 0,
    height: 0,
    transform: "translate(-3.3 37.27) rotate(-77.63)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.4 16.87 22.39 16.88 22.4 16.87 22.4 16.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.31,16.9h-.01s.01,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.6 20.77 22.61 20.77 22.61 20.77 22.6 20.77"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 21.98,
    y: 20.75,
    width: 0,
    height: 0.01,
    transform: "translate(-.96 40.46) rotate(-84.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.24,18.04s.02.02.03.04c0-.01-.02-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.31,18.13h.01s.01.02.02.03c0,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.27,18.09h0s.02.03.03.04c-.01-.01-.02-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.39,18.21s.02.02.03.02c-.01,0-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.34,18.17s.02.02.04.03c-.01-.01-.02-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.88,13.95h0s-.01,0-.02,0h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22,16.95h0s-.02,0-.03,0c.01,0,.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.2,17.99s.01.02.02.04h0s-.02-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 23.69,
    y: 20.54,
    width: 0.01,
    height: 0,
    transform: "translate(-5.59 9.34) rotate(-19.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.08,16.94h0s-.02,0-.02,0h0s.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.2,17.98s-.02-.03-.02-.04c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "21.18 20.59 21.2 20.6 21.2 20.6 21.18 20.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m20.33,20.21h-.01s-.02-.02-.03-.03c.02.01.03.02.05.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.33,15.97s.02,0,.03.01c-.02,0-.03-.01-.05-.02h0s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.38,15.99s.04.02.06.02c-.02,0-.04-.02-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.56,16.07h0s-.03-.01-.05-.02c.01,0,.03.01.04.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.63,16.11h.02s-.04-.01-.06-.03c.01,0,.02.01.04.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.84,16.26s.03.02.04.04c-.01-.01-.03-.02-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.9,16.31s.03.03.05.05c-.02-.02-.03-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.45,16.02s.03.01.05.02c-.02,0-.03-.02-.05-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.77,16.21s.04.03.05.04c-.02-.01-.04-.03-.05-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.7,13.83s.02.01.03.02c-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23.25 15.95 23.23 15.94 23.24 15.95 23.25 15.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.77,14.49s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.79,13.89h0s-.02-.01-.03-.02c.01,0,.02.01.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.18,15.93s-.02,0-.02,0h.01s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.23,15.94s-.02,0-.04,0h.01s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.96,16.37s.03.03.04.04c-.01-.02-.03-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.8,14.48s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.29,15.96s-.03,0-.04-.01h.01s.02,0,.02.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.84,14.48s.01,0,.02,0c0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.13,16.58s0,.01.01.02c-.01-.02-.02-.03-.03-.05,0,0,.01.02.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.74,16.18s.02.02.03.02c-.02-.01-.04-.03-.06-.04,0,0,.01,0,.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.13,14.19s-.02-.02-.03-.03c0,0,.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.23,15.61s.01.03.02.05h0s-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.35,13.68s.03,0,.04.01c-.01,0-.03,0-.04-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.83,13.91h0s-.02,0-.03-.02c0,0,.02.01.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.85 13.93 22.85 13.93 22.86 13.93 22.85 13.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.23,13.65s.02,0,.04,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.03,13.63s.02,0,.03,0h0s.02,0,.03,0c-.02,0-.04,0-.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.37,17.11s.02.08.03.12c0-.04-.02-.08-.03-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.16,16.62s.02.03.03.05c-.01-.02-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.2,16.68s.02.04.04.06c-.01-.02-.02-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.06,16.48s.03.04.04.06c-.01-.02-.03-.04-.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.93,14.47h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.69,16.14h.02s-.03,0-.04-.02c0,0,.01,0,.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.01,16.43s.02.03.04.04c-.01-.01-.02-.03-.04-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.24,16.76s.02.03.03.05c0-.02-.02-.03-.03-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.28,16.83s.02.05.03.07c0-.02-.02-.05-.03-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.13,15.92h0s-.03,0-.05,0h.01s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.27,15.7h0s0,.01,0,.01c0-.01-.01-.02-.02-.03,0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.7,16.06s-.03,0-.04-.01c.01,0,.03.01.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.46,13.72s.02,0,.03.01h0s-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.65,16.04s-.03-.01-.04-.02c.01,0,.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.13,20.58s.03.01.05.02c-.02,0-.03-.01-.05-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.74,16.07h0s-.02,0-.04,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.6,16.01s-.02-.01-.04-.02c.01,0,.02.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.6,13.78h0s.02.01.02.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 21.8,
    y: 16.08,
    width: 0,
    height: 0,
    transform: "translate(1.86 34.42) rotate(-79.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.44,15.91h0s0,0,0,0c0,0-.01,0-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.55,15.99s-.03-.02-.04-.03c.01,0,.03.02.04.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.41,15.88s-.01-.01-.02-.02c0,0,.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.54 13.75 22.55 13.75 22.54 13.75 22.54 13.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.37,15.83h0s0,.01,0,.01c0,0-.01-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.55,13.75h0s.02.01.02.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.35,20.64h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.5 13.73 22.5 13.73 22.52 13.74 22.5 13.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.48,15.94h0s.01.01.02.02c0,0-.02-.01-.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.3,15.75h0s0,0,0,0c0,0-.01-.02-.02-.03,0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "23 15.9 22.99 15.9 22.99 15.9 23 15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.17,13.64s.03,0,.04,0c-.01,0-.03,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.44 13.71 22.45 13.71 22.46 13.72 22.44 13.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.29,13.67s.02,0,.04,0c-.01,0-.02,0-.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.73,14.5s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.63,14.54s.03-.01.04-.02c-.01,0-.03.01-.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.68,14.52s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.06,15.91h0s-.05,0-.07,0c0,0,.02,0,.03,0,.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m24.3,20.27h0c-.1.06-.21.11-.32.16-.04.02-.08.04-.13.05.04-.02.08-.04.13-.05.11-.05.21-.1.32-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.24,20.61h0s.04.01.06.02c-.02,0-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.65,13.8h0s.02.01.03.02c-.01,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m21.33,15.79h0s0,0,0,0c0,0-.01-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.1,13.63h0s0,0,0,0c.01,0,.02,0,.03,0-.01,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "22.6 13.78 22.6 13.78 22.6 13.78 22.6 13.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.98,15.9s-.03,0-.04,0c0,0,.01,0,.02,0h.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.44,13.71h0s-.02,0-.04-.01c.01,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m22.76,12.15h-.02c-.48.02-.96.13-1.43.35-2.08.94-3.05,3.48-2.16,5.68.06.14.12.27.18.4-.01,0-.03,0-.04,0,.01,0,.03,0,.04,0,.06.12.12.23.19.33,0,.01.02.02.02.04.15.23.33.45.52.64.72.08,1.5-.03,2.25-.37.04-.02.08-.04.12-.05,0,0-.02,0-.03,0-.01,0-.02,0-.03,0,0,0-.02,0-.02,0-.01,0-.02,0-.03-.01h-.01s-.06-.03-.08-.04h0s-.03-.02-.04-.02h-.02s-.02-.02-.04-.03h-.02s-.02-.02-.04-.03h-.01s-.02-.02-.04-.03h0c-.07-.06-.15-.11-.21-.17h0s-.02-.03-.04-.04h0s-.02-.03-.04-.04h0c-.06-.07-.12-.15-.18-.23h0c-.05-.08-.1-.17-.14-.27l.17-.08.58-.26h.11c.11.29.36.46.64.49h0c.09,0,.18-.03.26-.06s.16-.09.22-.16c.03-.03.05-.06.08-.09.02-.02.03-.04.04-.06.05-.08.08-.16.1-.25,0-.03.01-.05.01-.08.01-.08.01-.16,0-.24,0-.05-.02-.11-.04-.16,0-.01,0-.03-.01-.04-.05-.12-.12-.21-.2-.29-.02-.02-.04-.03-.06-.05-.11-.08-.24-.13-.38-.15-.09,0-.18.03-.27.06-.21.1-.44.14-.65.13h-.11s.02,0,.02,0c0,0-.02,0-.02,0h0s-.03,0-.05,0h0c-.18-.01-.35-.06-.51-.13h-.01c-.06-.03-.12-.06-.17-.1h0s-.05-.04-.07-.05h-.01s-.05-.05-.08-.07h0s-.05-.04-.08-.07h0s-.04-.05-.06-.07c0,0,0,0-.01-.01-.13-.14-.24-.31-.32-.5-.28-.69-.07-1.47.45-1.93.01-.01.03-.03.04-.04l-.03-.08-.15-.37.19-.08.54-.24h.11s.18.44.18.44c.06,0,.13,0,.19,0h0s.01,0,.01,0c-.01,0-.03,0-.04,0h.11c.6.02,1.16.39,1.41,1l-.74.34h-.11s0,0,0,0c0-.02-.02-.04-.02-.05h0s-.02-.04-.03-.06h0s-.02-.04-.03-.05h0s-.02-.04-.03-.05h0s-.05-.06-.08-.09h0s-.03-.03-.04-.04h0s-.03-.02-.05-.03h0s-.03-.02-.05-.03h0s-.07-.03-.11-.05h0c-.05-.02-.11-.03-.16-.03-.09,0-.18.03-.26.06-.39.18-.57.66-.41,1.07.11.28.36.46.63.49h.02s0,0,0,0c.04,0,.08,0,.12-.02h0s.04-.01.05-.02h0s.04-.02.06-.03c.02-.01.05-.02.07-.03,0,0,.02,0,.02,0,.02,0,.03-.01.05-.02,0,0,.02,0,.03,0,.01,0,.03,0,.04-.01.01,0,.02,0,.03,0,.01,0,.03,0,.04-.01.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,0,0,.02,0,.03,0,.02,0,.03,0,.05,0,.02,0,.03,0,.05,0,.01,0,.02,0,.03,0h-.02s.11,0,.11,0c.6.01,1.16.39,1.41,1.01.03.08.06.17.08.25.5-.98.61-2.11.2-3.14-.19-.48-.48-.89-.84-1.22h0s-.01-.02-.01-.02c-.03-.02-.05-.05-.08-.07,0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02-.02-.02-.05-.04-.07-.06h0s-.06-.05-.09-.07c0,0-.02-.01-.03-.02-.03-.02-.06-.04-.09-.07h0s-.07-.05-.1-.07c0,0-.02-.01-.03-.02-.03-.02-.06-.04-.09-.05h-.01s-.07-.05-.1-.06c0,0-.02,0-.03-.01-.03-.02-.06-.03-.09-.04h-.02s-.03-.02-.05-.03h0s.08.01.12.02c-.02,0-.04,0-.06,0-.02,0-.04,0-.06,0-.01,0-.02,0-.03,0h0s-.02,0-.02,0c-.03,0-.07,0-.1-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m23.74,12.38s.02,0,.03.01c.03.01.07.03.1.04,0,0,.02,0,.03.01,0,0-.02,0-.03-.01-.03-.01-.07-.03-.1-.04,0,0-.02,0-.03-.01-.02,0-.04-.01-.05-.02h0s.04.01.06.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.36,20.22h0s.03.02.05.03h0s0,0,0,0c-.02-.01-.04-.02-.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24.29,18.24c.03-.06.05-.12.07-.19-.02.06-.04.13-.07.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24,18.69h0s-.06.06-.09.09h0c.08-.08.15-.16.22-.26-.04.06-.08.11-.13.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.7,20.4s.02,0,.03.01h0s-.03-.01-.04-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "22.88 19.22 22.88 19.22 22.89 19.22 22.88 19.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "23.91 19.12 23.81 18.87 23.82 18.86 23.81 18.87 23.91 19.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.82,20.46h.02s0,.01,0,.01c-.01,0-.02,0-.03-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.11,20.06s-.03-.02-.04-.03c.01,0,.02.02.04.03h.01s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.16,20.1s.01,0,.02.01c0,0,.01,0,.02.01h0s-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m23.86,18.83h0s.03-.03.04-.04h0s-.03.03-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m21.24,20.61s.04.01.06.02c-.02,0-.04-.01-.06-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.57,20.34h0s.02.01.03.02c-.01,0-.03-.01-.04-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m19.54,19.58h0s-.01,0-.02-.01h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "19.69 19.73 19.69 19.73 19.69 19.73 19.69 19.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m22.45,20.78h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m19.6,19.64h0s.01.02.02.02h0s-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m23.99,19.31l-.03-.08.03.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "19.8 19.82 19.8 19.82 19.79 19.82 19.8 19.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.02,20h0s.01.01.01.01h0s-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.25,20.16h0s.02.02.03.02c.01,0,.02.01.03.02-.02-.01-.05-.03-.07-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m23.09,19.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "22.94 19.21 22.94 19.21 22.96 19.21 22.94 19.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "21.51 20.68 21.52 20.69 21.52 20.69 21.5 20.68 21.51 20.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24.26,18.3c-.03.06-.06.12-.1.17.04-.06.07-.11.1-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "22.12 20.77 22.14 20.77 22.13 20.77 22.12 20.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "19.42 19.46 19.41 19.45 19.41 19.45 19.42 19.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m21.2,20.6s-.04-.01-.07-.02c.02,0,.03.01.05.02h.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24.3,20.27h0c.47-.27.87-.62,1.2-1.03.06-.08.12-.16.18-.24.01-.02.03-.04.04-.06.09-.13.17-.27.24-.41.01-.03.03-.05.04-.08.02-.05.05-.09.07-.14h0c.04-.11.08-.21.12-.31h0c.06-.16.1-.32.14-.48h0c.03-.11.05-.22.07-.33,0-.01,0-.03,0-.04.04-.24.06-.49.06-.73,0-.05,0-.1,0-.15,0,0,0-.02,0-.03,0-.05,0-.1,0-.15h0c0-.05,0-.1-.01-.15v-.02c0-.05-.01-.1-.02-.15h0c0-.06-.02-.11-.03-.16h0c-.03-.17-.07-.33-.12-.49-.04-.13-.08-.25-.13-.38-.03-.07-.06-.14-.09-.2-.04-.1-.09-.19-.14-.28h0s-.05-.08-.07-.12c0,0,0-.01-.01-.02-.02-.03-.04-.07-.06-.1,0,0,0-.01-.01-.02-.02-.04-.05-.08-.08-.11h0s-.05-.07-.07-.11c0,0-.01-.02-.02-.03-.02-.03-.04-.06-.07-.09,0,0,0-.01-.01-.02-.03-.03-.05-.07-.08-.1,0,0-.01-.01-.02-.02-.02-.03-.04-.05-.07-.08,0,0-.02-.02-.02-.03-.03-.03-.06-.06-.09-.09h0s0,0,0,0h0s0-.01-.01-.02c-.02-.02-.03-.03-.05-.04-.01-.01-.02-.02-.04-.04,0,0-.01-.01-.02-.02,0,0-.02-.02-.02-.02-.01-.01-.03-.02-.04-.03-.01-.01-.03-.02-.04-.03h0s-.01-.02-.02-.02c-.02-.02-.05-.04-.08-.06,0,0-.02-.01-.03-.02-.03-.03-.07-.05-.1-.08h0s-.04-.03-.05-.04c-.02-.01-.04-.03-.05-.04h-.01s-.01-.02-.01-.02h0s-.06-.04-.1-.06h0s-.01,0-.01,0h-.02s-.06-.05-.09-.07c0,0-.02-.01-.03-.02h-.02s-.05-.04-.08-.05c0,0-.01,0-.02-.01h-.01s-.02-.01-.02-.02c-.03-.01-.05-.03-.08-.04,0,0-.02,0-.03-.01h0s-.04-.02-.06-.03c-.01,0-.03-.01-.04-.02h0s-.02,0-.02-.01c-.03-.02-.07-.03-.11-.05h-.01s-.02-.01-.03-.02c-.03-.01-.07-.03-.1-.04,0,0-.02,0-.03-.01-.02,0-.04-.01-.06-.02-.02,0-.04-.01-.06-.02h0s-.02,0-.02,0c-.03-.01-.07-.02-.1-.03-.01,0-.02,0-.03,0-.04-.01-.08-.02-.12-.03h-.02s0,0,0,0c-.04,0-.07-.02-.11-.03h-.02s-.02,0-.02,0c-.04,0-.08-.02-.13-.02h0s-.08-.01-.12-.02h0s.03.01.05.02h.02s.06.04.09.05c0,0,.02,0,.03.01.03.02.07.04.1.06h.01s.06.04.09.06c0,0,.02.01.03.02.03.02.07.04.1.06h0s.06.05.09.07c0,0,.02.01.03.02.03.02.06.04.09.07h0s.05.04.07.06c0,0,.01.01.02.02,0,0,.01.01.02.02.03.02.05.05.08.07h.01s0,.02,0,.02c.36.33.64.74.84,1.22.41,1.02.3,2.16-.2,3.14.15.64-.08,1.32-.57,1.72l.18.45-.73.33h-.11s0,0,0,0l-.18-.44c-.06,0-.11,0-.17,0h-.11s0,0,0,0h0s-.02,0-.04,0c0,0-.02,0-.02,0-.01,0-.03,0-.04,0h-.02s-.04,0-.06,0c0,0-.02,0-.02,0-.01,0-.02,0-.04,0,0,0-.02,0-.03,0-.01,0-.02,0-.03,0,0,0-.02,0-.03,0,0,0-.02,0-.03,0-.01,0-.02,0-.03,0h0s-.08.04-.12.05c-.75.34-1.52.45-2.25.37.67.69,1.55,1.11,2.48,1.19.02,0,.03,0,.05,0h.01s.1,0,.15-.01h0c.05,0,.1-.01.16-.02h0s.1-.02.15-.02h.01c.1-.02.2-.04.3-.07h.01c.1-.03.2-.06.3-.1h.01s.1-.04.15-.06c.04-.02.08-.04.13-.05.11-.05.21-.1.32-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m21.83,20.74h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m19.96,19.95h0s0,0,0,0h0s.02.02.03.03c-.01,0-.03-.02-.04-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.33,20.21h0s.02.01.02.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24.41,17.31c0,.06.01.12.02.19,0-.06,0-.12-.02-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24.43,17.54s0,.08,0,.11c0-.04,0-.08,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m24.42,17.76c0,.08-.02.15-.04.22.02-.07.03-.15.04-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m21.97,20.76h.01s0,0,0,0c0,0-.02,0-.02,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m20.97,20.52h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m21.37,20.65h.01s-.02,0-.02,0h.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "23.01 19.21 23.01 19.21 23.02 19.21 23.01 19.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m23.03,11.31h-.54s.02-.01.02-.01h0s.05,0,.07,0c.02,0,.05,0,.07,0,.01,0,.03,0,.04,0,.05,0,.1,0,.15.01h0s.1.01.14.02c.01,0,.03,0,.04,0,.02,0,.03,0,.05,0,.03,0,.06,0,.1.01h0c.05.01.1.02.15.03.01,0,.03,0,.04,0,.04,0,.09.02.13.03h.02s.1.03.15.04c.01,0,.02,0,.04.01.02,0,.04.01.06.02.02,0,.04.01.06.02h0s.02,0,.02,0c.05.02.1.03.14.05.01,0,.02,0,.03.01.04.01.08.03.12.05.01,0,.02,0,.03.01.05.02.09.04.14.06,0,0,.02,0,.03.01.03.02.06.03.1.05h.02s0,.01,0,.01c.01,0,.02,0,.03.02.02.01.04.02.06.03.02.01.05.02.07.04,0,0,.02,0,.02.01.04.02.08.04.11.07.01,0,.02.01.03.02.04.03.09.05.13.08h.02s.02.02.02.02c.03.02.07.04.1.07.01,0,.02.02.03.02.04.03.08.06.13.09h0s.05.05.08.07c.01.01.03.02.04.03.01,0,.02.02.03.03.04.03.07.06.11.09h0s.08.08.12.11c0,0,.02.02.03.03.03.03.07.06.1.1,0,0,.01.01.02.02.04.04.07.08.11.11,0,0,.02.02.03.03.03.03.06.07.09.1h.01s.01.02.01.02h0s.07.08.1.12c0,0,.02.02.02.03.03.03.05.07.08.11,0,0,.01.02.02.03.03.04.06.09.09.13,0,0,.01.02.02.03.03.04.05.08.08.11,0,.01.01.02.02.03v.02s.06.08.09.13c0,0,0,.02.01.02,0,.01.02.03.02.04.02.03.03.06.05.08,0,.01.01.03.02.04.03.05.05.1.08.15v.02s.05.09.07.14c0,.01.01.03.02.04.02.05.05.1.07.16.75,1.85.39,3.9-.75,5.34h0s-.05.07-.07.1h0c-.29.36-.64.67-1.02.93h-.01s-.08.06-.12.09h0s-.09.06-.14.09h0s-.08.05-.13.07c-.01,0-.02.01-.04.02-.03.02-.07.04-.1.05-.01,0-.03.01-.04.02-.05.02-.09.04-.14.06-.04.02-.08.04-.12.05-.01,0-.03.01-.04.02-.03.01-.05.02-.08.03-.02,0-.03.01-.05.02-.02,0-.05.02-.07.03-.02,0-.03.01-.05.02-.02,0-.05.02-.07.02,0,0-.02,0-.03,0,0,0-.02,0-.03,0-.02,0-.05.01-.07.02-.02,0-.04.01-.05.02-.02,0-.05.01-.07.02-.02,0-.04,0-.06.01-.02,0-.05.01-.07.02-.02,0-.04,0-.06.01-.01,0-.02,0-.03,0-.01,0-.02,0-.03,0,0,0-.01,0-.02,0-.01,0-.02,0-.04,0-.02,0-.05,0-.07.01-.02,0-.04,0-.06,0-.02,0-.05,0-.07.01-.02,0-.04,0-.05,0-.01,0-.03,0-.04,0-.01,0-.02,0-.03,0-.02,0-.04,0-.05,0h-.01s-.04,0-.06,0c-.02,0-.03,0-.05,0-.03,0-.05,0-.08,0-.02,0-.03,0-.05,0-.03,0-.06,0-.09,0-.01,0-.02,0-.03,0-.04,0-.08,0-.12,0-.01,0-.02,0-.03,0-.02,0-.03,0-.05,0-.02,0-.03,0-.05,0h0s.54.01.54.01c.68.02,1.37-.12,2.03-.42,2.48-1.12,3.64-4.16,2.58-6.78-.78-1.92-2.53-3.08-4.38-3.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m20.07,19.58c-.19-.19-.36-.41-.52-.64,0-.01-.02-.02-.02-.04-.07-.11-.13-.22-.19-.33-.01,0-.03,0-.04,0,.01,0,.03,0,.04,0-.07-.13-.13-.26-.18-.4-.89-2.19.08-4.73,2.16-5.68.47-.21.95-.32,1.43-.35-.04,0-.07,0-.11,0-.01,0-.02,0-.03,0-.04,0-.08,0-.11,0h-.02s0,0,0,0c-.02,0-.04,0-.07,0-.01,0-.02,0-.04,0-.02,0-.04,0-.06,0h0s-.03,0-.04,0h-.02s-.06,0-.09,0c-.01,0-.03,0-.04,0-.02,0-.04,0-.07,0-.01,0-.03,0-.04,0-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0h0s-.04,0-.06,0h0s-.03,0-.05,0c-.02,0-.04,0-.06,0-.02,0-.03,0-.05,0-.02,0-.04,0-.06.01-.02,0-.03,0-.05,0h0s0,0,0,0c-.01,0-.03,0-.04,0-.02,0-.03,0-.05.01-.02,0-.04,0-.05.01h0s-.03,0-.05.01c-.02,0-.04.01-.06.02-.02,0-.03,0-.05.01-.01,0-.02,0-.03.01,0,0-.02,0-.02,0-.02,0-.03,0-.05.01-.02,0-.04.01-.06.02h0s-.03.01-.04.02h0s0,0,0,0c-.01,0-.03.01-.04.02h-.01s0,0,0,0c-.01,0-.03.01-.04.02-.02,0-.04.02-.06.03-.01,0-.03.01-.04.02-.02,0-.03.01-.05.02-.01,0-.03.01-.04.02h-.01c-.08.04-.17.09-.25.13-.19.1-.36.21-.53.34h0c-.08.06-.16.13-.24.2h0c-.08.07-.15.14-.22.21h0c-.07.07-.14.15-.21.23h0c-.07.08-.13.16-.19.24h0c-.06.08-.12.17-.17.25h0c-.05.09-.11.17-.15.26-.57,1.06-.71,2.36-.29,3.58.01.04.03.08.04.12h0s.03.09.05.13h0s.03.07.04.1c0,.01,0,.02.01.03.01.02.02.05.03.07,0,.01,0,.02.01.03h0s0,0,0,0c0,0,0,.02.01.03,0,0,0,.02.01.03h0s0,.02,0,.02c0,0,0,.01.01.02h0s0,.02.01.03c.01.03.03.05.04.08h0s0,.01,0,.02c0,0,0,.02.01.03,0,0,.01.02.02.03h0s0,0,0,0h0s0,.01,0,.01h0s0,.02,0,.02h0s0,.02.01.03c0,.01.01.02.02.04.01.02.02.04.03.05,0,.01.02.02.02.04,0,0,.01.02.02.03,0,.01.01.02.02.03.02.04.05.07.07.11,0,0,.01.01.02.02.02.02.03.04.05.07,0,.01.02.02.03.03.01.02.03.04.04.05h0s0,0,0,0h0s.05.07.07.1h0s.01.02.02.02c.02.03.05.06.08.09h0s0,.01.01.02h0s0,0,0,0h0s.03.04.05.06c0,0,.02.02.03.03h0s0,0,0,0c.01.01.02.02.03.03,0,0,.01.01.02.02,0,0,.01.01.02.02,0,0,.01.01.02.02,0,0,.01.01.02.02,0,0,.02.02.02.02,0,0,0,0,.01.01,0,0,.01.01.02.02.01.01.02.02.04.03h0s.02.02.03.03c.02.01.03.03.05.04,0,0,.01.01.02.02h0s.08.07.12.11h0s0,0,0,0h0s.01.01.02.02h0s.03.03.04.04c0,0,.01,0,.02.01h0s.01.01.02.02h0s0,0,0,0h0s.01.01.01.01c.01.01.03.02.04.03h0s.01.02.02.02h.01s0,.01,0,.01c.02.01.03.02.05.03h0s.02.01.02.02h0s.01,0,.01,0h0s.04.03.07.04h.01s0,0,0,0c0,0,.02.01.03.02h0s0,0,0,0c.02.01.04.02.06.04.05.03.09.05.14.08.01,0,.03.01.04.02.03.01.05.03.08.04.01,0,.03.01.04.02.03.01.06.03.09.04.01,0,.02,0,.03.01.04.02.08.03.12.05h0s.09.03.13.05h0s0,0,0,0h.02s0,0,0,0c.02,0,.04.01.07.02h0s0,0,0,0h.02s.02.01.03.01h0s.04.01.06.02h.01s.02,0,.03.01h0s.02,0,.02,0c.04.01.08.02.13.03h.02s.09.02.14.03h0s.1.02.15.03h.01s.09.01.13.02c0,0,.02,0,.02,0,.05,0,.09,0,.14.01h0s0,0,0,0c.1,0,.2,0,.3,0h.01s.06,0,.1,0c-.93-.09-1.8-.51-2.48-1.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m21.7,13.64s.07,0,.1-.01l-.18-.44h-.11s.18.45.18.45h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m22.84,16.75h-.02s-.01,0-.02,0h-.02s-.01,0-.02,0h-.02s-.01,0-.02,0h-.02s-.01,0-.02,0h-.02s-.02,0-.02.01h-.02s-.02.01-.03.01h-.01s-.02.01-.04.02h0s-.04.02-.07.03h-.01s-.01,0-.01,0c-.02,0-.03.01-.05.02,0,0-.01,0-.02,0h0s-.04.01-.06.02h-.01s-.01,0-.02,0c-.01,0-.02,0-.03,0,0,0-.02,0-.03,0h-.02s-.02,0-.03,0c-.01,0-.02,0-.04,0-.01,0-.02,0-.03,0h-.02s-.02,0-.03,0c-.01,0-.02,0-.04,0-.01,0-.03,0-.04,0h0s-.02,0-.04,0c-.01,0-.03,0-.04,0h-.02s.11,0,.11,0c.22,0,.44-.04.65-.13.09-.04.18-.06.27-.06-.02,0-.04,0-.07,0,0,0-.01,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m22.18,17.94s.01.03.02.04h0s.02.03.03.05h0s.02.03.03.05h0s.02.03.03.04h0s.02.03.03.04h0s.02.03.04.04h0s.02.02.03.03h0s.03.02.04.03h0s.02.02.04.02h.01s.03.02.04.03h0s.03.01.04.02h.01s.03.01.05.02h0s.03,0,.04.01h.01s.03,0,.05,0h0s.03,0,.05,0c.02,0,.04,0,.06,0-.27-.03-.52-.21-.64-.49h-.11s.01.03.02.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m23.09,19.2s-.04,0-.06,0h0s-.02,0-.02,0c-.01,0-.03,0-.04,0h-.01s-.02,0-.02,0c-.01,0-.02,0-.03,0h-.02s-.01,0-.01,0c-.01,0-.02,0-.03,0,0,0-.01,0-.02,0h0s.11,0,.11,0c.06,0,.11,0,.17,0h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m22.09,13.63h.01s.03,0,.05,0c0,0,.01,0,.02,0,.01,0,.03,0,.04,0,0,0,.02,0,.02,0,.01,0,.02,0,.04,0,0,0,.02,0,.02,0,.01,0,.02,0,.04,0h.02s.03.01.04.02h.02s.02.01.04.02h0s.02,0,.02,0h0s.02,0,.03.01h0s.02.01.02.01h.02s0,.01,0,.01h0s.02,0,.03.01h.02s0,.01,0,.01h0s.02.01.03.02h.02s0,.01,0,.01c.01,0,.02.01.03.02,0,0,.01,0,.02.01.01,0,.02.01.03.02,0,0,.01,0,.02.01.01,0,.02.02.03.02h0s0,.01,0,.01c.01,0,.02.01.03.02h0s.01.01.01.01h0s.01.02.02.02h0s.01.02.01.02c0,0,.01,0,.02.01h0s.01.01.01.01c0,0,.01,0,.02.01,0,0,.01.01.02.02h.01s.01.02.02.03c0,0,.01.01.02.02h0s.01.02.02.03c0,0,.01.01.01.02h0s.02.02.02.03c0,0,0,0,.01.01h0s.02.02.03.03c0,0,0,0,.01.01h0s.01.02.02.03c0,0,0,.01.01.02h0s0,.02,0,.02h0s0,.02.01.03h0s0,.02.01.03h0s0,.01.01.02h0s0,.03.01.04c0,0,0,.01,0,.02,0,0,0,.01.01.02,0,0,0,.01.01.02h0s0,.03.01.04c0,0,0,.01.01.02h0s.01.03.02.04c0,0,0,.01,0,.02h0s.02.04.02.06l-.74.34h.11s.74-.33.74-.33c-.25-.62-.81-.99-1.41-1h-.11s.03,0,.04,0h.01s.04,0,.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.16,19.05s-.02-.01-.04-.02c.01,0,.02.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.22,19.08s-.03-.01-.04-.02c.01,0,.03.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.11,19.03s-.02-.01-.04-.02c.01,0,.02.01.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.31,19.12s-.06-.02-.08-.04c.03.01.06.02.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.41,19.15s-.02,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.06,19s-.02-.02-.04-.02c.01,0,.02.02.04.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.35,19.13s-.02,0-.03-.01c.01,0,.02,0,.03.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.38,18.15s.05-.06.08-.09c-.02.03-.05.06-.08.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.46,18.06s.03-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.36,16.95s-.04-.03-.06-.05c.02.02.04.03.06.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.94,14.01s.02.01.02.02c0,0-.01-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.72,18.71c-.06-.07-.12-.15-.18-.23.05.08.11.16.18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.8,18.8s-.02-.02-.04-.04c.01.01.02.02.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.76,18.76s-.02-.03-.04-.04c.01.01.02.03.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.02,18.97c-.07-.05-.15-.1-.21-.17.07.06.14.12.21.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.41,18.22c.04.1.08.18.14.27l.03-.34-.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.04,16.94s-.03,0-.04,0c.01,0,.03,0,.04,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.82,18.37s.05,0,.07,0h0s-.04,0-.06,0h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.89,16.95s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22,16.95s-.07,0-.1,0c0,0,.02,0,.02,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.08,14.14s.01.01.02.02c0,0,0,0-.01-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.99,14.05s.02.01.02.02c0,0-.01-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.25,14.37s0,.02.01.02c0,0,0-.01-.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.04,14.09s.01.01.02.02c0,0,0-.01-.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.29,14.42s0,.02.01.02c0,0,0-.01-.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "23.38 14.63 23.39 14.63 22.64 14.96 22.64 14.96 22.64 14.96 23.39 14.63 23.38 14.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.32,14.48s0,.02.01.02c0,0,0-.01-.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.03,13.63h-.01s-.01,0-.01,0c.02,0,.03,0,.05,0,0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.96,15.9s-.01,0-.02,0h-.01s.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.61,13.78s.03.01.04.02h-.02s-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.61,14.9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.74,16.18s-.01,0-.02-.01h-.02s-.02-.02-.02-.02c.02.01.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.1,15.92h-.01s-.02,0-.02,0h0s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "21.25 15.65 21.25 15.66 21.25 15.65 21.25 15.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.41,14.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.47,14.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.38,14.72h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.44,14.66h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.03,15.91s-.02,0-.03,0h0s0,0,0,0c.01,0,.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.34,15.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m24.13,16.58s-.01-.02-.02-.03h0s-.03-.05-.04-.07h-.01s-.02-.04-.04-.06c0,0,0-.01-.01-.02-.01-.02-.03-.03-.04-.04h0s-.03-.04-.05-.06h-.01s-.03-.04-.04-.05c0,0-.01,0-.02-.01-.02-.01-.04-.03-.05-.04h0s-.02-.02-.03-.02c.15.11.28.24.39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.36,14.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.37,15.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.17,15.2v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.8,16.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.17,15.24v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.44,15.91h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.34,14.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.18,15.16v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.68,16.14s-.01,0-.02-.01h-.02s-.02-.02-.02-.02c.02.01.03.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.18,15.12v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.62,16.1s-.02-.01-.04-.02h0s0,0,0,0c.02,0,.04.02.05.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.24,15.95h0s0,0,0,0c0,0-.02,0-.02,0,.01,0,.03,0,.04.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.31,15.97h0s-.02,0-.02,0c0,0-.02,0-.02,0,.02,0,.03,0,.05.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.56,16.07s-.03-.01-.04-.02h-.02s-.03-.02-.05-.03h-.01s-.04-.02-.06-.03h-.01s-.02-.01-.03-.02c.08.03.16.06.24.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.19,15.08v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.29,14.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.27,14.87h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.2,15.05v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.31,14.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.26,14.9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.24,14.94v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.21,15.01v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.22,14.97v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.75,15.9s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.28,14.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.33,14.59h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.17,14.51h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.38,14.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.17,15.31s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.17,15.35s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.17,15.39s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.99,16.09h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.43,14.66h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.52,14.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.04,16.65s-.05-.04-.08-.06c.02.02.05.04.08.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.13,16.71s-.05-.03-.07-.05c.02.02.05.03.07.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.88,16.52s-.04-.04-.06-.06c.02.02.04.04.06.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m20.96,16.59s-.05-.04-.08-.07c.02.02.05.05.08.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.55,14.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.18,15.43s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.59,14.85h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.38,15.97s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.83,15.9s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.67,15.91s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.17,15.28v-.02s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.17,15.93h-.01s-.02,0-.02,0h0s.03,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.21,15.55s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.28,15.71h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.31,16.81c-.06-.03-.12-.06-.17-.09.06.03.11.07.17.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.23,15.6s0-.02-.01-.04c0,.01,0,.02.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.2,15.51s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.11,16.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.17,16.06h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.19,15.47s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.31,16s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.45,15.95s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.53,15.93s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.6,15.92s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.3,15.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.86,18.83s.03-.03.04-.04c-.01.01-.03.03-.04.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.64,19.2s-.02,0-.02,0c0,0,.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.58,19.19s-.02,0-.03,0c0,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.78,19.22s-.02,0-.02,0c0,0,.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.47,19.17s-.02,0-.03,0c.01,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.52,19.18s-.02,0-.03,0c0,0,.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.91,18.78s.06-.06.09-.09c-.03.03-.06.06-.09.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.72,19.21h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m21.93,16.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.26,16.91s-.02,0-.03,0h0s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.11,16.94s-.03,0-.04,0h0s.02,0,.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.19,16.92s-.03,0-.05,0h.01s.02,0,.04,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.42,16.87s-.01,0-.02,0h0s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.33,16.89s-.01,0-.02,0h0s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.49,16.84s-.01,0-.02,0h0s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.26,18.08s-.02-.02-.03-.04h0s0-.02,0-.02c.01.02.03.04.05.06h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.3,18.12s-.02-.02-.03-.04c.02.02.03.04.05.06h-.01s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.62,18.33h-.01s.05.01.07.02c-.02,0-.03,0-.04-.01h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.72,18.36s-.03,0-.04,0h0s0,0,0,0c.02,0,.05.01.07.01h-.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.57,18.32s-.03-.01-.04-.02h-.01s-.02-.01-.02-.01c.03.02.07.03.1.05,0,0-.02,0-.03,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.42,18.23s-.02-.02-.03-.02h0s-.02-.03-.04-.04h0s-.01-.02-.02-.02c.04.04.08.07.12.1h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.97,19.21s-.02,0-.02,0h.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.91,19.22s-.02,0-.02,0h0s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.03,19.21s-.01,0-.02,0h.01s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.82,19.22h0s.01,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.39,13.69s-.03,0-.04-.01h-.02s-.02-.01-.04-.02c0,0-.02,0-.02,0-.01,0-.02,0-.04,0,0,0-.02,0-.02,0-.01,0-.03,0-.04,0,0,0-.01,0-.02,0-.01,0-.02,0-.03,0,.11.01.22.04.32.07-.01,0-.02,0-.03-.01h-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.18,14.26h0s.01.01.02.02h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.46,13.72h-.01s.03,0,.04.01c0,0-.02,0-.03-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.86,13.93h0s.02,0,.03.02h-.01s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.52,13.74h-.02s.03,0,.04.01h0s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.74,13.85s-.02-.01-.03-.02c0,0-.01,0-.02-.01,0,0-.02,0-.03-.01.04.02.09.05.13.08-.01,0-.02-.01-.03-.02,0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.09,13.63s-.02,0-.03,0c.02,0,.03,0,.05,0h0s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.22,14.31h0s.01.01.02.02h0s0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.35,14.55h0s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.58,13.77h-.02s.03,0,.04.01h0s-.02-.01-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m23.14,14.21s0,.01.01.02c0,0,0-.01-.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.8,13.89s.02.01.03.02c0,0-.02-.01-.02-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m22.91,13.97h0s.02,0,.03.02h0s-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "23.99 19.31 23.96 19.22 23.95 19.35 23.27 19.65 23.27 19.65 24 19.32 23.99 19.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m19.92,19.92s-.08-.07-.12-.1h0s-.01-.01-.01-.01h0s0,0,0,0c-.02-.01-.03-.03-.05-.04h0s0-.01,0-.01c0,0-.01-.01-.02-.02h0s-.02-.02-.04-.03h0s-.01-.01-.01-.01c0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02h0s-.01-.01-.02-.02h0s-.01-.02-.02-.02c0,0-.02-.02-.03-.03,0,0-.02-.02-.03-.03h-.01s-.04-.06-.06-.08h0s-.05-.06-.08-.09c0,0-.01-.02-.02-.02h0s-.05-.06-.07-.09h0s0-.02,0-.02c-.01-.02-.03-.04-.04-.05,0-.01-.02-.02-.03-.03-.02-.02-.03-.04-.05-.07,0,0-.01-.01-.02-.02-.03-.04-.05-.07-.07-.11,0-.01-.01-.02-.02-.03,0,0-.01-.02-.02-.03,0-.01-.02-.02-.02-.04-.01-.02-.02-.03-.03-.05,0-.01-.01-.02-.02-.04,0,0,0-.02-.01-.03h0s0-.02,0-.02h0s0-.01,0-.01h0s-.01-.02-.02-.03c0,0,0-.02-.01-.03,0,0,0-.01,0-.02h0s-.03-.05-.04-.08c0,0,0-.02-.01-.03h0s0-.02-.01-.03h0s0-.03-.01-.04c0,0,0-.02-.01-.03h0s0-.03-.01-.04c-.01-.02-.02-.05-.03-.07,0-.01,0-.02-.01-.03-.01-.03-.03-.07-.04-.1h0s-.03-.08-.05-.12h0s-.03-.09-.04-.13h0s-.13,1.55-.13,1.55h0s.04.06.06.09c0,.01.02.03.03.04.02.03.04.06.06.08,0,0,.01.02.02.02.04.05.08.11.12.16,0,.01.02.02.03.03.02.03.04.05.07.08.01.01.02.02.03.03.05.05.1.11.15.16h0s.05.06.07.08c.01.01.02.02.03.03.02.02.05.05.07.07h.01c.05.06.1.1.15.15.01,0,.02.02.03.03.03.02.05.04.08.06.01,0,.02.02.03.03.06.04.11.09.17.13h.01s.06.05.08.07c.01,0,.02.02.04.02.03.02.06.04.09.06h0s.08-.96.08-.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m19.84,12.34c-.35.29-.67.61-.94.97l-.08,1.02h0c.05-.09.1-.18.15-.26h0c.05-.09.11-.17.17-.25h0c.06-.08.12-.16.19-.24h0c.07-.08.13-.15.21-.23h0c.07-.07.15-.14.22-.21h0c.08-.07.16-.13.24-.2h0c.16-.12.34-.24.53-.34h0s.08-.96.08-.96c-.05.02-.09.04-.14.06-.04.02-.07.03-.11.05-.01,0-.02.01-.04.02-.02.01-.05.02-.07.04-.01,0-.03.02-.04.02-.02.01-.04.02-.07.03-.02,0-.03.02-.05.03-.02.01-.04.02-.06.03-.02,0-.03.02-.05.03-.02.01-.04.02-.06.04-.02,0-.03.02-.05.03-.02.01-.04.02-.06.04-.02.01-.03.02-.05.03-.02.01-.04.02-.05.04-.02.01-.03.02-.05.03-.02.01-.04.03-.05.04-.01.01-.03.02-.04.03-.02.01-.04.03-.05.04-.01.01-.03.02-.04.03-.02.01-.03.03-.05.04-.01.01-.03.02-.04.03-.02.01-.03.03-.05.04-.01.01-.03.02-.04.03-.02.01-.03.03-.05.04-.01.01-.03.02-.04.03-.02.02-.03.03-.05.05-.01.01-.02.02-.04.03-.02.02-.04.04-.06.05-.01,0-.02.02-.03.03-.02.02-.05.05-.07.08h0s0,.01,0,.01l-.02.28c.27-.29.58-.54.92-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m21.1,20.57h0s-.09-.03-.13-.05h0s-.08-.03-.12-.05h0s0,0,0,0h-.02s0,0,0,0h0s-.06-.03-.09-.04h0s0,0,0,0c0,0-.02,0-.03-.01h0s0,0,0,0c-.03-.01-.05-.03-.08-.04,0,0-.02,0-.03-.01h0s0,0,0,0c-.05-.02-.1-.05-.14-.08h0s-.07.9-.07.9c.06.03.11.05.17.08h0c.06.02.11.05.17.07h0c.06.02.11.04.17.06h0c.06.02.11.04.17.06l.07-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m21.07,12.36h0s0,0,0,0h0s.02-.01.04-.01h0s.04-.01.06-.02h0s.01,0,.02,0c0,0,.02,0,.02,0h0s.02,0,.02,0c.01,0,.02,0,.03-.01.02,0,.03,0,.05-.01h0s.04-.01.06-.02h0s.03,0,.05-.01c.02,0,.04,0,.06-.01.02,0,.03,0,.05-.01.02,0,.03,0,.05-.01h0s0,0,0,0c.02,0,.03,0,.05,0,.02,0,.04,0,.06-.01.02,0,.03,0,.05,0,.02,0,.03,0,.05,0l.07-.86h0c-.05,0-.11.01-.16.02-.01,0-.02,0-.03,0-.05,0-.11.02-.16.03h0c-.12.02-.24.05-.36.09h0s-.07.9-.07.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.27,15.13h0c.05.16.09.32.12.48h0s0,0,0,0h0c0,.05.02.1.03.16h0s0,0,0,0h0c0,.05.01.1.02.15v.02s.01.1.02.15h0s0,0,0,0h0s0,.1,0,.15h0s0,.02,0,.03c0,.05,0,.1,0,.15l.2-2.45s-.02-.04-.03-.06c0-.01-.01-.03-.02-.04-.02-.03-.03-.06-.05-.08,0-.01-.02-.03-.02-.04,0,0,0-.02-.01-.02-.02-.04-.05-.08-.08-.13v-.02s-.02-.02-.03-.03c0-.01-.01-.02-.02-.03l-.13,1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m26.41,17.2h0c-.02.11-.04.22-.07.32h0s0,0,0,0h0c-.04.16-.09.32-.14.47h0s0,0,0,0h0c-.04.1-.08.2-.12.29h0s0,.01,0,.01c-.02.05-.04.1-.07.14l-.13,1.61c.06-.06.11-.13.17-.19h0s.05-.06.07-.1h0s.05-.08.08-.11l.2-2.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m18,14.52c.09-.23.2-.44.32-.65h0s.03-.34.03-.34h0c-.07.1-.13.2-.19.31h0c-.06.11-.11.21-.17.32h0s-.04.45-.04.45c.01-.03.02-.06.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m18.29,14.34c-.04.08-.07.17-.11.25-.13.33-.23.66-.3,1.01l-.11,1.31c0,.15.01.31.03.46-.02-.07-.03-.13-.05-.2l-.06.77h0s.03.09.04.14h0s.03.09.04.13h0c.01.05.03.09.04.13,0,0,0,.01,0,.02.02.04.03.09.05.13h0s.04.09.06.13h0s.35-4.29.35-4.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m22.31,21.62s.03,0,.05,0c.01,0,.02,0,.03,0,.04,0,.08,0,.12,0,.01,0,.02,0,.03,0,.03,0,.06,0,.09,0,.02,0,.03,0,.05,0,.03,0,.05,0,.08,0,.02,0,.03,0,.05,0,.02,0,.04,0,.06,0h.01s.04,0,.05,0c.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,.02,0,.04,0,.05,0,.02,0,.05,0,.07-.01.02,0,.04,0,.06,0,.02,0,.05,0,.07-.01.01,0,.02,0,.04,0,0,0,.01,0,.02,0,.01,0,.02,0,.03,0,.01,0,.02,0,.03,0,.02,0,.04,0,.06-.01.02,0,.05-.01.07-.02.02,0,.04,0,.06-.01.02,0,.05-.01.07-.02.02,0,.04-.01.05-.02.02,0,.05-.01.07-.02,0,0,.02,0,.03,0l.08-.92s-.1.04-.15.06h0s-.01,0-.01,0h0c-.1.04-.2.07-.3.1h0s-.01,0-.01,0c-.1.03-.2.05-.3.07h0s-.01,0-.01,0h0s-.1.02-.15.02h0s0,0,0,0h0c-.05,0-.1.01-.16.02h0s0,0,0,0h0s-.1,0-.15.01h0s-.01,0-.01,0c-.02,0-.03,0-.05,0-.03,0-.06,0-.1,0h-.01c-.1,0-.2,0-.3,0h-.01s-.09,0-.14-.01h0s0,0,0,0h-.01s0,0,0,0h0s-.09-.01-.13-.02h-.01s-.1-.02-.15-.03h0s-.09-.02-.14-.03h0s0,0,0,0h0s0,0,0,0h-.01s-.08-.02-.13-.03h-.01s-.07.84-.07.84c.11.03.23.05.34.07.02,0,.03,0,.05,0,.03,0,.06,0,.09.01.04,0,.09.01.13.02.02,0,.04,0,.06,0,.03,0,.07,0,.1,0,.02,0,.03,0,.05,0,.05,0,.1,0,.15,0h0s.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m22.06,12.15s.04,0,.06,0c.01,0,.02,0,.04,0,.03,0,.06,0,.1,0h0s0,0,0,0c.01,0,.03,0,.04,0,.02,0,.04,0,.06,0,.01,0,.02,0,.03,0h0s.04,0,.07,0h0s0,0,0,0h0s0,0,0,0c.04,0,.08,0,.11,0h0s.02,0,.03,0h0s.07,0,.11,0h.02s0,0,0,0h0s0,0,0,0c.03,0,.07,0,.1.01h.02s.02,0,.03,0h0s.04,0,.06,0c.02,0,.04,0,.06,0h0s.08.02.13.03c0,0,.02,0,.02,0h0s0,0,0,0h0s.07.02.11.03h0s.02,0,.02,0c.04.01.08.02.12.03.01,0,.02,0,.03,0,.03.01.07.02.1.03h.02s.04.02.07.03c.02,0,.04.01.05.02h0s.02,0,.03.01c.03.01.07.03.1.04,0,0,.02,0,.03.01h.01s.07.04.11.05h0s.02,0,.02.01c.01,0,.03.01.04.02.02,0,.04.02.06.03h0s.01,0,.01,0h.02s.05.03.08.05c.01,0,.02.01.04.02h.02s.05.04.08.06h.02s0,0,0,0c0,0,.02.01.03.02.03.02.05.03.08.05l.08-.92s-.04-.02-.06-.03c-.01,0-.02-.01-.03-.02h0s-.02-.01-.02-.01c-.03-.02-.06-.03-.1-.05,0,0-.02,0-.03-.01-.05-.02-.09-.04-.14-.06-.01,0-.02,0-.03-.01-.04-.02-.08-.03-.12-.05-.01,0-.02,0-.03-.01-.05-.02-.1-.03-.14-.05h-.02s0,0,0,0c-.02,0-.04-.01-.06-.02-.02,0-.04-.01-.06-.02-.01,0-.02,0-.04-.01-.05-.01-.1-.03-.15-.04h-.02s-.09-.03-.13-.04c-.01,0-.03,0-.04,0-.05-.01-.1-.02-.15-.03h0s-.06-.01-.1-.02c-.02,0-.03,0-.05,0-.01,0-.03,0-.04,0-.05,0-.1-.01-.14-.02h0c-.05,0-.1,0-.15-.01-.01,0-.03,0-.04,0-.02,0-.05,0-.07,0-.02,0-.04,0-.07,0h0s0,0,0,0c-.06,0-.11,0-.17,0-.01,0-.02,0-.04,0-.06,0-.11,0-.17,0l-.07.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m24.89,13.04h0s.06.05.09.08h0s.03.03.04.04c0,0,0,0,.01.01,0,0,.02.01.02.02,0,0,.02.01.02.02,0,0,.01.01.02.02.01.01.02.02.04.04h.01s.02.03.03.04h.01s0,.01,0,.01h0s0,0,0,0h0s.06.06.09.09c0,0,.02.02.02.03.02.03.05.05.07.08,0,0,.01.01.02.02.03.03.06.07.08.1,0,0,0,.01.01.02.02.03.05.06.07.09,0,0,.01.02.02.03.02.03.05.07.07.1h0s.05.08.08.12c0,0,0,.01.01.02.02.03.04.06.06.1,0,0,0,.01.01.02.02.04.05.08.07.12h0s.1-1.27.1-1.27h0s-.01-.01-.01-.01h-.01s-.06-.08-.09-.11c0,0-.02-.02-.03-.03-.04-.04-.07-.08-.11-.11,0,0-.01-.01-.02-.02-.03-.03-.07-.06-.1-.1,0,0-.02-.02-.03-.03-.04-.04-.08-.07-.12-.11h0s-.07-.07-.11-.1c-.01,0-.02-.02-.03-.03-.01-.01-.03-.02-.04-.03-.03-.02-.05-.04-.08-.06h0s-.08-.07-.13-.1c-.01,0-.02-.02-.03-.02-.03-.02-.07-.04-.1-.07l-.08.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m25.5,19.24h0c-.33.41-.73.76-1.2,1.03l-.08.97s.05-.02.07-.03c.05-.02.09-.04.14-.06.01,0,.03-.01.04-.02.03-.02.07-.03.1-.05.01,0,.02-.01.04-.02.04-.02.08-.05.13-.07h0s.09-.06.14-.08h0s.08-.06.12-.09h.01c.13-.1.26-.19.38-.3l.1-1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m18.92,13.07c-.06.07-.12.13-.18.2-.15.18-.29.38-.41.58h0c-.12.22-.23.44-.32.67-.01.03-.02.06-.03.09-.16.43-.26.87-.29,1.33-.03.41,0,.83.08,1.24.01.07.03.13.05.2-.01-.15-.02-.31-.03-.46,0-.32,0-.64.05-.96.02-.12.04-.24.06-.35.07-.34.17-.68.3-1.01.03-.09.07-.17.11-.25.06-.13.12-.26.19-.38.11-.21.24-.4.38-.59.01-.02.03-.03.04-.05.27-.36.59-.68.94-.97-.34.19-.65.44-.92.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 22.11,
    cy: 16.42,
    r: 3.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m24.14,14.37c.02.05-.05.14-.17.19l-1.85.84c-.12.05-.26.12-.31.15-.05.03-.17.02-.16-.11l.11-1.16c.01-.13.13-.22.26-.21l1.85.18c.13.01.25.07.28.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m21.32,14.01c.06,0,.09.12.08.24l-.2,2.02c-.01.13-.02.23-.02.23,0,0,0,.05,0,.11,0,.06-.07.16-.18.09l-.95-.68c-.11-.08-.13-.22-.05-.33l1.08-1.51c.08-.11.18-.19.24-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m19.6,16.26s.15-.02.25.05l1.65,1.18c.11.08.19.14.19.14,0,0,.04.03.1.06.05.03.1.14-.01.19l-1.06.48c-.12.05-.26,0-.31-.12l-.77-1.69c-.05-.12-.07-.25-.04-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m20.69,18.89c-.02-.05.05-.14.17-.19l1.85-.84c.12-.05.22-.1.22-.1h0l.1-.05c.1-.07.17-.03.16.1l-.11,1.16c-.01.13-.13.22-.26.21l-1.85-.18c-.13-.01-.25-.07-.28-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m23.5,19.25c-.06,0-.09-.12-.08-.24l.2-2.02c.01-.13.02-.23.02-.23,0,0,0-.05,0-.11,0-.06.07-.16.18-.09l.95.68c.11.08.13.22.05.33l-1.08,1.51c-.08.11-.18.19-.24.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m25.23,17s-.15.02-.25-.05l-1.65-1.18c-.11-.08-.19-.14-.19-.14,0,0-.04-.03-.1-.06-.05-.03-.1-.14.01-.19l1.06-.48c.12-.05.26,0,.31.12l.77,1.69c.05.12.07.25.04.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m22.07,15.88c-.44.2-.64.73-.44,1.17s.73.64,1.17.44h0c.13-.06.23-.14.31-.24-.19.06-.4-.03-.48-.22-.09-.2,0-.44.2-.53.17-.08.37-.02.48.12,0-.1-.03-.21-.08-.31-.2-.44-.73-.64-1.17-.44Zm.04.9c-.1.04-.21,0-.26-.1s0-.21.1-.26.21,0,.26.1,0,.21-.1.26Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 22.04,
    cy: 16.6,
    r: 0.23
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.84,8.33h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.43,8.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.67,17.73h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.97,9.24l1.52-.91c-.15.07-.29.14-.43.21-.38.2-.74.44-1.09.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.35,11h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.06,8.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.82,17.88h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.25,8.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.66,8.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.78,16.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.06,16.87v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.86,16.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.54,17.57h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.49,15.4v-.03s0,.03,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.42,13.36s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.39,13.6h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.4,13.48v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.45,15.23s0-.03,0-.04c0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.38,13.72h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.02,8.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.97,19.42h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "47.73 14.59 47.73 14.59 47.73 14.59 47.73 14.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.03,19.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.4,19.32h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "47.74 12.79 47.74 12.77 47.74 12.77 47.74 12.78 47.74 12.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "47.43 11.66 47.44 11.68 47.43 11.66 47.43 11.66 47.43 11.66 47.43 11.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.71,12.63h0s0,.04.01.06c0-.02,0-.04-.01-.06,0-.01,0-.02,0-.04,0,.01,0,.02,0,.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.52,18.24s-.02.01-.03.02c0,0,.02-.01.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.37,11.5s0-.02-.01-.03c-.02-.05-.05-.11-.07-.16.03.05.05.1.07.16,0,0,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.62,12.21h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.51,11.88s.03.09.05.14v.03s0,0,0,0h0s.02.06.02.08h0s-.02-.05-.03-.08v-.03s-.04-.09-.06-.14c0-.01,0-.03-.01-.04-.02-.05-.04-.11-.06-.16.02.05.04.11.06.16,0,.01,0,.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.35,15.87s0,.02-.01.03c0-.01,0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.55,15.32s0,.03-.01.04c0-.01,0-.03.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.49,15.52h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.66,14.94s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.6,15.15s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.42,15.7s0,.02-.01.03c0-.01,0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.7,14.76s0,.03,0,.05c0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.68,18.11h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46,17.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.85,17.97l-.02.02.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.16,17.66h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.78,14.25s0-.05,0-.07h0s0,0,0,0c0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.44,10.41s.06-.09.09-.13c-.03.04-.06.09-.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.04,7.41s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.32,10.6c.03-.05.07-.11.1-.16-.04.05-.07.11-.1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.55,10.26s.07-.1.11-.14c-.04.05-.07.1-.11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.62,12.06s.03-.09.05-.13c-.02.04-.03.09-.05.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.55,12.25s.03-.09.04-.13c-.01.04-.03.09-.04.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.66,10.11c.04-.05.08-.1.12-.15-.04.05-.08.1-.12.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.56,7.31s.04,0,.06.01c-.02,0-.04,0-.06-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.72,7.34s.04,0,.07.01c-.02,0-.04,0-.07-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.88,7.37s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.4,7.28h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.64,7.26c.16-.02.32-.03.49-.04-.16,0-.32.02-.49.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.97,18.04h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.46,12.55c.02-.09.05-.17.07-.26-.03.09-.05.17-.07.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.51,16.11c-.02-.08-.04-.15-.06-.23.02.08.04.15.06.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36,17.29s-.04-.07-.06-.11c.02.04.04.07.06.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.44,15.88c-.02-.08-.04-.16-.06-.24.02.08.04.16.06.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.42,12.74s.02-.09.03-.13c-.01.04-.02.09-.03.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.23,17.69s-.02-.04-.04-.06c.01.02.02.04.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.12,17.51s-.03-.04-.04-.07c.01.02.03.04.04.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.25,14.62s0-.09,0-.14c0,.05,0,.09,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.29,13.44s.01-.09.02-.14c0,.05-.01.09-.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.24,14.27c0-.09,0-.19,0-.28,0,.09,0,.19,0,.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.34,13.09c.02-.1.04-.19.06-.29-.02.1-.04.19-.06.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.32,13.24s.01-.09.02-.14c0,.05-.02.09-.02.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.25,13.93s0-.09,0-.14c0,.05,0,.09,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.26,13.74c0-.09.02-.18.03-.28-.01.09-.02.18-.03.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.16,7.33c.16-.03.32-.05.48-.07-.16.02-.32.04-.48.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.18,20.14c-.07-.03-.13-.06-.2-.08.07.03.13.06.2.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.98,20.05c-.06-.03-.12-.05-.17-.08.06.03.12.06.17.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.54,18.13s.02.02.03.03c.03.03.05.07.08.1-.03-.03-.05-.07-.08-.1,0-.01-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.71,9.83c.04.06.09.12.13.19-.04-.06-.09-.12-.13-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.38,20.22c-.06-.02-.12-.05-.18-.07.06.02.12.05.18.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.39,20.63c-.05,0-.11,0-.16,0,.05,0,.11,0,.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.76,19.95s-.09-.05-.14-.07c.05.02.09.05.14.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.66,18.59h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.75,18.39s.03.03.05.05c.02.02.03.04.05.06-.02-.02-.03-.04-.05-.06-.02-.02-.03-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.3,18.33h-.02s.02,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.6,19.21s-.05-.04-.07-.06c-.02-.02-.04-.03-.06-.05.02.02.04.03.06.05.02.02.05.04.07.06.02.02.04.03.06.05.03.02.05.04.08.06-.03-.02-.05-.04-.08-.06-.02-.02-.04-.03-.06-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.25,18.91s.01.01.02.02c.01.01.02.02.03.03-.01-.01-.02-.02-.03-.03,0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.97,18.64s-.02-.02-.03-.04c.01.01.02.03.03.04.02.02.03.04.05.05.02.02.04.05.07.07-.02-.02-.04-.04-.07-.07-.02-.02-.03-.04-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.77,8.1h0c.06.03.12.07.18.11-.06-.04-.12-.07-.18-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.66,7.59s.05.02.07.02c-.02,0-.05-.02-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.81,7.65s.05.02.07.03c-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.15,9.17c.05.05.1.11.15.16-.05-.05-.1-.11-.15-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.96,7.71s.05.02.07.03c-.02,0-.05-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.35,7.49s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.5,7.54s.05.02.07.02c-.02,0-.05-.02-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.12,7.77s.04.02.07.03c-.02,0-.04-.02-.07-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.58,8.66c.13.1.25.21.37.33-.12-.11-.24-.22-.37-.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.19,7.45s.05.01.07.02c-.02,0-.05-.01-.07-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.96,8.98c.05.05.1.1.16.15-.05-.05-.1-.1-.16-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.42,7.91s.04.02.06.03c-.02-.01-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.58,7.99s.03.02.05.03c-.02,0-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.27,7.84s.04.02.06.03c-.02-.01-.04-.02-.06-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m35.24,14.43s0-.09,0-.14c0,.05,0,.09,0,.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.79,13.21s0,.1,0,.15v.02s0,0,0,0v.02s0,0,0,0h0c0,.05,0,.1,0,.16h0s0,0,0,0c0,.02,0,.03,0,.05h0s0,.06,0,.09c0,.03,0,.06,0,.09h0c0,.06,0,.12,0,.18h0s0,.03,0,.04l1.12-.67v-.03s0-.03,0-.03c0-.07,0-.14-.01-.21,0-.02,0-.04,0-.05,0-.06-.01-.12-.02-.18,0-.01,0-.02,0-.04,0-.04,0-.07-.02-.11l-1.06.64s0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.94,11.72h0s0,.02-.01.02c0,0,0-.01.01-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.59 12.62 36.58 12.63 36.59 12.62 36.59 12.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.91,14.02s0-.04,0-.06c0-.02,0-.04,0-.07,0,.02,0,.04,0,.07,0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.74,15.15v.02s0-.02,0-.02c.01-.06.03-.12.04-.18,0-.02,0-.03.01-.05,0,.02,0,.03-.01.05-.01.06-.03.12-.04.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.08,11.44h0s0,0,0,0c0,.01-.01.03-.02.04,0-.01.01-.03.02-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.26,11.14h0s-.05.08-.08.13c.03-.04.05-.08.08-.13h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "48.84 12.55 48.84 12.55 48.84 12.52 48.84 12.55 48.84 12.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.6,9.32h0s0,0,0,0c-.01,0-.03-.02-.04-.03.01,0,.03.02.04.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.48,13.02s0-.02,0-.03c0,.04-.02.08-.03.12,0-.03.01-.06.02-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.45,13.2h0s0,.03,0,.04c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.53,12.84c-.01.05-.02.1-.04.15h0s0,0,0,0c.01-.05.02-.1.04-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.63,11.66h0s-.02-.07-.03-.09c0,.03.02.05.03.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.54,12.8h0s0,.03-.01.04c0-.01,0-.03.01-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.3,10.81h0s-.04-.09-.06-.13c.02.04.04.08.06.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.81,10.52s.02.02.03.04c0-.01-.02-.02-.03-.04-.02-.02-.03-.05-.05-.07h0s.03.05.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.97,10.22s-.02-.03-.03-.05c-.02-.03-.03-.05-.05-.08.02.03.03.05.05.08,0,.02.02.03.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.75,19.46s-.08.01-.12.02c-.21.03-.42.05-.63.06-.04,0-.07,0-.11,0-.13,0-.27,0-.4,0l-1.47.88c-.21-.05-.41-.12-.61-.19.59.22,1.2.35,1.82.39-.12,0-.23-.02-.34-.03l1.87-1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.3,19.69l1.12-.67c-.14-.07-.29-.14-.43-.22-.05-.03-.11-.06-.16-.1l-1.06.64s.02.02.03.02c.03.02.05.04.08.06.02.01.04.03.06.04.03.02.06.04.09.06.02.01.04.03.06.04.03.02.07.04.1.06.02.01.03.02.05.03.05.03.1.06.15.09.06.03.12.07.18.1-.06-.03-.12-.06-.18-.1-.03-.02-.06-.04-.09-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.73,10.41h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.84,10.56h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.18,11.12h0s.01.03.02.04c0-.01-.01-.03-.02-.04v-.02s0,.02,0,.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "47.1 10.97 47.1 10.97 47.1 10.97 47.1 10.97 47.1 10.97 47.09 10.95 47.1 10.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.11,9.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.83,9.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.67,9.37s.02.01.03.02c0,0-.02-.01-.03-.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.41,16.16v-.02s.02-.03.03-.05c0,.02-.01.03-.02.05v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.94,9.59h0s.04.03.06.05c.02.01.03.03.05.04.02.01.03.03.05.04h0s-.03-.03-.05-.04c-.02-.01-.03-.03-.05-.04-.02-.02-.04-.03-.06-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.89,9.55s.03.03.05.04c-.02-.01-.03-.03-.05-.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m47.06,16.46c-.05.09-.1.17-.15.25-.1.15-.2.3-.31.45l1.87-1.12s-.01.03-.02.05c.02-.06.04-.11.07-.17,0-.01.01-.03.02-.04.02-.07.05-.14.07-.21,0-.02,0-.03.01-.05.02-.06.04-.11.05-.17,0-.02,0-.03.01-.05.02-.07.04-.14.05-.21l-1.47.88c-.06.13-.13.25-.2.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m48.21,16.6s-.03.06-.04.08l-2.84,1.7c-.27.2-.55.37-.85.51-.02,0-.03.02-.05.02l-2.85,1.71c-.06,0-.12,0-.17,0,2.48.12,5-1.11,6.44-3.37.04-.07.08-.13.12-.2.01-.02.02-.03.03-.05.03-.06.07-.12.1-.18v-.02c.05-.07.08-.13.11-.2,0-.02.02-.03.03-.05.02-.04.04-.08.05-.12-.02.04-.04.08-.05.12,0,.02-.02.03-.03.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "46.89 10.63 46.89 10.64 46.89 10.63 46.89 10.63 46.89 10.63 46.89 10.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m38.96,8.37c.52-.32,1.09-.56,1.68-.72l.52-.31c-1.68.31-3.26,1.22-4.38,2.63l.89-.54c.37-.41.81-.77,1.29-1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.84,8.87c.11.05.22.11.33.18h.02s.04.03.05.04c.02.01.04.02.06.04.01,0,.03.02.04.03.03.02.06.04.08.05.02.01.03.02.05.03h0s0,0,0,0h.01s.03.03.05.04l1.05-.63c-.2-.16-.41-.31-.63-.45l-1.11.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.38,14.77h0s0-.06,0-.08h0s0-.01,0-.01h0s0-.03,0-.04c0-.03,0-.05,0-.08,0-.01,0-.03,0-.04v-.02s0-.02,0-.02h0s0-.03,0-.04v-.02s0-.02,0-.03c0-.01,0-.03,0-.04v-.02s0-.02,0-.04v-.02s0-.05,0-.08v-.02s0-.01,0-.01h0s0-.02,0-.02c0-.04,0-.08,0-.11h0s0-.04,0-.06h0s0-.02,0-.02l-1.11.67c.02.34.07.68.14,1.01-.02-.08-.03-.16-.05-.24l1.04-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.71,7.44c.12,0,.24.02.36.04l.33-.2c-.42-.06-.85-.08-1.27-.06l-.38.23c.32-.02.64-.03.96,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.34,17.86h0s0,0,0,0c.01.02.02.03.04.05-.01-.02-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m36.7,16.11v-.02s0,0,0,0c0-.01,0-.03-.01-.04v-.02s-.03-.06-.04-.09c0-.01,0-.02-.01-.03v-.02s-.02-.03-.02-.03c0-.02-.01-.04-.02-.06v-.03s-.01-.01-.01-.01l-.99.6c-.03-.08-.05-.15-.07-.23.1.35.24.68.4,1-.07-.14-.13-.28-.19-.42l.98-.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m37.46,10.85c1.01-1.41,2.54-2.28,4.15-2.49h0s1.18-.71,1.18-.71c-.03,0-.06,0-.09,0-.32,0-.63.01-.95.05-.19.02-.38.05-.57.09l-4.97,2.98h0c-.22.38-.41.76-.56,1.16l1.79-1.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m46.26,9.88s-.03-.03-.05-.04c-.02-.02-.04-.04-.06-.05.02.02.04.04.06.05.02.01.03.03.05.04.02.02.04.04.06.06.01.01.03.03.04.04h0s0,0,0,0c.02.02.04.04.05.06h0s0,0,0,0c.01.01.03.03.04.04.02.02.04.04.06.06.01.01.02.03.04.04.02.02.04.05.06.07.01.01.02.02.03.04-.01-.01-.02-.02-.03-.04-.02-.02-.03-.04-.05-.06l.98-.59c.05.06.09.12.14.18-.12-.16-.24-.31-.38-.46l-.99.6s-.03-.03-.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.43,18.92s.03-.02.05-.02c-.02,0-.03.02-.05.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 45.67,
    y: 18.12,
    width: 0,
    height: 0,
    transform: "translate(-.96 33.61) rotate(-40.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.44,15.18s0,.03,0,.04h0s0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 46.15,
    y: 17.67,
    width: 0,
    height: 0,
    transform: "translate(1.5 38.84) rotate(-46.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.04,13.3s0,.02-.01.02h0s0-.01.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.83,17.98l.02-.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.49,18.27s.02-.01.03-.02h0s-.02.01-.03.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.33,18.39h0c-.27.2-.55.37-.85.51.29-.15.58-.32.85-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.81,13.6s0,.06,0,.09c0-.03,0-.06,0-.09v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45,13.38s-.01.02-.02.03h0s.01-.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.96,14.49s-.01-.01-.02-.02c0,0,.02.01.03.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.9,14.44s.02.01.03.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42,14.52l-.02-.02s.02.01.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.1,14.62s.01.01.02.02c0,0-.01-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.03,14.55s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.06,14.58s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.14,14.68h0s.01,0,.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.96,13.45s-.02.03-.02.04h0s.02-.03.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.92,13.52s-.03.05-.04.07h0s.03-.05.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.83,14.4s.03.02.05.03c-.01,0-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.38,14.76s0-.05,0-.07c0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 44.02,
    y: 19.1,
    width: 0,
    height: 0,
    transform: "translate(-3.95 17.8) rotate(-21.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.63,10.98h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 46,
    y: 17.82,
    width: 0,
    height: 0,
    transform: "translate(.86 37.71) rotate(-44.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.18,12.84s0,.03,0,.04h0s0-.02.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.2,12.77s0,.02,0,.03h0s0-.01,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.73,14.58h0s0,0,0,0h0s0,0,0,0v-.02s.01-.04.01-.06v-.02s0,.06,0,.08c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.21,12.69v.02s0,.01,0,.01c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.11 13.11 45.11 13.12 45.11 13.11 45.11 13.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.12 13.08 45.12 13.08 45.12 13.09 45.12 13.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.8,14s0,.09-.01.13c0-.04,0-.09.01-.13,0-.02,0-.03,0-.05h0s0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.22,12.61h0s0,.03,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.77,14.32s0-.03,0-.04c0,0,0-.02,0-.03,0,.02,0,.05,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.77,12.97v.02s0,.02,0,.03c0-.01,0-.02,0-.03v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.14,13.03v.02s0-.03,0-.05c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.49,19.53c.13,0,.27,0,.4,0-.13,0-.27,0-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.63,19.48c-.21.03-.42.05-.63.06.21,0,.42-.03.63-.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "42.95 19.42 42.97 19.42 42.95 19.42 42.95 19.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.75,19.46h0s-.08.01-.12.02c.04,0,.08-.01.12-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 43.39,
    y: 19.32,
    width: 0.01,
    height: 0,
    transform: "translate(-3.56 12.13) rotate(-15.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.08 13.2 45.08 13.2 45.08 13.2 45.08 13.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "47.37 11.52 47.37 11.52 47.36 11.49 47.37 11.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.22 12.59 45.22 12.59 45.22 12.58 45.22 12.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.07 13.23 45.06 13.24 45.06 13.25 45.07 13.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.22 12.53 45.22 12.54 45.22 12.56 45.22 12.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "41.72 14.33 41.72 14.33 41.74 14.34 41.72 14.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.1 13.15 45.09 13.16 45.09 13.17 45.1 13.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.17,15.4s0,.04,0,.06c0-.02,0-.04,0-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m37.03,11.54s-.01.02-.02.03c0,0,0-.02.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.45,13.2s0,.03,0,.04c0,.01,0,.02,0,.04v-.02s.01-.04.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.31,14.86s.02-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 36.87,
    y: 11.85,
    width: 0,
    height: 0.02,
    transform: "translate(12.34 41.82) rotate(-68.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.18,15.47s0,.02,0,.03v.02s0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.31,15.87s.02.03.03.04h0s-.02-.02-.03-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.2,15.61s0,.02,0,.04v.02s0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.19,15.54s0,.04.01.06c0-.02,0-.04-.01-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.22,15.68s.01.04.02.06h0s-.01-.04-.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.28,15.83s.02.03.02.04c-.01-.02-.02-.04-.03-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.25,15.75s.02.04.02.05c0-.02-.02-.04-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.48,13.03h0s0-.01,0-.01c0,.03-.01.06-.02.09v.02s0-.06.02-.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.42,13.35s0-.02,0-.03h0s0,.02,0,.03c0,.01,0,.02,0,.03h0s0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.36 14.49 36.36 14.51 36.36 14.5 36.36 14.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.36 14.16 36.36 14.16 36.36 14.16 36.36 14.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.36,14.35s0,.03,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.36 14.42 36.36 14.44 36.36 14.43 36.36 14.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.36,14.19s0,.05,0,.08c0-.02,0-.04,0-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.36,14.12s0-.02,0-.03c0-.02,0-.04,0-.05,0,.04,0,.08,0,.11v-.02s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.41,13.43h0s0,.02,0,.03v.02s0,0,0,0c0-.01,0-.02,0-.03,0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.39,13.55s0,.02,0,.03h0s0,.02,0,.02c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.38,13.7h0s0,.02,0,.02v.02s0,0,0,0c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.36,13.98s0,.03,0,.05v-.02s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 37.67,
    y: 17.72,
    width: 0,
    height: 0,
    transform: "translate(-2.31 29.33) rotate(-41.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 36.48,
    y: 15.37,
    width: 0,
    height: 0.03,
    transform: "translate(-2.45 8.17) rotate(-12.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 37.82,
    y: 17.88,
    width: 0,
    height: 0,
    transform: "translate(-1.72 31.54) rotate(-44.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "41.47 14.13 41.46 14.12 41.47 14.14 41.47 14.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "38.29 18.31 38.3 18.33 38.3 18.33 38.29 18.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.38,14.05s-.01-.01-.02-.02c0,.01.02.02.03.03h-.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 37.97,
    y: 18.02,
    width: 0,
    height: 0.02,
    transform: "translate(-1.39 32.79) rotate(-45.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 36.78,
    y: 16.3,
    width: 0,
    height: 0,
    transform: "translate(-3.45 15.86) rotate(-23.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "41.64 14.28 41.64 14.27 41.64 14.28 41.64 14.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.55,14.2h-.01s.01,0,.02,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "37.53 17.56 37.54 17.57 37.54 17.57 37.53 17.56"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 37.06,
    y: 16.86,
    width: 0,
    height: 0.02,
    transform: "translate(-3.49 20.55) rotate(-29.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.24,15.02s-.01.04-.02.06c0-.02.01-.04.02-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.19,15.17v.02s0,.02,0,.03c0-.02,0-.04,0-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.21,15.09h0s-.01.05-.01.07c0-.02,0-.04.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.18,15.32s0,.04,0,.05c0-.02,0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.18,15.24s0,.04,0,.07c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.22,12.51h0s0-.01,0-.02v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.25,13.9h0s-.02-.03-.03-.04c0,.01.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.27,14.94s-.01.03-.02.05h0s.02-.03.03-.05Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 38.65,
    y: 18.58,
    width: 0,
    height: 0.02,
    transform: "translate(1.49 39.99) rotate(-55.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.32,13.98h0s-.01-.03-.02-.03h0s.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m40.27,14.93s.02-.04.03-.06c-.01.02-.02.04-.03.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "36.61 15.86 36.62 15.89 36.62 15.89 36.61 15.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.37,14.63v-.02s0-.04,0-.05c0,.03,0,.05,0,.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.36,14.59s0,.03.01.05c0-.02-.01-.05-.02-.07h0s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.38,14.66s.02.06.02.09c0-.03-.01-.06-.02-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.44,14.93h0s0-.04-.01-.07c0,.02,0,.04,0,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.45,15.02v.02s0-.06,0-.09c0,.02,0,.04,0,.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.45,15.38s0,.05,0,.07c0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.44,15.48s0,.06-.01.09c0-.03,0-.06.01-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.41,14.76s0,.05.01.07c0-.02,0-.05-.01-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.46,15.26s0,.06,0,.09c0-.03,0-.06,0-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.21,12.23s0,.03,0,.05c0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "43.32 14.48 43.32 14.47 43.32 14.48 43.32 14.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.76,11.71s.02.01.02.02c0,0-.02-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.22,12.36h0s0-.03,0-.05c0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.29,14.4s0-.02-.01-.03v.02s.01.01.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.31,14.45s-.01-.03-.02-.05v.02s.02.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.42,15.59s-.01.05-.02.08c0-.03.01-.05.02-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.8,11.75s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.35,14.54s-.01-.03-.02-.05v.02s.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.83,11.79s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.33,15.94s0,.02-.01.03c0-.02.02-.05.03-.07,0,.01,0,.03-.01.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.46,15.21s0,.04,0,.05c0-.03,0-.06,0-.09,0,0,0,.02,0,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.15,12.97s0-.03.01-.05c0,.02,0,.03-.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.11,12s-.02.04-.03.06h0s.02-.04.04-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.1,11.72s.01.03.02.05c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.22,12.43h0s0-.02,0-.04c0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.22 12.46 45.22 12.46 45.22 12.47 45.22 12.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.04,11.57s.01.03.02.05c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.91,11.33s.01.02.02.03h0s.01.03.02.04c-.01-.02-.03-.05-.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.94,16.62s-.07.08-.11.12c.04-.04.08-.08.11-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.3,16s-.02.05-.03.08c.01-.03.02-.05.03-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.27,16.1s-.03.06-.04.09c.01-.03.03-.06.04-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.38,15.79s-.02.06-.03.09c0-.03.02-.06.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.91,11.88h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.45,15.12v.03s0-.05,0-.07c0,.01,0,.02,0,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.4,15.7s-.01.05-.02.07c0-.02.01-.05.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.21,16.21s-.02.05-.04.07c.01-.02.02-.05.04-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.16,16.3s-.03.06-.05.09c.02-.03.04-.06.05-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.26,14.33h0s-.02-.03-.03-.05v.02s.02.02.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.05,12.12h0s0,.02,0,.02c0-.01.01-.03.02-.04,0,0,0,.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.99,12.87s-.01-.04-.01-.05c0,.02,0,.04.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.15,11.87s0,.02,0,.04h0s0-.02-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.97,12.81s0-.04-.01-.06c0,.02,0,.04.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.59,15.8s.01.04.02.06c0-.02-.01-.04-.02-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.01,12.93h0s-.01-.03-.02-.04c0,.01,0,.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.96,12.73s0-.04,0-.05c0,.02,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.19,12.07h0s0,.04,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 42.04,
    y: 13,
    width: 0,
    height: 0,
    transform: "translate(-1.59 18.73) rotate(-24.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.95,12.47h0s0,.02,0,.02c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.95,12.66s0-.04,0-.07c0,.02,0,.04,0,.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.96,12.42s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.18 11.99 45.18 11.99 45.17 11.98 45.18 11.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.97,12.33h0s0,.02,0,.02c0-.01,0-.02,0-.03v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.18,12h0s0,.04,0,.04c0-.01,0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.69,16.09v.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.16 11.92 45.16 11.93 45.17 11.95 45.16 11.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.95,12.54h0s0,.02,0,.04c0-.02,0-.03,0-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m42.01,12.2h0s0,0,0,0c0-.01.01-.03.02-.04,0,.01,0,.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "43.18 14.18 43.17 14.16 43.17 14.17 43.18 14.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45,11.49s.02.03.02.05c0-.02-.02-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.14 11.85 45.14 11.85 45.15 11.87 45.14 11.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.07,11.64s.01.03.02.05c0-.02-.01-.03-.02-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.71,11.68s.02.01.03.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.6,11.61s.03.02.05.03c-.02-.01-.03-.02-.05-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.67,11.65s.02.01.03.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.22,14.25h0s-.03-.04-.04-.07c0,.01.01.02.02.03,0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m39.42,19.02h0c-.14-.07-.29-.14-.43-.22-.05-.03-.11-.06-.16-.1.05.03.11.06.16.1.14.08.28.15.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m36.64,15.95h0s.02.06.03.09c-.01-.03-.02-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.2,12.15h0s0,.03,0,.05c0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m41.99,12.26h0s0,.02,0,.02c0-.01,0-.02.01-.04v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m44.96,11.41h0s0,.02,0,.02c0,.01.01.03.02.04,0-.02-.02-.04-.03-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "45.19 12.06 45.19 12.06 45.19 12.06 45.19 12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m43.16,14.15s-.02-.03-.03-.05c0,0,.01.02.02.03v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m45.14,11.84h0s0-.03-.01-.04c0,.01,0,.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.1,10.97v-.02c-.41-.51-.92-.95-1.51-1.29-2.66-1.54-6.21-.6-7.91,2.09-.11.17-.2.34-.29.51,0-.01-.02-.03-.03-.05.01.02.02.03.03.05-.08.16-.15.31-.21.47,0,.02-.01.04-.02.05-.14.35-.23.71-.3,1.07.48.86,1.21,1.62,2.17,2.17.05.03.1.06.15.08,0-.01,0-.02-.01-.03,0-.01,0-.03-.01-.04,0-.01,0-.02,0-.03,0-.02,0-.03-.01-.05h0c-.01-.05-.02-.09-.03-.14h0s0-.05,0-.07v-.02s0-.04-.01-.05v-.02s0-.04,0-.06v-.02s0-.04,0-.06h0c0-.14,0-.26.02-.38h0s0-.05.01-.08h0s0-.06.01-.08h0c.03-.13.06-.26.11-.38h0c.05-.12.11-.24.19-.36l.21.12.74.43.08.12c-.22.35-.22.76-.04,1.08h0c.07.1.17.18.28.24s.23.1.35.12c.05,0,.1.01.16.01.03,0,.07,0,.1,0,.12,0,.24-.04.35-.08.03-.01.06-.03.1-.04.09-.05.18-.11.26-.19.05-.05.1-.11.14-.17.01-.02.02-.03.03-.05.09-.14.14-.3.16-.45,0-.03,0-.07,0-.1,0-.19-.04-.37-.13-.53-.08-.09-.17-.18-.28-.24-.27-.16-.49-.37-.66-.61l-.08-.12.02.02s-.01-.02-.02-.03h0s-.03-.05-.04-.07h0c-.13-.21-.22-.43-.26-.67v-.02c-.02-.09-.03-.17-.04-.26h0s0-.09,0-.13v-.02s0-.09,0-.13h0s0-.09.01-.14v-.02s.01-.08.02-.11c0,0,0-.02,0-.03.05-.25.15-.51.3-.74.54-.85,1.55-1.24,2.46-1.03.03,0,.05.01.08.02l.07-.1.29-.45.24.14.69.4.08.12-.34.54c.06.07.11.13.16.21h0s0,.02,0,.02c0-.02-.02-.03-.03-.04l.08.12c.45.67.49,1.57.01,2.33l-.95-.55-.08-.12h0s.03-.05.04-.07h0s.02-.06.03-.08h0s.02-.05.02-.08h0s.01-.06.02-.08h0c.01-.06.02-.11.03-.16h0s0-.06,0-.09h0s0-.06,0-.08h0s0-.05,0-.08h0c0-.06-.02-.11-.03-.16h0c-.02-.07-.05-.14-.09-.21-.07-.09-.17-.17-.28-.24-.5-.29-1.17-.11-1.49.39-.22.35-.22.76-.04,1.08v.02s.02,0,.02,0c.03.04.07.08.11.11h0s.04.04.06.06h.01s.04.04.07.05c.03.02.06.04.09.05,0,0,.02.01.03.02.02.01.04.03.06.04.01,0,.02.02.03.02.02.01.03.02.05.04.01,0,.02.02.03.03.02.01.03.03.04.04.01,0,.02.02.03.03.01.01.03.03.04.04.01.01.02.02.03.03.01.01.03.03.04.04,0,.01.02.02.03.03.01.01.03.03.04.04,0,.01.02.02.03.03.01.02.03.04.04.06.01.02.02.03.04.05,0,.01.02.02.03.04v-.02s.07.12.07.12c.46.67.49,1.58,0,2.34-.06.1-.13.19-.21.28,1.47-.22,2.79-.99,3.59-2.24.38-.59.6-1.23.68-1.88h0s0-.03,0-.03c0-.05.01-.09.01-.14,0-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0-.04,0-.08,0-.13h0c0-.06,0-.11,0-.16,0-.01,0-.03,0-.04,0-.05,0-.1,0-.15h0c0-.06,0-.11,0-.17,0-.01,0-.03,0-.04,0-.05,0-.09-.01-.14v-.02c0-.05-.01-.11-.02-.16,0-.01,0-.03,0-.04,0-.04-.01-.09-.02-.13v-.03s-.02-.05-.02-.07h0c.03.06.05.11.07.16-.01-.02-.02-.05-.04-.07-.01-.03-.03-.05-.04-.08,0-.01-.01-.03-.02-.04h0s-.01-.02-.01-.02c-.02-.04-.04-.08-.07-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m47.62,12.21s0,.03.01.04c.01.05.02.09.03.14,0,.01,0,.02,0,.04,0-.01,0-.02,0-.04-.01-.05-.02-.09-.03-.14,0-.01,0-.03-.01-.04,0-.03-.01-.05-.02-.08h0s.02.05.02.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.38,14.68h0s0,.06,0,.08h0s0,.02,0,.02c0-.03,0-.06,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m41.64,17.42c.09-.02.17-.04.26-.07-.09.03-.17.05-.26.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m40.91,17.46h0c-.06,0-.12-.01-.17-.02h0c.15.03.3.04.45.04-.09,0-.19,0-.28-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.44,15.18s0,.03,0,.04h0s0-.04-.01-.06h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "39.46 16.65 39.45 16.64 39.46 16.66 39.46 16.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "40.38 17.7 40.57 17.4 40.58 17.4 40.57 17.4 40.38 17.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.48,15.37v.03s0,0,0,0c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.36,14.28s0-.05,0-.07c0,.02,0,.04,0,.06v.02s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.36,14.36s0,.02,0,.03c0,.01,0,.02,0,.03h0s0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m40.66,17.42h0s.05.01.08.02h0s-.05-.01-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.64,15.95s.02.06.03.09c-.01-.03-.02-.06-.03-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.41,15h0s0,.04,0,.05c0-.02,0-.04,0-.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.43,13.27h0s0-.01,0-.02v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "36.39 13.55 36.39 13.55 36.39 13.56 36.39 13.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m37.41,17.4h-.01s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.42,13.38h0s0,.03,0,.04h0s0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m40.23,17.93l.06-.1-.06.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "36.37 13.74 36.37 13.75 36.38 13.73 36.37 13.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.36,14.13v.02s0,.02,0,.02h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.36,14.5h0s0,.04,0,.05c0,.02,0,.04,0,.05,0-.04,0-.07,0-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m39.64,16.86h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "39.51 16.71 39.51 16.71 39.52 16.73 39.51 16.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "36.78 16.3 36.78 16.31 36.78 16.32 36.77 16.29 36.78 16.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m41.55,17.44c-.09.02-.18.03-.27.03.09,0,.18-.02.27-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "37.16 17.04 37.17 17.05 37.16 17.05 37.16 17.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "36.48 13.04 36.48 13.03 36.48 13.03 36.48 13.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.62,15.89s-.02-.06-.03-.09c0,.02.01.04.02.06v.03s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m39.42,19.02h0c.66.31,1.36.47,2.07.51.13,0,.27,0,.4,0,.04,0,.07,0,.11,0,.21,0,.42-.03.63-.06.04,0,.08-.01.12-.02.07-.01.14-.02.21-.04h.02c.14-.03.28-.07.41-.1h.01c.21-.06.42-.13.62-.22h0c.14-.06.27-.12.41-.18.02,0,.03-.02.05-.02.29-.15.58-.32.85-.51.05-.04.11-.08.16-.12,0,0,.02-.01.03-.02.05-.04.1-.08.16-.13h0c.05-.05.1-.09.15-.14l.02-.02c.05-.05.1-.09.15-.14h0c.05-.05.1-.1.15-.15h0c.15-.16.3-.33.44-.51.11-.14.21-.29.31-.45.05-.08.1-.17.15-.25.07-.13.14-.25.2-.38h0c.03-.06.05-.11.08-.17,0-.01,0-.02.01-.03.02-.05.04-.09.06-.14,0-.01,0-.02.01-.03.02-.06.04-.11.06-.17h0c.02-.06.04-.11.05-.17,0-.01,0-.03.01-.04.01-.05.03-.1.04-.14,0,0,0-.02,0-.03.02-.06.03-.11.04-.17,0-.01,0-.03,0-.04.01-.04.02-.09.03-.13,0-.02,0-.03,0-.05.01-.06.02-.11.03-.17h0s0,0,0,0h0s0-.02,0-.03c0-.03,0-.06.01-.08,0-.02,0-.05.01-.07,0-.01,0-.03,0-.04,0-.01,0-.03,0-.04,0-.02,0-.05,0-.07,0-.02,0-.05,0-.07h0s0-.04,0-.05c0-.04,0-.09.01-.13,0-.02,0-.03,0-.05,0-.06,0-.11,0-.17h0s0-.07,0-.09c0-.03,0-.06,0-.09v-.02s0-.02,0-.02h0c0-.05,0-.1,0-.16h0s0-.02,0-.02v-.02s0-.1-.01-.15c0-.01,0-.03,0-.04v-.03s-.01-.08-.02-.12c0-.01,0-.02,0-.03v-.02s0-.02,0-.03c0-.04-.01-.08-.02-.12,0-.01,0-.03,0-.04h0s0-.06-.01-.09c0-.02,0-.04-.01-.06h0s0-.02,0-.04c-.01-.05-.02-.1-.03-.15v-.02s0-.02-.01-.04c-.01-.05-.02-.09-.03-.14,0-.01,0-.03-.01-.04,0-.03-.02-.05-.02-.08,0-.03-.02-.06-.02-.08h0s0-.03,0-.03c-.01-.05-.03-.09-.05-.14,0-.01,0-.03-.01-.04-.02-.05-.04-.11-.06-.16v-.02s0,0,0,0c-.02-.05-.04-.09-.06-.14v-.02s-.02-.02-.02-.02c-.02-.05-.05-.1-.07-.16h0c-.02-.06-.05-.11-.07-.16h0s.01.04.01.06v.03s.02.09.03.13c0,.01,0,.03,0,.04,0,.05.01.11.02.16v.02s.01.09.01.14c0,.01,0,.03,0,.04,0,.05,0,.11,0,.16h0c0,.06,0,.11,0,.16,0,.01,0,.03,0,.04,0,.05,0,.1,0,.15h0c0,.05,0,.1,0,.14,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,.05,0,.09-.01.14v.02s0,0,0,0c-.08.65-.31,1.29-.68,1.88-.8,1.25-2.13,2.02-3.59,2.24-.58.67-1.5.95-2.33.72l-.35.56-.93-.54-.08-.12h0s.34-.54.34-.54c-.05-.06-.1-.12-.14-.18l-.08-.12h0s0,0,0,0c0-.01-.02-.03-.03-.04,0,0-.01-.02-.02-.03,0-.02-.02-.03-.03-.05v-.02s-.04-.05-.05-.07c0,0,0-.02-.01-.03,0-.01-.01-.03-.02-.04,0-.01-.01-.02-.02-.03,0-.01-.01-.03-.02-.04,0-.01-.01-.02-.02-.04,0-.01,0-.02-.01-.04,0-.01,0-.03-.01-.04h0c-.05-.03-.1-.06-.15-.08-.96-.55-1.69-1.31-2.17-2.17-.22,1.27,0,2.57.64,3.65.01.02.03.04.04.05h0c.04.06.08.11.13.16h0c.05.06.09.11.14.16h0s.1.1.14.14h.01c.1.11.2.2.31.29h.02c.11.1.22.19.34.27h.02c.06.05.12.09.18.13.05.03.11.06.16.1.14.08.28.15.43.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.96,16.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.36,14.02h0s0,0,0,0h0s0,.05,0,.06c0-.02,0-.04,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.37,14.63h0s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m42.75,16.83c-.06.06-.12.11-.19.16.07-.05.13-.1.19-.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m42.51,17.02s-.08.06-.13.09c.04-.03.09-.06.13-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m42.26,17.18c-.09.05-.18.09-.28.13.1-.04.19-.08.28-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m37.05,16.86v.02s.01,0,.01,0c0,0-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.53,15.58h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m36.7,16.11h0v.02s0-.02,0-.03v.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "39.57 16.78 39.56 16.78 39.58 16.79 39.57 16.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m48.24,10.6l-.41-.61v.02s.01,0,.01,0c.02.03.03.05.05.08.02.03.03.05.05.08,0,.02.02.03.03.05.04.06.07.12.11.18h0c.03.07.06.12.09.18,0,.02.02.03.03.05.01.02.02.04.03.06.02.04.04.08.06.12h0c.03.07.06.14.09.2,0,.02.01.03.02.05.02.06.05.11.07.17v.03c.04.06.06.13.08.19,0,.02.01.03.02.05,0,.03.02.05.03.08,0,.03.02.05.03.08h0s0,.04,0,.04c.02.07.04.13.06.2,0,.02,0,.03.01.05.01.05.03.11.04.17,0,.01,0,.03.01.04.02.07.03.13.04.2,0,.01,0,.03,0,.04,0,.05.02.09.02.14v.03s0,0,0,0c0,.01,0,.03,0,.04,0,.03,0,.06.01.1,0,.04.01.07.02.11,0,.01,0,.02,0,.04,0,.06.01.12.02.18,0,.02,0,.04,0,.05,0,.07.01.14.01.21v.03s0,.03,0,.03c0,.05,0,.11,0,.16,0,.02,0,.04,0,.05,0,.07,0,.14,0,.21h0c0,.05,0,.1,0,.15,0,.02,0,.04,0,.07,0,.02,0,.04,0,.06,0,.07,0,.13-.02.2v.02c0,.07-.02.14-.03.21,0,.02,0,.04,0,.05,0,.06-.02.12-.03.18,0,.01,0,.02,0,.03-.01.07-.03.14-.04.21,0,.02,0,.03-.01.05-.01.06-.03.12-.04.18v.02s0,.02,0,.02h0c-.02.07-.04.14-.05.21,0,.02,0,.03-.01.05-.02.06-.03.12-.05.17,0,.02,0,.03-.01.05-.02.07-.05.14-.07.21,0,.01-.01.03-.02.04-.02.06-.04.11-.07.17,0,.02-.01.03-.02.05v.02c-.03.06-.06.12-.09.18,0,.01-.01.02-.02.03,0,.02-.02.04-.03.06-.02.04-.04.08-.05.12,0,.02-.02.03-.03.05-.03.07-.07.13-.1.2v.02c-.04.06-.08.12-.11.18-.01.02-.02.03-.03.05-.04.07-.08.13-.12.2-1.44,2.27-3.96,3.49-6.44,3.37h-.02c-.05,0-.11,0-.16-.01h0c-.62-.05-1.23-.18-1.82-.39h-.02c-.06-.03-.12-.05-.18-.08h-.01c-.07-.03-.13-.06-.2-.09h0c-.06-.03-.12-.06-.17-.08-.02,0-.03-.02-.05-.02-.05-.02-.09-.05-.14-.07-.02,0-.03-.02-.05-.03-.06-.03-.12-.06-.18-.1-.05-.03-.1-.06-.15-.09-.02-.01-.03-.02-.05-.03-.03-.02-.07-.04-.1-.06-.02-.01-.04-.03-.06-.04-.03-.02-.06-.04-.09-.06-.02-.01-.04-.03-.06-.04-.03-.02-.05-.04-.08-.06-.01,0-.02-.02-.03-.02,0,0-.02-.01-.03-.02-.03-.02-.05-.04-.08-.06-.02-.02-.04-.03-.06-.05-.03-.02-.05-.04-.07-.06-.02-.02-.04-.03-.06-.05-.02-.02-.05-.04-.07-.06-.02-.02-.04-.03-.06-.05-.01-.01-.02-.02-.03-.03-.01-.01-.02-.02-.03-.03,0,0-.01-.01-.02-.02-.01-.01-.03-.02-.04-.03-.02-.02-.05-.04-.07-.06-.02-.02-.04-.04-.05-.05-.02-.02-.04-.04-.07-.07-.02-.02-.03-.04-.05-.05-.01-.01-.02-.02-.03-.04-.01-.01-.02-.02-.03-.03-.02-.02-.03-.04-.05-.05h-.01s-.03-.05-.05-.07c-.02-.02-.03-.03-.05-.05-.02-.03-.05-.05-.07-.08-.01-.02-.03-.03-.04-.05-.03-.03-.05-.07-.08-.1,0-.01-.02-.02-.03-.03-.03-.04-.07-.09-.1-.13,0-.01-.02-.02-.02-.03-.01-.02-.02-.03-.04-.05-.01-.02-.02-.03-.04-.05h0s.41.6.41.6c.51.75,1.2,1.41,2.05,1.9,3.18,1.84,7.41.72,9.45-2.5,1.49-2.36,1.39-5.19-.02-7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m36.85,13.86c.06-.36.16-.72.3-1.07,0-.02.01-.04.02-.05.06-.16.13-.32.21-.47-.01-.02-.02-.03-.03-.05.01.02.02.03.03.05.09-.17.18-.34.29-.51,1.71-2.69,5.25-3.63,7.91-2.09.6.35,1.1.79,1.5,1.29-.03-.04-.05-.09-.08-.13,0-.01-.02-.03-.02-.04-.03-.04-.06-.09-.08-.13v-.02s-.01,0-.01,0c-.02-.02-.03-.05-.05-.07,0-.01-.02-.03-.03-.04-.02-.02-.03-.04-.05-.06h0s-.02-.04-.03-.05v-.02s-.06-.06-.09-.09c-.01-.01-.02-.03-.03-.04-.02-.02-.04-.05-.06-.07-.01-.01-.03-.03-.04-.04-.02-.02-.04-.04-.05-.06-.01-.02-.03-.03-.04-.05h0s-.04-.04-.05-.06h0s-.03-.03-.04-.05c-.02-.02-.04-.04-.05-.06-.02-.02-.03-.03-.05-.05-.02-.02-.04-.04-.06-.05-.02-.02-.03-.03-.05-.04h0s0-.01,0-.01c-.01-.01-.03-.03-.04-.04-.02-.01-.03-.03-.05-.04-.02-.02-.04-.03-.06-.05h0s-.03-.03-.05-.04c-.02-.02-.04-.03-.06-.05-.02-.01-.03-.03-.05-.04-.01,0-.02-.02-.04-.03,0,0-.02-.01-.03-.02-.02-.01-.03-.03-.05-.04-.02-.02-.04-.03-.07-.05h0s-.03-.03-.05-.04h0s0,0,0,0c-.02-.01-.03-.02-.05-.03h-.01s0,0,0,0c-.02-.01-.03-.02-.05-.03-.03-.02-.05-.03-.08-.05-.02,0-.03-.02-.05-.03-.02-.01-.04-.02-.06-.03-.02-.01-.04-.02-.05-.03h-.02c-.11-.07-.22-.13-.33-.18-.25-.12-.52-.23-.78-.31h0c-.13-.04-.27-.08-.4-.11h0c-.13-.03-.27-.06-.41-.08h0c-.14-.02-.27-.04-.41-.05h0c-.14-.01-.27-.02-.41-.02h0c-.14,0-.27,0-.41.01h0c-.14,0-.27.02-.41.04-1.61.21-3.14,1.08-4.15,2.49-.03.05-.06.09-.1.14h0c-.03.06-.06.11-.1.15h0s-.05.08-.08.13c0,.01-.02.03-.02.04-.02.03-.03.06-.05.09,0,.01-.01.03-.02.04h0s0,.01,0,.01c0,.01-.01.03-.02.04,0,.01-.01.03-.02.04v.02s-.01,0-.01,0c0,0,0,.02-.01.03h0s-.01.03-.02.04c-.02.03-.03.07-.05.1h0s0,.02-.01.02c0,.01-.01.02-.02.04,0,.01-.01.03-.02.04h0s0,0,0,0h0s0,.02,0,.02h0s0,.02,0,.02h0s-.01.03-.02.04c0,.02-.01.03-.02.05-.01.03-.02.05-.03.08,0,.02-.01.04-.02.05,0,.01-.01.03-.02.04,0,.02-.01.03-.02.05-.02.06-.04.11-.06.17,0,.01,0,.02-.01.03-.01.03-.02.07-.03.1,0,.02-.01.04-.02.05,0,.03-.02.06-.03.09h0s0,.01,0,.01v.02s-.03.1-.05.15h0s0,.03-.01.04c-.01.05-.02.1-.04.15h0s0,.02,0,.03h0s0,.01,0,.01h0s-.01.07-.02.11c0,.02,0,.03,0,.05h0s0,0,0,0c0,.02,0,.04-.01.06,0,.01,0,.02,0,.03,0,.01,0,.03,0,.04,0,.01,0,.02,0,.03,0,0,0,.02,0,.03,0,.02,0,.03,0,.05,0,0,0,.02,0,.03,0,.01,0,.02,0,.03,0,.02,0,.04,0,.07h0s0,.04,0,.06c0,.03,0,.06,0,.09,0,.01,0,.02,0,.03h0c0,.08-.01.15-.01.22h0s0,0,0,0h0s0,.03,0,.04h0s0,.06,0,.08c0,.01,0,.02,0,.03h0s0,.03,0,.04h0s0,.01,0,.01v.02s0,.02,0,.02c0,.02,0,.05,0,.07h0s0,.04,0,.05v.02s0,.01,0,.01c0,.03,0,.05,0,.08h0s0,.03,0,.04h0s0,.02,0,.02h0s0,.08,0,.11v.02s0,0,0,0c0,.01,0,.03,0,.04h0s0,0,0,0c0,.03,0,.06,0,.1,0,.07.02.15.03.22,0,.02,0,.04,0,.06,0,.04.01.08.02.12,0,.02,0,.04.01.06,0,.04.02.09.03.13,0,.01,0,.03,0,.04.01.06.03.11.04.17h0c.02.07.03.13.05.19h0s0,.01,0,.01v.03s0,0,0,0c0,.03.02.06.03.09h0s0,0,0,0v.02s.02.02.02.03h0s.02.06.03.09v.02s.02.03.02.04h0s0,.02.01.03c.02.05.04.11.07.16v.03c.04.06.06.12.09.18h0c.03.07.06.13.09.19h0c.03.07.06.12.09.17,0,0,.01.02.02.03.03.05.06.11.1.16h0s0,.01,0,.01c.07.11.15.23.23.33h.01s.05.08.08.12c-.63-1.08-.86-2.37-.64-3.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m44.63,10.98s.06.07.09.1l.34-.54-.08-.12-.35.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m42.13,14.67v-.02s-.03-.02-.03-.02l-.02-.02s-.01-.01-.02-.02l-.02-.02s-.01-.01-.02-.02l-.02-.02s-.02-.01-.02-.02l-.02-.02s-.02-.01-.03-.02h-.02s-.02-.03-.03-.03h-.02s-.03-.03-.05-.04h0s-.06-.03-.08-.05h-.01s-.01-.02-.01-.02c-.02-.01-.04-.03-.06-.04,0,0-.01-.01-.02-.02h0s-.04-.04-.07-.06h-.01s-.01-.02-.02-.03c-.01,0-.02-.02-.03-.03,0,0-.02-.02-.03-.02l-.02-.02s-.02-.02-.03-.03c-.01-.01-.02-.02-.04-.04-.01-.01-.02-.02-.03-.03l-.02-.02s-.02-.02-.03-.03c-.01-.01-.02-.02-.03-.04-.01-.01-.02-.03-.03-.04h0s-.02-.03-.03-.04c-.01-.02-.02-.03-.03-.05l-.02-.02.08.12c.17.24.39.45.66.61.11.06.2.15.28.24-.01-.03-.03-.05-.05-.07,0,0-.01-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m40.3,14.87s-.02.04-.03.06h0s-.02.05-.03.07v.02s-.02.04-.02.06h0s-.01.05-.02.08v.02s-.01.04-.01.06h0s0,.06,0,.08v.02s0,.04,0,.05v.02s0,.04,0,.07h0s0,.05,0,.07v.02s.01.04.01.06h0s0,.05.01.06v.02s.02.04.03.06h0s.02.04.02.06v.02s.03.04.04.06h0s.02.04.03.06c.01.02.03.04.05.07-.18-.32-.18-.73.04-1.08l-.08-.12s-.03.04-.04.06v.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m39.64,16.86s-.04-.04-.06-.06h0s-.01-.02-.01-.02c-.01-.01-.02-.03-.03-.04h0s-.01-.03-.01-.03c0-.01-.02-.02-.03-.04v-.02s-.02-.01-.02-.01c0-.01-.02-.02-.02-.03,0,0-.01-.02-.02-.02h0s.08.11.08.11c.04.06.09.12.14.18v-.02s.01,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m44.95,11.39v.02s.03.04.04.05c0,0,0,.02.01.03,0,.02.02.03.02.05,0,0,0,.02.01.03,0,.02.01.03.02.05,0,0,0,.02.01.03,0,.02.01.03.02.05v.03s.02.03.03.05v.03s.02.03.02.05h0s0,.02,0,.02h0s0,.03.01.05h0s0,.04,0,.04v.02s0,.01,0,.01h0s0,.03,0,.04v.03s0,0,0,0h0s0,.03,0,.05v.03s0,0,0,0c0,.02,0,.03,0,.05,0,.01,0,.02,0,.03,0,.02,0,.03,0,.05,0,.01,0,.02,0,.03,0,.02,0,.04,0,.06h0s0,.03,0,.03c0,.02,0,.03,0,.05v.02s0,.02,0,.02h0s0,.03,0,.04v.02s0,.02,0,.02c0,0,0,.02,0,.03h0s0,.03,0,.03c0,0,0,.02,0,.03,0,.01,0,.02,0,.03v.02s0,.02,0,.03c0,.01,0,.02,0,.03h0s0,.04,0,.05c0,0,0,.02,0,.03h0s0,.04-.01.06c0,0,0,.02,0,.03h0s0,.04-.01.06c0,0,0,.02,0,.02h0s0,.04-.01.05c0,0,0,.02,0,.03h0s0,.03,0,.03v.02s-.01.02-.02.03h0s0,.03-.01.04h0s0,.02-.01.03v.02s-.02.02-.02.03c0,0,0,.02-.01.02,0,0,0,.02-.01.03,0,.01,0,.02-.01.03v.02s-.02.02-.03.03c0,0,0,.02-.02.03h0s-.02.04-.02.05c0,0,0,.02-.01.03h0s-.03.05-.04.08l-.95-.55.08.12.95.55c.48-.76.44-1.67-.01-2.33l-.08-.12s.02.03.03.04v.02s.04.05.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.07,15.73s0-.04,0-.05c0,.02,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.09,15.81s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.06,15.66s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.12,15.94s-.02-.08-.03-.12c0,.04.02.08.03.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.16,16.08s0-.03-.01-.04c0,.01,0,.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.06,15.58s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.14,16s0-.03-.01-.05c0,.02,0,.03.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.02,16.36c.05,0,.1.01.16.01-.05,0-.1,0-.16-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.17,16.37s.07,0,.1,0c-.03,0-.07,0-.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.32,15.39s0-.07,0-.1c0,.03,0,.07,0,.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.21,12.63s0,.03,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.1,14.98c.03-.13.06-.25.11-.37-.05.12-.09.25-.11.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.07,15.13s0-.05.01-.07c0,.02,0,.05-.01.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.08,15.05s0-.05.01-.07c0,.02,0,.05-.01.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.05,15.5c0-.12,0-.24.02-.36-.02.12-.02.24-.02.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.39,14.25c-.07.12-.14.24-.19.36l.4-.24-.21-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.29,13.95s-.02-.03-.04-.04c.01.01.02.03.03.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.34,15.92s.04.06.06.08h0s-.03-.05-.05-.07h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.16,13.78s-.03-.04-.04-.06c.01.02.03.04.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.25,13.89s-.05-.07-.08-.11c0,0,.01.02.02.03.01.02.02.03.03.05,0,.01.02.02.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.17,12.88s0,.02,0,.03c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.2,12.71s0,.03,0,.04c0-.01,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.06,13.24s0,.02-.01.03c0-.01,0-.02.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.19,12.79s0,.03,0,.04c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.03,13.33s-.01.02-.02.03c0-.01,0-.02.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "44.88 13.6 44.88 13.6 43.93 13.05 43.93 13.05 43.93 13.05 44.88 13.6 44.88 13.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.99,13.41s-.01.02-.02.03c0,0,.01-.02.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.91,11.33v-.02s-.02-.01-.02-.01c.01.02.03.04.04.06,0-.01-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.15,14.13s-.01-.02-.02-.03v-.02s0,.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.19,12.08s0,.04,0,.06v-.03s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.98,12.96h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.46,15.2s0-.02,0-.03v-.03s0-.03,0-.03c0,.03,0,.06,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.24,14.3v-.02s-.02-.02-.02-.02h0s.02.02.02.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "42.08 12.06 42.07 12.08 42.08 12.06 42.08 12.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.26,11.48h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.36,11.51h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.21,11.48h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.31,11.49h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.2,14.21s-.01-.02-.02-.03h0s0-.01,0-.01c0,.02.02.03.03.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.99,12.27h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.33,15.94s0-.03.01-.04v-.02s.03-.06.04-.09v-.02s.02-.05.02-.07c0,0,0-.02,0-.03,0-.03.01-.05.02-.08h0s0-.08.01-.11v-.03s0-.05,0-.07c0,0,0-.02,0-.03,0-.03,0-.06,0-.09h0s0-.04,0-.05c0,.24-.04.49-.13.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.16,11.47h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.97,12.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.52,11.62h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.04,13.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.47,11.65h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.95,12.48h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.11,11.47h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.56,11.59h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.45,15.1s0-.02,0-.03v-.02s0-.02,0-.02c0,.03,0,.05,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.61,11.57h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.45,15.01s0-.04,0-.06h0s0-.03,0-.03c0,.03,0,.06,0,.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.32,14.48h0s0-.02,0-.02c0-.01,0-.02-.01-.03,0,.02.02.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.35,14.57h0s0-.03,0-.03c0-.01,0-.02-.01-.03,0,.02.01.04.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.44,14.92s0-.04,0-.06v-.03s-.01-.05-.02-.07v-.02s-.02-.06-.03-.09v-.02s-.02-.03-.02-.05c.03.11.06.22.08.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.66,11.55h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.01,11.47h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.95,11.47h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.7,11.53h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.06,11.47h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.9,11.48h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.85,11.49h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.75,11.52h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.8,11.5h.02s-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.98,13.9s.02.02.03.03c0-.01-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.09,12.33h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.1,12.41h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.05,12.17h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.1,12.49h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.38,11.71s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.34,11.74s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.3,11.77s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.17,13.22h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.09,12.57h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.06,12.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.82,12.62s0-.09,0-.13c0,.04,0,.09,0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.82,12.76s0-.08,0-.12c0,.04,0,.08,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.84,12.33s.01-.08.02-.11c0,.04-.01.08-.02.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.82,12.49s0-.09.01-.13c0,.04-.01.09-.01.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.04,12.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.26,11.81s.01-.01.02-.02c0,0-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.01,12.9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.61,13.55s.02.02.03.02c-.01,0-.02-.02-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.05,13.98s.02.03.04.05c-.01-.02-.02-.03-.04-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.92,13.82s.02.02.03.03c0-.01-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.43,11.67l.02-.02s-.01.01-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m43.29,14.39v-.02s-.02-.02-.02-.02h0s.02.02.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.16,11.94s.01-.02.02-.03c0,0-.01.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.04,12.14h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.86,13.03c-.02-.09-.03-.18-.03-.26,0,.09.02.18.03.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.12,12s.02-.03.03-.04c0,.01-.02.03-.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.19,11.89s.01-.02.02-.03c0,0-.01.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.29,13.33h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.36,13.39h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.23,11.85s.01-.02.02-.02c0,0-.01.02-.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.53,13.5s.02.01.03.02c0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.7,13.62s.02.02.03.03c-.01,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.77,13.68s.02.02.03.03c-.01,0-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.85,13.75s.02.02.03.03c-.01-.01-.02-.02-.03-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.01,12.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.66,17.42s.05.01.08.02c-.03,0-.05,0-.08-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.28,16.37s0-.02-.01-.03c0,0,0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.25,16.3s-.01-.02-.02-.03c0,.01.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.38,16.54s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.19,16.15s0-.03-.01-.04c0,.01,0,.03.01.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.22,16.23s-.01-.02-.02-.04c0,.01.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.74,17.44c.06.01.11.02.17.02-.06,0-.12-.01-.17-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.33,16.46v-.02s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.13,13.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.5,14.16s-.02-.02-.03-.03h0s.02.02.03.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.35,14.01s-.02-.03-.04-.04h0s.02.03.03.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.43,14.1s-.03-.03-.05-.05h.01s.02.04.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.66,14.29s-.01-.01-.02-.02h0s.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.57,14.22s-.02-.01-.02-.02h0s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m41.75,14.35s-.02-.01-.02-.02h.01s.01.02.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.22,15.08s.01-.04.02-.06v-.02s.01-.01.01-.01c-.01.03-.02.07-.03.1h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.2,15.15s0-.04.01-.06c0,.03-.02.07-.02.1v-.02s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.22,15.66v-.02s.01.06.03.09c0-.02-.01-.04-.02-.06v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.27,15.8s-.02-.04-.02-.05h0s0,0,0,0c.01.03.03.06.04.09h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.2,15.6s0-.04-.01-.06v-.02s0-.02,0-.02c0,.05.02.1.03.15,0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m40.17,15.37s0-.04,0-.05v-.02s0-.04,0-.07h0s0-.03,0-.04c-.01.07-.02.14-.01.2h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.53,16.74s-.01-.02-.02-.02h.01s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.48,16.67s-.01-.02-.02-.03h0s.01.03.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.58,16.8s-.01-.01-.02-.02h.01s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m39.41,16.58h0s.01.02.02.03c0,0-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.12,11.77s-.01-.03-.02-.05v-.03s-.02-.03-.03-.05c0-.01,0-.02-.01-.03,0-.02-.01-.03-.02-.05,0,0,0-.02-.01-.03,0-.02-.02-.03-.02-.05,0,0,0-.02-.01-.03,0-.01-.01-.03-.02-.04.07.13.13.27.17.41,0-.01,0-.03-.01-.04v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.12,13.09h0s0,.02-.01.03h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.15,11.87v-.02s0,.04.01.06c0-.01,0-.02,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.22,12.47h0s0,.02,0,.03v-.02s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.17,11.95v-.03s0,.04,0,.06h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.22,12.28s0-.03,0-.05c0-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0,.07.01.14.02.2,0-.02,0-.03,0-.05,0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.95,11.39s-.01-.02-.02-.03c.01.02.02.04.04.06h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.09,13.17h0s0,.02-.01.03h0s0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.94,13.49h0s0,.02-.01.03c0,0,0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.19,12.03v-.03s0,.04,0,.06h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.15,13s0,.02,0,.03c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.22,12.38s0,.03,0,.05c0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m45.22,12.56h0s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "40.23 17.93 40.29 17.83 40.15 17.92 39.29 17.42 39.29 17.42 40.22 17.95 40.23 17.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m36.36,13.96c0-.07,0-.14.01-.21h0s0-.03,0-.03h0s0-.02,0-.02c0-.03,0-.06,0-.09v-.02s0,0,0,0c0-.01,0-.02,0-.03h0s0-.05,0-.07h0s0-.03,0-.03c0-.01,0-.02,0-.04,0,0,0-.02,0-.03,0-.01,0-.02,0-.03,0-.01,0-.02,0-.03h0s0-.03,0-.04h0s0-.03,0-.05c0-.02,0-.03,0-.05,0-.02,0-.03,0-.05v-.02s.02-.08.03-.12h0c.01-.05.02-.1.04-.15,0-.01,0-.03.01-.04h0c.01-.05.03-.1.04-.15v-.02s0-.01,0-.01c0-.03.02-.06.03-.09,0-.02.01-.04.02-.05.01-.03.02-.07.03-.1,0-.01,0-.02.01-.03.02-.06.04-.11.06-.17,0-.02.01-.03.02-.05,0-.01.01-.03.02-.04,0-.02.01-.04.02-.05.01-.03.02-.05.03-.08,0-.02.01-.03.02-.05,0-.01.01-.02.02-.04v-.02s.01,0,.01,0v-.02s0,0,0,0h0s.01-.03.02-.04c0-.01.01-.02.02-.04,0,0,0-.01.01-.02h0s.03-.07.05-.1c0-.01.01-.02.02-.03h0s.01-.03.02-.04v-.02s.02-.03.03-.04c0-.01.01-.03.02-.04h0s.01-.04.02-.05c.02-.03.03-.06.05-.09,0-.01.02-.03.02-.04.03-.04.05-.08.08-.13h0s.06-.1.1-.15h0c.03-.06.06-.1.1-.15h0s-1.79,1.08-1.79,1.08h0s-.03.09-.05.13c0,.02-.01.04-.02.06-.01.04-.03.09-.04.13,0,.01,0,.03-.01.04-.03.09-.05.17-.07.26,0,.02-.01.04-.02.06-.01.04-.02.09-.03.13,0,.02,0,.04-.01.06-.02.1-.04.19-.06.29h0c0,.06-.02.1-.02.15,0,.02,0,.04,0,.06,0,.05-.01.09-.02.14v.03c-.01.09-.02.18-.03.28,0,.02,0,.04,0,.06,0,.05,0,.09,0,.14,0,.02,0,.04,0,.06,0,.09,0,.19,0,.28v.02s0,.09,0,.14c0,.02,0,.04,0,.06,0,.05,0,.09,0,.14h0s1.11-.67,1.11-.67h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m44.59,7.92c-.59-.16-1.2-.25-1.8-.26l-1.18.71h0c.14-.02.27-.03.41-.04h0c.14,0,.27-.01.41-.01h0c.14,0,.27,0,.41.02h0c.14.01.27.03.41.05h0c.14.02.27.05.41.08h0c.13.03.27.07.4.11h0c.27.08.53.19.78.31h0s1.11-.67,1.11-.67c-.06-.04-.12-.07-.18-.11-.05-.03-.1-.05-.15-.08-.02,0-.03-.02-.05-.03-.03-.02-.06-.03-.1-.05-.02-.01-.04-.02-.06-.03-.03-.01-.06-.03-.09-.04-.02-.01-.04-.02-.06-.03-.03-.01-.06-.03-.09-.04-.02,0-.04-.02-.07-.03-.03-.01-.06-.02-.08-.04-.02,0-.05-.02-.07-.03-.03-.01-.06-.02-.08-.03-.02,0-.05-.02-.07-.03-.03-.01-.06-.02-.08-.03-.02,0-.05-.02-.07-.02-.03,0-.06-.02-.08-.03-.02,0-.05-.02-.07-.02-.03,0-.06-.02-.08-.03-.02,0-.05-.01-.07-.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.02-.03,0-.06-.02-.09-.02-.02,0-.05-.01-.07-.02-.03,0-.06-.01-.09-.02-.02,0-.05-.01-.07-.02-.03,0-.06-.01-.09-.02-.02,0-.04,0-.07-.01-.03,0-.07-.01-.1-.02-.02,0-.04,0-.06-.01-.05,0-.09-.01-.14-.02h-.02s0,0,0,0l-.33.2c.53.07,1.04.21,1.52.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m36.58,15.76h0c-.02-.06-.03-.12-.05-.18h0c-.01-.06-.03-.12-.04-.17h0s0,0,0,0v-.03s0,0,0,0h0c0-.05-.02-.09-.03-.14h0s0,0,0,0c0-.01,0-.03,0-.04h0s0-.01,0-.01c0-.04-.01-.08-.02-.12,0-.01,0-.03,0-.04h0s0-.02,0-.02c-.01-.07-.02-.14-.03-.22h0s-1.04.62-1.04.62c.01.08.03.16.05.24h0c.02.08.04.16.06.24h0c.02.08.04.16.06.24h0c.02.09.05.16.07.24l.99-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m45.54,9.28h0s0,0,0,0h0s.03.03.04.04h0s.04.03.07.05h0s.02.01.03.02c0,0,.02.01.03.02h0s.02.01.03.02c.01,0,.03.02.04.03.02.01.03.03.05.04h0s.04.03.06.05h0s.03.03.05.04c.02.02.04.03.06.05.02.01.03.03.05.04.02.02.03.03.05.05h0s0,0,0,0c.02.01.03.03.05.04.02.02.04.04.06.05.02.01.03.03.05.04.02.02.03.03.05.05l.99-.6h0c-.05-.06-.1-.11-.15-.16-.01-.01-.02-.02-.03-.03-.05-.05-.1-.1-.16-.15h0c-.12-.12-.24-.22-.37-.33h0s-1.05.63-1.05.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m46.59,17.16h0c-.14.18-.28.35-.44.51h0s0,0,0,0h0c-.05.05-.1.1-.15.15h0s0,0,0,0h0c-.05.05-.1.1-.15.14l-.02.02s-.1.09-.15.13h0s0,0,0,0h0c-.05.04-.1.09-.16.13h0s-.02.01-.03.02c-.05.04-.1.08-.16.12l2.84-1.7s.03-.06.04-.08c0-.02.02-.03.03-.05.02-.04.04-.08.05-.12,0-.02.02-.04.03-.06,0-.01.01-.02.02-.03.03-.06.05-.12.08-.18v-.02s.02-.03.03-.05c0-.02.01-.03.02-.05l-1.87,1.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m44.43,18.92h0c-.13.07-.27.13-.41.18h0s0,0,0,0h0c-.2.08-.41.15-.62.21h0s-.01,0-.01,0h0c-.14.04-.27.07-.41.1h-.02s0,0,0,0c-.07.01-.14.03-.21.04l-1.87,1.12c.11.01.23.03.34.03h0c.05,0,.11,0,.16.01h.02c.06,0,.12,0,.17,0l2.85-1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m40.76,7.61c.32-.08.64-.13.97-.16h.02s.38-.23.38-.23h0c-.16,0-.32.02-.49.04h0c-.16.02-.32.04-.48.07h0s-.52.31-.52.31c.04-.01.08-.02.12-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m41.19,7.79c-.12.02-.24.05-.36.08-.46.11-.9.27-1.33.47l-1.52.91c-.16.12-.33.25-.48.39.06-.07.12-.14.18-.21l-.89.54h0s-.08.1-.12.15h0c-.04.05-.07.1-.11.15v.02s-.07.09-.1.13c0,0-.01.02-.02.03-.04.05-.07.11-.1.16h0c-.04.06-.07.11-.1.17h0s4.97-2.98,4.97-2.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m36.38,17.91s.02.03.04.05c0,.01.02.02.02.03.03.04.07.09.1.13,0,.01.02.02.03.03.03.03.05.07.08.1.01.02.03.03.04.05.02.03.04.05.07.08.01.02.03.03.05.05.02.02.03.04.05.06h.01s.03.05.05.07c.01.01.02.02.03.03.01.01.02.03.03.04.02.02.03.04.05.05.02.02.04.05.07.07.02.02.04.04.05.05.02.02.05.04.07.06.01.01.03.02.04.03,0,0,.01.01.02.02.01.01.02.02.03.03.01.01.02.02.03.03.02.02.04.03.06.05.02.02.05.04.07.06.02.02.04.03.06.05.02.02.05.04.07.06.02.02.04.03.06.05.03.02.05.04.08.06,0,0,.02.01.03.02l1.06-.64c-.06-.04-.12-.08-.18-.12h0s-.02-.01-.02-.01h0c-.12-.08-.23-.16-.34-.25h0s-.02-.01-.02-.01c-.11-.09-.21-.18-.31-.28h0s-.01-.01-.01-.01h0s-.1-.1-.14-.14h0s0,0,0,0h0c-.05-.05-.1-.1-.14-.16h0s0,0,0,0h0s-.09-.1-.13-.15h0s0-.01,0-.01c-.01-.02-.03-.04-.04-.05-.03-.03-.05-.07-.08-.1h-.01c-.08-.12-.16-.23-.23-.35h0c-.03-.07-.06-.12-.1-.17h0s0,0,0,0v-.02s0,0,0,0h0c-.03-.06-.06-.11-.09-.17h0c-.03-.07-.06-.13-.09-.19h0c-.03-.06-.05-.12-.08-.18h0s0,0,0,0h0s0,0,0,0h0c-.02-.07-.04-.12-.07-.18v-.02s-.99.59-.99.59c.06.14.12.29.19.42,0,.02.02.04.03.06.02.04.04.07.06.11.03.05.06.1.09.15.01.02.03.04.04.07.02.04.05.08.07.12.01.02.02.04.04.06.04.06.07.12.11.17h0s.02.03.04.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m46.56,10.2s.03.04.05.06c.01.01.02.02.03.04.03.03.05.07.08.1h0s0,0,0,0c.01.01.02.03.03.04.02.02.03.05.05.07,0,.01.02.02.03.04h0s.04.05.05.08h0s0,0,0,0h0s0,.01,0,.01c.03.04.06.08.08.13h0s.02.03.02.04h0s.05.09.08.13v.02s.01,0,.01,0h0s0,0,0,0c.02.04.05.08.07.12v.02s.03.03.03.04h0s.03.05.04.08c.01.02.02.05.04.07h0c.03.06.05.11.07.16,0,0,0,.02.01.03h0s0,.01,0,.01h0s.04.09.06.14h0s0,.02,0,.02c.02.05.04.11.06.16,0,.01,0,.03.01.04.02.05.03.09.05.14v.03s.03.06.04.09c0,.03.01.05.02.08h0s0,.03.01.04c.01.05.02.09.04.14,0,.01,0,.02,0,.04v.02c.01.05.03.1.04.15h0s0,.02,0,.04c0,.02,0,.04.01.06,0,.03.01.06.01.08h0s0,.02,0,.02v.02s.01.08.02.12c0,.02,0,.04,0,.05v.03s.01.08.02.12v.03s0,0,0,0c0,.01,0,.03,0,.04,0,.04,0,.08,0,.12l1.06-.64s0-.06-.01-.1c0-.02,0-.03,0-.04h0s0-.03,0-.03c0-.05-.02-.09-.02-.14,0-.01,0-.03,0-.04-.01-.07-.03-.13-.04-.2,0-.01,0-.03-.01-.04-.01-.06-.03-.11-.04-.17,0-.02,0-.03-.01-.05-.02-.07-.04-.13-.06-.2v-.03s-.01-.01-.01-.01c0-.03-.02-.05-.03-.08,0-.03-.02-.06-.03-.08,0-.02-.01-.03-.02-.05-.02-.06-.05-.13-.07-.19v-.03c-.03-.06-.06-.11-.08-.17,0-.02-.01-.03-.02-.05-.03-.06-.06-.13-.09-.19h0s-.04-.09-.06-.13c0-.02-.02-.04-.03-.06,0-.02-.02-.03-.03-.05-.03-.06-.06-.11-.09-.17h0c-.03-.07-.07-.13-.11-.19,0-.02-.02-.03-.03-.05-.02-.03-.03-.05-.05-.08-.02-.03-.03-.05-.05-.08h0s0,0,0,0c-.04-.06-.09-.12-.13-.19,0-.01-.02-.03-.03-.04-.05-.06-.09-.12-.14-.18l-.98.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m47.8,14h0c0,.06,0,.11-.01.17h0s0,.06,0,.08c0,0,0,.02,0,.03,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04,0,.01,0,.03,0,.04,0,.02,0,.05-.01.07v.02s0,.04-.01.06v.02s0,0,0,0h0s0,0,0,0h0c0,.06-.02.12-.03.17,0,.02,0,.03,0,.05,0,.04-.02.09-.03.13,0,.01,0,.03,0,.04-.01.06-.03.11-.04.17,0,0,0,.02,0,.03-.01.05-.03.1-.04.14,0,.01,0,.03-.01.04-.02.05-.03.11-.05.16h0c-.02.07-.04.12-.06.18,0,.01,0,.02-.01.03-.02.05-.04.1-.06.14,0,.01,0,.02-.01.03-.02.06-.05.11-.08.17h0s1.47-.88,1.47-.88h0s0-.02,0-.02v-.02c.02-.06.03-.12.04-.18,0-.02,0-.03.01-.05.01-.07.03-.14.04-.21,0-.01,0-.02,0-.03.01-.06.02-.12.03-.18,0-.02,0-.04,0-.05,0-.07.02-.14.02-.21v-.02c0-.07.01-.13.02-.2,0-.02,0-.04,0-.06,0-.02,0-.04,0-.07,0-.05,0-.09,0-.14h0c0-.08,0-.15,0-.22,0-.02,0-.04,0-.05,0-.05,0-.11,0-.16l-1.12.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m41.49,19.53h0c-.71-.04-1.41-.2-2.07-.51l-1.12.67s.06.04.09.06c.06.03.12.07.18.1.02,0,.03.02.05.03.05.02.09.05.14.07.02,0,.03.02.05.02.06.03.12.06.17.08h0c.07.03.13.06.2.09h.01c.06.03.12.05.18.08h.02c.2.08.41.15.61.2l1.47-.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m43.07,7.48c-.12-.02-.24-.03-.36-.04-.32-.03-.64-.02-.96,0h-.02c-.33.03-.65.09-.97.16-.04.01-.08.02-.12.03-.59.16-1.16.4-1.68.72-.48.29-.92.65-1.29,1.06-.06.07-.12.14-.18.21.16-.14.32-.27.48-.39.35-.26.71-.5,1.09-.7.14-.08.28-.15.43-.21.43-.2.88-.35,1.33-.47.12-.03.24-.06.36-.08.19-.04.38-.07.57-.09.31-.04.63-.05.95-.05.03,0,.06,0,.09,0,.6.02,1.21.11,1.8.26-.48-.22-.99-.36-1.52-.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 41.92,
    cy: 13.61,
    r: 4.77
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m45.75,14.22c-.04.07-.19.05-.35-.04l-2.37-1.37c-.15-.09-.34-.19-.41-.23-.08-.04-.16-.18,0-.26l1.36-.79c.15-.09.35-.04.43.12l1.25,2.17c.09.15.13.33.09.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m43.94,10.85c.04.07-.05.19-.21.28l-2.37,1.37c-.15.09-.28.16-.28.16,0,0-.06.04-.13.08-.07.05-.23.05-.23-.12v-1.57c0-.17.14-.32.32-.32h2.5c.17,0,.35.05.39.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m40.11,10.73c.08,0,.14.14.14.32v2.74c0,.17,0,.32,0,.32,0,0,0,.07.01.15,0,.08-.07.23-.22.14l-1.36-.79c-.15-.09-.2-.28-.12-.43l1.25-2.17c.09-.15.22-.28.3-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m38.1,13.98c.04-.07.19-.05.35.04l2.37,1.37c.15.09.28.16.28.16h0l.13.08c.16.05.16.16,0,.25l-1.36.79c-.15.09-.35.04-.43-.12l-1.25-2.17c-.09-.15-.13-.33-.09-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m39.91,17.36c-.04-.07.05-.19.21-.28l2.37-1.37c.15-.09.28-.16.28-.16,0,0,.06-.04.13-.08.07-.05.23-.05.23.12v1.57c0,.17-.14.32-.32.32h-2.5c-.17,0-.35-.05-.39-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m43.73,17.48c-.08,0-.14-.14-.14-.32v-2.74c0-.17,0-.32,0-.32,0,0,0-.07-.01-.15,0-.08.07-.23.22-.14l1.36.79c.15.09.2.28.12.43l-1.25,2.17c-.09.15-.22.28-.3.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m42.48,13.14c-.57-.33-1.3-.13-1.63.44s-.13,1.3.44,1.63h0c.16.09.33.14.51.16-.21-.16-.27-.46-.14-.7.15-.26.48-.35.74-.2.22.13.32.39.25.63.11-.09.2-.2.28-.32.33-.57.13-1.3-.44-1.63Zm-.96.75c-.13-.07-.17-.23-.1-.36s.23-.17.36-.1.17.23.1.36-.23.17-.36.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 41.66,
    cy: 13.67,
    r: 0.31
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.04,2.63h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.86,2.62h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.77,6.77h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.9,3.04l.67-.4c-.06.03-.13.06-.19.09-.17.09-.33.19-.48.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.63,3.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.58,2.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.83,6.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.22,2.65h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.4,2.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.37,6.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.5,6.39h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.41,6.23h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.71,6.7h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.24,5.75h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.22,4.85s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.2,4.95h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.21,4.9h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.23,5.67s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.2,5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.68,2.63h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.1,7.52h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "32.19 5.39 32.19 5.39 32.19 5.39 32.19 5.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.56,7.38h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.29,7.47h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 32.2,
    y: 4.59,
    width: 0,
    height: 0,
    transform: "translate(-.32 5.09) rotate(-9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "32.06 4.1 32.07 4.11 32.06 4.1 32.06 4.1 32.06 4.1 32.06 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.19,4.53h0s0,.02,0,.03c0,0,0-.02,0-.03,0,0,0-.01,0-.02,0,0,0,.01,0,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.22,7s0,0-.01,0c0,0,0,0,.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.03,4.03s0,0,0-.01c-.01-.02-.02-.05-.03-.07.01.02.02.05.03.07,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.14,4.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.1,4.2s.01.04.02.06h0s0,.01,0,.01h0s0,.02.01.04h0s0-.02-.01-.04h0s-.01-.05-.02-.07c0,0,0-.01,0-.02,0-.02-.02-.05-.03-.07,0,.02.02.05.03.07,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.03,5.95s0,0,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.12,5.71s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.09,5.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.16,5.54s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.14,5.63s0,0,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.06,5.88s0,0,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.18,5.46s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.29,6.94h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.43,6.81h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.36,6.88h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.5,6.74h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.21,5.24s0-.02,0-.03h0s0,0,0,0c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.23,3.55s.03-.04.04-.06c-.01.02-.03.04-.04.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.57,2.23s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.17,3.63s.03-.05.05-.07c-.02.02-.03.05-.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.27,3.48s.03-.04.05-.06c-.02.02-.03.04-.05.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.86,4.27s.01-.04.02-.06c0,.02-.01.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.83,4.36s.01-.04.02-.06c0,.02-.01.04-.02.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.32,3.42s.03-.04.05-.07c-.02.02-.03.04-.05.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.36,2.18s.02,0,.02,0c0,0-.02,0-.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.43,2.2s.02,0,.03,0c0,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.5,2.21s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.29,2.17h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.51,2.16c.07,0,.14-.01.21-.02-.07,0-.14,0-.21.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.9,6.91h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.79,4.49s.02-.08.03-.11c-.01.04-.02.08-.03.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.81,6.06s-.02-.07-.03-.1c0,.03.02.07.03.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.03,6.58s-.02-.03-.02-.05c0,.02.02.03.02.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.79,5.95s-.02-.07-.02-.1c0,.03.02.07.02.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.77,4.58s0-.04.01-.06c0,.02,0,.04-.01.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.13,6.75s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.08,6.67s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.7,5.4s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.72,4.88s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.7,5.25s0-.08,0-.12c0,.04,0,.08,0,.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.74,4.73s.02-.08.03-.13c0,.04-.02.08-.03.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.73,4.79s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.7,5.1s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.7,5.01s0-.08.01-.12c0,.04,0,.08-.01.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.3,2.19c.07-.01.14-.02.21-.03-.07,0-.14.02-.21.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.43,7.83s-.06-.02-.09-.04c.03.01.06.03.09.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.34,7.79s-.05-.02-.08-.04c.03.01.05.02.08.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.27,6.95s0,0,.01.01c.01.01.02.03.03.04-.01-.01-.02-.03-.03-.04,0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.18,3.29s.04.05.06.08c-.02-.03-.04-.05-.06-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.52,7.87s-.05-.02-.08-.03c.03.01.05.02.08.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.4,8.05s-.05,0-.07,0c.02,0,.05,0,.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.24,7.75s-.04-.02-.06-.03c.02.01.04.02.06.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.2,7.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.36,7.06s.01.02.02.02c0,0,.02.02.02.03,0,0-.02-.02-.02-.03,0,0-.01-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.04,7.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.74,7.42s-.02-.02-.03-.03c0,0-.02-.01-.03-.02,0,0,.02.01.03.02.01,0,.02.02.03.03,0,0,.02.01.03.02.01,0,.02.02.03.03-.01,0-.02-.02-.03-.03,0,0-.02-.01-.03-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.58,7.29s0,0,0,0c0,0,.01,0,.02.01,0,0-.01,0-.02-.01,0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.46,7.17s-.01-.01-.02-.02c0,0,.01.01.02.02,0,0,.02.02.02.02,0,0,.02.02.03.03,0,0-.02-.02-.03-.03,0,0-.02-.02-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.33,2.53h0s.05.03.08.05c-.03-.02-.05-.03-.08-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.84,2.31s.02,0,.03.01c-.01,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.91,2.33s.02,0,.03.01c-.01,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.94,3s.05.05.07.07c-.02-.02-.04-.05-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.98,2.36s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.7,2.26s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.77,2.28s.02,0,.03.01c-.01,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.04,2.39s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.69,2.78c.06.05.11.09.16.14-.05-.05-.11-.1-.16-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.64,2.24s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.86,2.92s.05.04.07.07c-.02-.02-.05-.04-.07-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.18,2.45s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.25,2.48s.01,0,.02.01c0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.11,2.42s.02,0,.03.01c0,0-.02,0-.03-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m26.7,5.32s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.22,4.78s0,.04,0,.07h0s0,.01,0,.01h0s0,0,0,0h0s0,.05,0,.07h0s0,0,0,0c0,0,0,.01,0,.02h0s0,.03,0,.04c0,.01,0,.03,0,.04h0s0,.05,0,.08h0s0,.01,0,.02l.49-.3h0s0-.02,0-.02c0-.03,0-.06,0-.09,0,0,0-.02,0-.02,0-.03,0-.05,0-.08,0,0,0-.01,0-.02,0-.02,0-.03,0-.05l-.47.28s0-.04,0-.05Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "27.44 4.12 27.44 4.12 27.44 4.13 27.44 4.12 27.44 4.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "27.29 4.52 27.29 4.53 27.29 4.52 27.29 4.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.71,5.14s0-.02,0-.02c0,0,0-.02,0-.03,0,0,0,.02,0,.03,0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.64,5.63h0s0,0,0,0c0-.03.01-.05.02-.08,0,0,0-.02,0-.02,0,0,0,.02,0,.02,0,.03-.01.05-.02.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.51,4h0s0,0,0,0c0,0,0,.01,0,.02,0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.58,3.87h0s-.02.04-.03.06c.01-.02.02-.04.03-.06h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "32.68 4.49 32.68 4.49 32.68 4.48 32.68 4.49 32.68 4.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.26,3.07h0s0,0,0,0c0,0-.01,0-.02-.01,0,0,.01,0,.02.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.24,4.7s0,0,0-.01c0,.02,0,.04-.01.05,0-.01,0-.03,0-.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.23,4.77h0s0,.01,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.26,4.62s-.01.04-.02.07h0s0,0,0,0c0-.02.01-.04.02-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.59,4.1h0s0-.03-.01-.04c0,.01,0,.02.01.04h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.27,4.6h0s0,.01,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.44,3.72h0s-.02-.04-.03-.06c0,.02.02.03.03.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.79,3.6s0,.01.01.02c0,0,0-.01-.01-.02,0-.01-.02-.02-.02-.03h0s.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.3,3.46s0-.01-.01-.02c0-.01-.01-.02-.02-.03,0,.01.01.02.02.03,0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30,7.53s-.03,0-.05,0c-.09.01-.19.02-.28.02-.02,0-.03,0-.05,0-.06,0-.12,0-.18,0l-.65.39c-.09-.02-.18-.05-.27-.08.26.1.53.15.8.17-.05,0-.1,0-.15-.02l.82-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.04,7.64l.49-.3c-.06-.03-.13-.06-.19-.1-.02-.01-.05-.03-.07-.04l-.47.28s0,0,.01.01c.01,0,.02.02.04.03,0,0,.02.01.03.02.01,0,.03.02.04.03,0,0,.02.01.03.02.01,0,.03.02.04.03,0,0,.01,0,.02.01.02.01.04.03.07.04.03.01.05.03.08.04-.03-.01-.05-.03-.08-.04-.01,0-.03-.02-.04-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.75,3.55h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.8,3.61h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.95,3.86h0s0,.01,0,.02c0,0,0-.01,0-.02h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "31.92 3.79 31.92 3.79 31.92 3.79 31.92 3.8 31.92 3.79 31.91 3.79 31.92 3.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.48,3.25h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.36,3.15h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "31.28 3.09 31.3 3.1 31.28 3.09 31.28 3.09 31.28 3.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.49,6.08h0s0-.02,0-.03c0,0,0,.01,0,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.41,3.19h0s.02.01.03.02c0,0,.01.01.02.02,0,0,.01.01.02.02h0s-.01-.01-.02-.02c0,0-.01-.01-.02-.02,0,0-.02-.02-.03-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.39,3.17s.01.01.02.02c0,0-.01-.01-.02-.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.9,6.21s-.04.08-.07.11c-.04.07-.09.13-.14.2l.82-.49s0,.01,0,.02c.01-.03.02-.05.03-.08,0,0,0-.01,0-.02.01-.03.02-.06.03-.09,0,0,0-.01,0-.02,0-.03.02-.05.02-.08,0,0,0-.01,0-.02,0-.03.02-.06.02-.09l-.65.39c-.03.06-.06.11-.09.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m32.41,6.27s-.01.02-.02.04l-1.25.75c-.12.09-.24.16-.37.23,0,0-.01,0-.02.01l-1.26.75s-.05,0-.08,0c1.09.05,2.2-.49,2.83-1.49.02-.03.04-.06.05-.09,0,0,0-.02.01-.02.02-.03.03-.05.04-.08h0s.03-.07.05-.1c0,0,0-.02.01-.02,0-.02.02-.03.02-.05,0,.02-.02.03-.02.05,0,0,0,.02-.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "31.82 3.65 31.83 3.65 31.82 3.65 31.82 3.65 31.82 3.65 31.82 3.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.33,2.65c.23-.14.48-.25.74-.32l.23-.14c-.74.14-1.44.54-1.93,1.16l.39-.24c.16-.18.36-.34.57-.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.92,2.87s.1.05.15.08h0s.02.01.02.02c0,0,.02.01.03.02,0,0,.01,0,.02.01.01,0,.02.02.04.02,0,0,.01,0,.02.01h0s0,0,0,0h0s.01.01.02.02l.46-.28c-.09-.07-.18-.14-.28-.2l-.49.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.2,5.47h0s0-.03,0-.04h0s0,0,0,0h0s0-.01,0-.02c0-.01,0-.02,0-.04,0,0,0-.01,0-.02h0s0-.02,0-.02h0s0-.01,0-.02h0s0-.02,0-.02c0,0,0-.01,0-.02h0s0-.02,0-.02h0s0-.03,0-.04h0s0-.01,0-.01h0s0,0,0,0c0-.02,0-.03,0-.05h0s0-.02,0-.02h0s0,0,0,0l-.49.29c0,.15.03.3.06.45,0-.04-.01-.07-.02-.11l.46-.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.98,2.24c.05,0,.11,0,.16.02l.15-.09c-.19-.03-.37-.04-.56-.03l-.17.1c.14-.01.28-.01.42,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.18,6.83h0s0,0,0,0c0,0,.01.01.02.02,0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.34,6.06h0s0,0,0,0c0,0,0-.01,0-.02h0s0-.03-.01-.05c0,0,0-.01,0-.02h0s0-.02,0-.02c0,0,0-.02,0-.03h0s0-.02,0-.02l-.44.26s-.02-.07-.03-.1c.05.15.1.3.18.44-.03-.06-.06-.12-.08-.19l.43-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m27.67,3.74c.44-.62,1.12-1,1.83-1.1h0s.52-.31.52-.31c-.01,0-.03,0-.04,0-.14,0-.28,0-.42.02-.08,0-.17.02-.25.04l-2.19,1.31h0c-.1.17-.18.34-.24.51l.79-.47h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.55,3.32s-.01-.01-.02-.02c0,0-.02-.02-.03-.02,0,0,.02.02.03.02,0,0,.01.01.02.02,0,0,.02.02.02.02,0,0,.01.01.02.02h0s0,0,0,0c0,0,.02.02.02.03h0s0,0,0,0c0,0,.01.01.02.02,0,0,.02.02.02.03,0,0,.01.01.02.02,0,.01.02.02.03.03,0,0,0,.01.01.02,0,0,0-.01-.01-.02,0,0-.01-.02-.02-.03l.43-.26s.04.05.06.08c-.05-.07-.11-.14-.17-.2l-.44.26s-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.74,7.3s.01,0,.02-.01c0,0-.01,0-.02.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.29,
    y: 6.94,
    width: 0,
    height: 0,
    transform: "translate(2.86 21.74) rotate(-40.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.23,5.65s0,.01,0,.02h0s0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.5,
    y: 6.74,
    width: 0,
    height: 0,
    transform: "translate(4.87 24.87) rotate(-46.32)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.01 4.82 31 4.83 31 4.83 31.01 4.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.36,6.88h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.21,7.01s0,0,.01,0h0s0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.14,7.06h0c-.12.09-.24.16-.37.23.13-.06.25-.14.37-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.23,4.95s0,.03,0,.04c0-.01,0-.03,0-.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.99,4.85s0,0,0,.01h0s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.66 5.34 29.65 5.34 29.66 5.35 29.66 5.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.63,5.32s0,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.67 5.36 29.67 5.35 29.68 5.36 29.67 5.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.71,5.4s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.68,5.37s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.7,5.39s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.73 5.43 29.73 5.42 29.74 5.43 29.73 5.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.98,4.89s0,.01-.01.02h0s0-.01.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.96,4.92s-.01.02-.02.03h0s.01-.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.6,5.31s.01,0,.02.01c0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.2,5.46s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 30.56,
    y: 7.38,
    width: 0,
    height: 0,
    transform: "translate(-.55 11.93) rotate(-21.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.83,3.8h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 31.43,
    y: 6.81,
    width: 0,
    height: 0,
    transform: "translate(4.38 24.2) rotate(-44.96)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.07,4.62s0,.01,0,.02h0s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.08,4.59s0,0,0,.01h0s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.19,5.39h0s0,0,0,0h0s0,0,0,0h0s0-.03,0-.04h0s0,.02,0,.03c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.08,4.55h0s0,.01,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.04 4.74 31.04 4.74 31.04 4.74 31.04 4.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.05 4.72 31.05 4.72 31.04 4.73 31.05 4.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.22,5.13s0,.04,0,.06c0-.02,0-.04,0-.06,0,0,0-.01,0-.02h0s0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.09,4.52h0s0,.01,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.21,5.27s0-.01,0-.02c0,0,0,0,0-.01,0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.21,4.67h0s0,.02,0,.02c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.05,4.7h0s0,0,0-.01c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.45,7.56c.06,0,.12,0,.18,0-.06,0-.12,0-.18,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.95,7.54c-.09.01-.19.02-.28.02.09,0,.19-.01.28-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "30.09 7.52 30.1 7.52 30.09 7.52 30.09 7.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30,7.53h0s-.03,0-.05,0c.02,0,.03,0,.05,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 30.28,
    y: 7.47,
    width: 0,
    height: 0,
    transform: "translate(-.9 8.26) rotate(-15.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.03 4.78 31.03 4.78 31.03 4.77 31.03 4.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "32.04 4.04 32.04 4.04 32.03 4.03 32.04 4.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.09 4.51 31.09 4.51 31.09 4.51 31.09 4.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.02 4.79 31.02 4.8 31.02 4.8 31.02 4.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.09 4.48 31.09 4.49 31.09 4.49 31.09 4.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.55 5.28 29.55 5.27 29.56 5.28 29.55 5.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.03 4.76 31.03 4.76 31.03 4.76 31.03 4.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.87,5.74s0,.02,0,.02c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.48,4.05s0,.01,0,.02c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.23,4.77s0,.01,0,.02c0,0,0,.01,0,.02h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.93,5.51s.01-.02.02-.03c0,0-.01.02-.02.03Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.41,
    y: 4.18,
    width: 0,
    height: 0,
    transform: "translate(13.48 28.16) rotate(-68.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.87,5.77s0,0,0,.01h0s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.93,5.95s0,.01.01.02h0s-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.88,5.84s0,.01,0,.02h0s0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.87,5.81s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.89,5.87s0,.02,0,.03h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.92,5.93s0,.01.01.02c0,0,0-.02-.01-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.9,5.9s0,.02.01.02c0,0,0-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.24,4.7h0s0,0,0,0c0,.01,0,.03,0,.04h0s0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.22,4.84s0,0,0-.01h0s0,.01,0,.02c0,0,0,.01,0,.02h0s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "27.19 5.35 27.19 5.35 27.19 5.35 27.19 5.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "27.19 5.2 27.19 5.2 27.19 5.2 27.19 5.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.19,5.28s0,.01,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "27.19 5.31 27.19 5.32 27.19 5.32 27.19 5.31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.19,5.21s0,.02,0,.03c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.19,5.18s0,0,0-.01c0,0,0-.02,0-.02,0,.02,0,.03,0,.05h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.21,4.88h0s0,0,0,.01h0s0,.01,0,.01c0,0,0,0,0-.01,0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.2,4.93s0,.01,0,.02h0s0,.01,0,.01c0,0,0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.2,5h0s0,0,0,0h0s0,0,0,0c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.19,5.12s0,.01,0,.02h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.77,
    y: 6.77,
    width: 0,
    height: 0,
    transform: "translate(2.46 20.05) rotate(-41.39)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.24,
    y: 5.73,
    width: 0,
    height: 0.01,
    transform: "translate(-.6 5.97) rotate(-12.36)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.83,
    y: 6.84,
    width: 0,
    height: 0,
    transform: "translate(3.15 21.41) rotate(-44.37)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.44 5.19 29.43 5.18 29.44 5.19 29.44 5.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "28.04 7.03 28.04 7.03 28.04 7.03 28.04 7.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.4,5.15s0,0,0,0c0,0,0,0,.01.01h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.9,
    y: 6.9,
    width: 0,
    height: 0,
    transform: "translate(3.54 22.16) rotate(-45.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.37,
    y: 6.14,
    width: 0,
    height: 0,
    transform: "translate(-.2 11.31) rotate(-23.27)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.51 5.25 29.51 5.25 29.51 5.25 29.51 5.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "29.47 5.22 29.47 5.21 29.48 5.22 29.47 5.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "27.7 6.69 27.71 6.7 27.71 6.7 27.7 6.69"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 27.5,
    y: 6.39,
    width: 0,
    height: 0,
    transform: "translate(.44 14.45) rotate(-29.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.89,5.58s0,.02,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.88,5.64h0s0,.02,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.89,5.61h0s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.87,5.71s0,.02,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.87,5.67s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.09,4.47h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.34,5.08h0s0-.01-.01-.02c0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.91,5.54s0,.02,0,.02h0s0-.01.01-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 28.2,
    y: 7.14,
    width: 0,
    height: 0,
    transform: "translate(6.38 26.39) rotate(-55.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.37,5.12h0s0-.01,0-.02h0s0,0,.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.91,5.54s0-.02.01-.03c0,0,0,.02-.01.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "27.3 5.95 27.3 5.96 27.3 5.96 27.3 5.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.19,5.41h0s0-.02,0-.03c0,.01,0,.02,0,.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.27,5.39s0,.01,0,.02c0-.01,0-.02,0-.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.28,5.42s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.3,5.54h0s0-.02,0-.03c0,0,0,.02,0,.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.31,5.58h0s0-.02,0-.03c0,0,0,.02,0,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.31,5.74s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.3,5.78s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.29,5.47s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.31,5.68s0,.03,0,.04c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.09,4.35s0,.02,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "30.25 5.34 30.25 5.33 30.25 5.34 30.25 5.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.44,4.12s0,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.09,4.41h0s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.24,5.3s0,0,0-.01h0s0,.01,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.25,5.33s0-.01,0-.02h0s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.3,5.83s0,.02,0,.04c0-.01,0-.02,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.46,4.14s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.26,5.37s0-.01,0-.02h0s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.48,4.16s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.26,5.98s0,0,0,.01c0-.01,0-.02.01-.03,0,0,0,.01,0,.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.31,5.66s0,.02,0,.02c0-.01,0-.03,0-.04,0,0,0,0,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.06,4.68s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.72,4.25s-.01.02-.01.03h0s.01-.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.04,4.12s0,.01,0,.02c0,0,0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.09,4.44h0s0,0,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.09 4.45 31.09 4.45 31.09 4.46 31.09 4.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.01,4.06s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.95,3.95s0,0,0,.01h0s0,.01,0,.02c0-.01-.01-.02-.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.09,6.28s-.03.04-.05.05c.02-.02.03-.04.05-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.25,6.01s0,.02-.01.03c0-.01,0-.02.01-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.23,6.05s-.01.03-.02.04c0-.01.01-.03.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.28,5.92s0,.03-.01.04c0-.01,0-.03.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.51,4.2h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.31,5.62h0s0,0,0-.02c0,0,0,0,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.29,5.88s0,.02,0,.03c0-.01,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.21,6.1s-.01.02-.02.03c0,0,.01-.02.02-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.18,6.14s-.02.03-.02.04c0-.01.02-.03.02-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.23,5.28h0s0-.01-.01-.02h0s0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.69,4.3h0s0,0,0,0c0,0,0-.01,0-.02,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.67,4.63s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.06,4.19s0,.01,0,.02h0s0,0,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.66,4.6s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.29,5.92s0,.02,0,.03c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.68,4.66h0s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.65,4.57s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.08,4.28h0s0,.02,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 29.69,
    y: 4.69,
    width: 0,
    height: 0,
    transform: "translate(.75 12.82) rotate(-24.66)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.65,4.45h0s0,0,0,0c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.65,4.54s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.65,4.43s0,0,0-.01c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.07 4.24 31.07 4.24 31.07 4.24 31.07 4.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.66,4.39h0s0,0,0,0c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.07,4.25h0s0,.02,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.34,6.05h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.06 4.21 31.06 4.22 31.07 4.23 31.06 4.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.65,4.49h0s0,.01,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.68,4.34h0s0,0,0,0c0,0,0-.01,0-.02,0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "30.19 5.21 30.19 5.2 30.19 5.2 30.19 5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.99,4.02s0,.01.01.02c0,0,0-.01-.01-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.05 4.18 31.05 4.18 31.06 4.19 31.05 4.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.02,4.09s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.43,4.11s0,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.38,4.08s.01,0,.02.01c0,0-.01,0-.02-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.4,4.09s0,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.21,5.24h0s-.01-.02-.02-.03c0,0,0,0,0,.01,0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m28.54,7.34h0c-.06-.03-.13-.06-.19-.1-.02-.01-.05-.03-.07-.04.02.01.05.03.07.04.06.04.12.07.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m27.31,5.99h0s0,.03.01.04c0-.01,0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.08,4.31h0s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m29.67,4.36h0s0,0,0,0c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.97,3.99h0s0,0,0,0c0,0,0,.01,0,.02,0,0,0-.02-.01-.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "31.08 4.28 31.08 4.28 31.08 4.28 31.08 4.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m30.18,5.19s0-.01-.01-.02c0,0,0,0,0,.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.05,4.18h0s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m31.92,3.79h0c-.18-.23-.4-.43-.66-.58-1.17-.68-2.73-.26-3.48.92-.05.07-.09.15-.13.22,0,0,0-.01-.01-.02,0,0,0,.01.01.02-.03.07-.07.14-.09.21,0,0,0,.02,0,.02-.06.16-.1.31-.13.47.21.38.53.71.95.96.02.01.04.02.07.04,0,0,0,0,0-.02,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02h0s0-.04-.01-.06h0s0-.02,0-.03h0s0-.03,0-.03h0s0-.03,0-.03h0s0-.03,0-.04h0c0-.06,0-.11,0-.17h0s0-.02,0-.03h0s0-.02,0-.03h0c.01-.06.03-.11.05-.17h0c.02-.05.05-.11.08-.16l.09.05.32.19.04.05c-.1.15-.1.33-.02.48h0s.07.08.12.11.1.05.15.05c.02,0,.05,0,.07,0,.02,0,.03,0,.05,0,.05,0,.11-.02.16-.04.01,0,.03-.01.04-.02.04-.02.08-.05.11-.08.02-.02.04-.05.06-.07,0,0,0-.01.01-.02.04-.06.06-.13.07-.2,0-.02,0-.03,0-.04,0-.08-.02-.16-.06-.23-.03-.04-.07-.08-.12-.11-.12-.07-.22-.16-.29-.27l-.04-.05h0s0,0,0,0h0s-.01-.02-.02-.03h0c-.06-.09-.09-.19-.12-.29h0s-.01-.08-.02-.12h0s0-.04,0-.06h0s0-.05,0-.07h0s0-.04,0-.06h0s0-.04,0-.06c0,0,0,0,0-.01.02-.11.07-.22.13-.33.24-.37.68-.54,1.08-.45.01,0,.02,0,.03,0l.03-.05.13-.2.11.06.3.18.04.05-.15.24s.05.06.07.09h0s0,0,0,0c0,0,0-.01-.01-.02l.04.05c.2.29.22.69,0,1.03l-.42-.24-.04-.05h0s.01-.02.02-.03h0s.01-.03.01-.04h0s0-.02.01-.03h0s0-.03,0-.04h0s0-.05.01-.07h0s0-.03,0-.04h0s0-.02,0-.04h0s0-.02,0-.04h0s0-.05-.02-.07h0s-.02-.06-.04-.09c-.03-.04-.07-.08-.12-.1-.22-.13-.51-.05-.66.17-.1.15-.1.33-.02.47h0s0,.01,0,.01c.01.02.03.03.05.05h0s.02.02.03.02h0s.02.02.03.02c.01,0,.03.02.04.02,0,0,0,0,.01,0,0,0,.02.01.03.02,0,0,0,0,.01.01,0,0,.01.01.02.02,0,0,0,0,.01.01,0,0,.01.01.02.02,0,0,0,0,.01.01,0,0,.01.01.02.02,0,0,0,0,.01.01,0,0,.01.01.02.02,0,0,0,0,.01.01,0,0,.01.01.02.02,0,0,0,0,.01.01,0,0,.01.02.02.02,0,0,.01.01.02.02,0,0,0,.01.01.02h0s.04.04.04.04c.2.29.21.7,0,1.03-.03.04-.06.09-.09.12.65-.1,1.23-.44,1.58-.99.17-.26.26-.54.3-.83h0s0-.01,0-.01c0-.02,0-.04,0-.06,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.02,0-.04,0-.06h0s0-.05,0-.07c0,0,0-.01,0-.02,0-.02,0-.05,0-.07h0s0-.05,0-.07c0,0,0-.01,0-.02,0-.02,0-.04,0-.06h0s0-.06,0-.08c0,0,0-.01,0-.02,0-.02,0-.04,0-.06h0s0-.03,0-.04h0s.02.05.03.07c0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.03,0,0,0-.01,0-.02h0s0,0,0,0c0-.02-.02-.04-.03-.05h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m32.14,4.34s0,.01,0,.02c0,.02.01.04.02.06,0,0,0,.01,0,.02,0,0,0-.01,0-.02,0-.02-.01-.04-.02-.06,0,0,0-.01,0-.02,0-.01,0-.02,0-.03h0s0,.02.01.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.2,5.43h0s0,.02,0,.04h0s0,0,0,0c0-.01,0-.03,0-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.51,6.63s.08-.02.11-.03c-.04.01-.08.02-.11.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.19,6.65h0s-.05,0-.08-.01h0c.07.01.13.02.2.02-.04,0-.08,0-.12,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.23,5.65s0,.01,0,.02h0s0-.02,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.55 6.29 28.55 6.29 28.55 6.3 28.55 6.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.96 6.76 29.04 6.62 29.05 6.63 29.04 6.62 28.96 6.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.24,5.73h0s0,.02,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.19,5.25s0-.02,0-.03c0,0,0,.02,0,.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.19,5.29s0,.01,0,.02c0,0,0,0,0,.01h0s0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.08,6.63h0s.02,0,.04,0h0s-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.31,5.99s0,.03.01.04c0-.01,0-.03-.01-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.21,5.57h0s0,.02,0,.02c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.22,4.81h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "27.2 4.93 27.2 4.93 27.2 4.93 27.2 4.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.65,6.63h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.21,4.86h0s0,.01,0,.02h0s0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.89,6.86l.03-.04-.03.04Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "27.2 5.01 27.19 5.02 27.2 5.01 27.2 5.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.19,5.19h0s0,.01,0,.01h0s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.19,5.35h0s0,.02,0,.02c0,0,0,.02,0,.02,0-.02,0-.03,0-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.63,6.39h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.57 6.32 28.57 6.32 28.58 6.33 28.57 6.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "27.37 6.14 27.37 6.15 27.37 6.15 27.37 6.14 27.37 6.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.47,6.64s-.08.01-.12.01c.04,0,.08,0,.12-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "27.54 6.47 27.54 6.47 27.54 6.47 27.54 6.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "27.24 4.71 27.24 4.7 27.24 4.7 27.24 4.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.3,5.96s0-.03-.01-.04c0,0,0,.02,0,.03h0s0,.01,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m28.54,7.34h0c.29.14.6.21.91.22.06,0,.12,0,.18,0,.02,0,.03,0,.05,0,.09,0,.19-.01.28-.02.02,0,.03,0,.05,0,.03,0,.06-.01.09-.02h0c.06-.01.12-.03.18-.05h0c.09-.03.18-.06.27-.09h0c.06-.02.12-.05.18-.08,0,0,.01,0,.02-.01.13-.06.25-.14.37-.23.02-.02.05-.03.07-.05,0,0,0,0,.01,0,.02-.02.05-.04.07-.06h0s.04-.04.07-.06h0s.05-.05.07-.07h0s.04-.05.07-.07h0c.07-.07.13-.15.19-.23.05-.06.09-.13.14-.2.02-.04.05-.07.07-.11.03-.06.06-.11.09-.17h0s.02-.05.03-.08c0,0,0,0,0-.01,0-.02.02-.04.03-.06,0,0,0,0,0-.01,0-.02.02-.05.03-.08h0s.02-.05.02-.07c0,0,0-.01,0-.02,0-.02.01-.04.02-.06,0,0,0,0,0-.01,0-.02.01-.05.02-.07,0,0,0-.01,0-.02,0-.02,0-.04.01-.06,0,0,0-.01,0-.02,0-.02,0-.05.01-.07h0s0,0,0,0h0s0,0,0-.01c0-.01,0-.02,0-.04,0-.01,0-.02,0-.03,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0-.01,0-.02,0-.03,0-.01,0-.02,0-.03h0s0-.02,0-.02c0-.02,0-.04,0-.06,0,0,0-.01,0-.02,0-.03,0-.05,0-.08h0s0-.03,0-.04c0-.01,0-.03,0-.04h0s0-.02,0-.02h0s0-.05,0-.07h0s0,0,0,0h0s0-.05,0-.08c0,0,0-.01,0-.02h0s0-.05,0-.06c0,0,0,0,0-.01h0s0-.02,0-.02c0-.02,0-.03,0-.05,0,0,0-.01,0-.02h0s0-.03,0-.04c0,0,0-.02,0-.03h0s0-.01,0-.02c0-.02,0-.04-.01-.07h0s0-.02,0-.02c0-.02-.01-.04-.02-.06,0,0,0-.01,0-.02,0-.01,0-.02-.01-.04,0-.01,0-.02-.01-.04h0s0-.01,0-.01c0-.02-.01-.04-.02-.06,0,0,0-.01,0-.02,0-.02-.02-.05-.03-.07h0s0,0,0,0c0-.02-.02-.04-.03-.06h0s0-.02,0-.02c-.01-.02-.02-.05-.03-.07h0s-.02-.05-.03-.07h0s0,.02,0,.03h0s0,.05,0,.07c0,0,0,.01,0,.02,0,.02,0,.05,0,.07h0s0,.05,0,.07c0,0,0,.01,0,.02,0,.02,0,.05,0,.07h0s0,.05,0,.07c0,0,0,.01,0,.02,0,.02,0,.04,0,.07h0s0,.04,0,.06c0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,.02,0,.04,0,.06h0s0,.01,0,.01c-.04.29-.14.57-.3.83-.35.55-.94.89-1.58.99-.26.29-.66.42-1.02.32l-.16.25-.41-.24-.04-.05h0s.15-.24.15-.24c-.02-.03-.04-.05-.06-.08l-.04-.05h0s0,0,0,0c0,0,0-.01-.01-.02,0,0,0,0,0-.01,0,0,0-.01-.01-.02h0s-.01-.03-.02-.04c0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.01,0-.02h0s-.04-.02-.07-.04c-.42-.24-.74-.58-.95-.96-.1.56,0,1.13.28,1.61,0,0,.01.02.02.02h0s.04.05.06.07h0s.04.05.06.07h0s.04.04.06.06h0s.09.09.14.13h0s.1.08.15.12h0s.05.04.08.06c.02.01.05.03.07.04.06.04.12.07.19.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.45,6.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.19,5.14h0s0,0,0,0h0s0,.02,0,.03c0,0,0-.02,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.19,5.41h0s0,.01,0,.02c0,0,0-.01,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m30,6.37s-.05.05-.08.07c.03-.02.06-.05.08-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.9,6.46s-.04.03-.06.04c.02-.01.04-.02.06-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m29.79,6.53s-.08.04-.12.06c.04-.02.08-.04.12-.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.49,6.39h0s0,.01,0,.01c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.26,5.82h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m27.34,6.06h0s0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "28.6 6.35 28.6 6.35 28.61 6.36 28.6 6.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m32.42,3.63l-.18-.27h0s0,0,0,0c0,.01.01.02.02.03,0,.01.01.02.02.03,0,0,0,.01.01.02.02.03.03.05.05.08h0s.03.06.04.08c0,0,0,.01.01.02,0,0,0,.02.01.03,0,.02.02.03.03.05h0s.03.06.04.09c0,0,0,.01,0,.02.01.02.02.05.03.07h0s.02.07.03.1c0,0,0,.01,0,.02,0,.01,0,.02.01.04,0,.01,0,.02.01.04h0s0,.02,0,.02c0,.03.02.06.03.09,0,0,0,.01,0,.02,0,.02.01.05.02.07,0,0,0,.01,0,.02,0,.03.01.06.02.09,0,0,0,.01,0,.02,0,.02,0,.04.01.06h0s0,.01,0,.01c0,0,0,.01,0,.02,0,.01,0,.03,0,.04,0,.02,0,.03,0,.05,0,0,0,.01,0,.02,0,.03,0,.05,0,.08,0,0,0,.02,0,.02,0,.03,0,.06,0,.09h0s0,.02,0,.02c0,.02,0,.05,0,.07,0,0,0,.02,0,.02,0,.03,0,.06,0,.09h0s0,.04,0,.06c0,0,0,.02,0,.03,0,0,0,.02,0,.02,0,.03,0,.06,0,.09h0s0,.07-.01.1c0,0,0,.02,0,.02,0,.03,0,.05-.01.08,0,0,0,0,0,.01,0,.03-.01.06-.02.09,0,0,0,.02,0,.02,0,.03-.01.05-.02.08h0s0,.02,0,.02h0s-.02.06-.02.09c0,0,0,.01,0,.02,0,.03-.01.05-.02.08,0,0,0,.01,0,.02,0,.03-.02.06-.03.09,0,0,0,.01,0,.02,0,.03-.02.05-.03.08,0,0,0,.01,0,.02h0s-.02.06-.03.09c0,0,0,0,0,.01,0,0,0,.02-.01.03,0,.02-.02.03-.02.05,0,0,0,.02-.01.02-.01.03-.03.06-.05.09h0s-.03.06-.04.09c0,0,0,.02-.01.02-.02.03-.03.06-.05.09-.63,1-1.74,1.54-2.83,1.49h0s-.05,0-.07,0h0c-.27-.02-.54-.08-.8-.17h0s-.05-.02-.08-.03h0s-.06-.03-.09-.04h0s-.05-.02-.08-.04c0,0-.01,0-.02-.01-.02,0-.04-.02-.06-.03,0,0-.01,0-.02-.01-.03-.01-.05-.03-.08-.04-.02-.01-.05-.03-.07-.04,0,0-.01,0-.02-.01-.01,0-.03-.02-.04-.03,0,0-.02-.01-.03-.02-.01,0-.03-.02-.04-.03,0,0-.02-.01-.03-.02-.01,0-.02-.02-.04-.03,0,0,0,0-.01-.01,0,0,0,0-.01,0-.01,0-.02-.02-.03-.03,0,0-.02-.01-.03-.02-.01,0-.02-.02-.03-.03,0,0-.02-.01-.03-.02-.01,0-.02-.02-.03-.03,0,0-.02-.01-.03-.02,0,0-.01,0-.02-.01,0,0-.01,0-.02-.01,0,0,0,0,0,0,0,0-.01-.01-.02-.02-.01,0-.02-.02-.03-.03,0,0-.02-.02-.02-.02,0,0-.02-.02-.03-.03,0,0-.02-.02-.02-.02,0,0-.01-.01-.02-.02,0,0,0,0-.01-.01,0,0-.01-.02-.02-.02h0s-.02-.02-.02-.03c0,0-.01-.02-.02-.02-.01-.01-.02-.02-.03-.04,0,0-.01-.01-.02-.02-.01-.01-.02-.03-.03-.04,0,0,0,0-.01-.01-.01-.02-.03-.04-.04-.06,0,0,0-.01-.01-.02,0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02h0s.18.26.18.26c.23.33.53.62.9.84,1.4.81,3.26.32,4.16-1.1.66-1.04.61-2.28,0-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m27.4,5.07c.03-.16.07-.32.13-.47,0,0,0-.02,0-.02.03-.07.06-.14.09-.21,0,0,0-.01-.01-.02,0,0,0,.01.01.02.04-.08.08-.15.13-.22.75-1.19,2.31-1.6,3.48-.92.26.15.48.35.66.57-.01-.02-.02-.04-.03-.06,0,0,0-.01-.01-.02-.01-.02-.02-.04-.04-.06h0s0,0,0,0c0-.01-.02-.02-.02-.03,0,0,0-.01-.01-.02,0,0-.01-.02-.02-.03h0s0-.02-.01-.02h0s-.02-.03-.03-.05c0,0,0-.01-.01-.02,0,0-.02-.02-.02-.03,0,0-.01-.01-.02-.02,0,0-.02-.02-.02-.03,0,0-.01-.01-.02-.02h0s-.02-.02-.02-.03h0s-.01-.01-.02-.02c0,0-.02-.02-.02-.02,0,0-.01-.01-.02-.02,0,0-.02-.02-.02-.02,0,0-.01-.01-.02-.02h0s0,0,0,0c0,0-.01-.01-.02-.02,0,0-.01-.01-.02-.02,0,0-.02-.01-.03-.02h0s-.01-.01-.02-.02c0,0-.02-.01-.03-.02,0,0-.02-.01-.02-.02,0,0-.01,0-.02-.01,0,0,0,0-.01,0,0,0-.02-.01-.02-.02,0,0-.02-.01-.03-.02h0s-.02-.01-.02-.02h0s0,0,0,0c0,0-.01,0-.02-.01h0s0,0,0,0c0,0-.01-.01-.02-.02-.01,0-.02-.01-.03-.02,0,0-.01,0-.02-.01,0,0-.02-.01-.03-.02,0,0-.02,0-.02-.01h0s-.1-.06-.15-.08c-.11-.05-.23-.1-.34-.14h0c-.06-.02-.12-.03-.18-.05h0c-.06-.01-.12-.03-.18-.03h0c-.06,0-.12-.02-.18-.02h0c-.06,0-.12,0-.18,0h0c-.06,0-.12,0-.18,0h0c-.06,0-.12,0-.18.02-.71.09-1.38.48-1.83,1.1-.01.02-.03.04-.04.06h0s-.03.05-.04.07h0s-.02.04-.03.06c0,0,0,.01-.01.02,0,.01-.02.03-.02.04,0,0,0,.01,0,.02h0s0,0,0,0c0,0,0,.01,0,.02,0,0,0,.01,0,.02h0s0,0,0,0c0,0,0,0,0,.01h0s0,.01,0,.02c0,.02-.02.03-.02.05h0s0,0,0,0c0,0,0,.01,0,.02,0,0,0,.01,0,.02h0s0,0,0,0h0s0,0,0,0h0s0,0,0,0h0s0,.01,0,.02c0,0,0,.01,0,.02,0,.01,0,.02-.01.03,0,0,0,.02,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,.02-.02.05-.03.07,0,0,0,.01,0,.02,0,.02-.01.03-.02.05,0,0,0,.02,0,.02,0,.01,0,.03-.01.04h0s0,0,0,0h0s-.01.05-.02.07h0s0,.01,0,.02c0,.02-.01.04-.02.07h0s0,0,0,.01h0s0,0,0,0h0s0,.03,0,.05c0,0,0,.02,0,.02h0s0,0,0,0c0,0,0,.02,0,.03,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,.02,0,.03h0s0,.02,0,.03c0,.01,0,.03,0,.04,0,0,0,0,0,.01h0s0,.07,0,.1h0s0,0,0,0h0s0,.01,0,.02h0s0,.03,0,.04c0,0,0,0,0,.01h0s0,.01,0,.02h0s0,0,0,0h0s0,.01,0,.01c0,.01,0,.02,0,.03h0s0,.02,0,.02h0s0,.01,0,.01c0,.01,0,.02,0,.03h0s0,.01,0,.02h0s0,0,0,0h0s0,.03,0,.05h0s0,.01,0,.01c0,0,0,.01,0,.02h0s0,0,0,0c0,.01,0,.03,0,.04,0,.03,0,.06.01.1,0,0,0,.02,0,.03,0,.02,0,.03,0,.05,0,0,0,.02,0,.03,0,.02,0,.04.01.06,0,0,0,.01,0,.02,0,.02.01.05.02.07h0s.01.06.02.08h0s0,0,0,0h0s0,.01,0,.01c0,.01,0,.03.01.04h0s0,0,0,0h0s0,.02,0,.03h0s0,.03.01.04h0s0,.02,0,.03h0s0,.01,0,.02c0,.02.02.05.03.07h0s.02.06.03.09h0s.03.06.04.08h0s.03.05.04.08c0,0,0,0,0,.01.01.02.03.05.04.07h0s0,0,0,0c.03.05.07.1.1.15h0s.02.04.04.05c-.28-.48-.38-1.04-.28-1.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m30.83,3.8s.03.03.04.05l.15-.24-.04-.05-.16.25h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m29.73,5.42h0s0-.01,0-.02h0s0-.01,0-.02h0s0-.01,0-.02h0s0-.01-.01-.02h0s0-.01-.01-.02h0s0-.01-.01-.01h0s-.01-.01-.02-.02h0s-.02-.02-.04-.02h0s0,0,0,0c0,0-.02-.01-.02-.02,0,0,0,0,0,0h0s-.02-.02-.03-.02h0s0-.01,0-.01c0,0-.01,0-.02-.01,0,0,0,0-.01-.01h0s0-.01-.01-.02c0,0-.01-.01-.02-.02,0,0,0,0-.01-.01h0s0-.02-.01-.02c0,0,0-.01-.01-.02,0,0-.01-.01-.02-.02h0s0-.01-.01-.02c0,0-.01-.01-.02-.02h0s.04.04.04.04c.07.11.17.2.29.27.05.03.09.06.12.11,0-.01-.01-.02-.02-.03,0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m28.92,5.51s0,.02-.01.03h0s0,.02-.01.03h0s0,.02,0,.03h0s0,.02,0,.03h0s0,.02,0,.03h0s0,.03,0,.03h0s0,.02,0,.03h0s0,.03,0,.04h0s0,.02,0,.03h0s0,.03,0,.04h0s0,.02,0,.03h0s0,.03,0,.03h0s0,.02.01.03h0s0,.02.01.03h0s0,.02.02.02c0,0,.01.02.02.03-.08-.14-.08-.32.02-.48l-.04-.05s-.01.02-.02.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m28.63,6.39s-.02-.02-.03-.03h0s0,0,0,0c0,0-.01-.01-.02-.02h0s0-.01,0-.01c0,0,0-.01-.01-.02h0s0-.01,0-.01c0,0,0-.01-.01-.02,0,0,0,0,0-.01h0s.04.05.04.05c.02.03.04.05.06.08h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m30.97,3.98h0s0,.02.01.03c0,0,0,0,0,.01,0,0,0,.01.01.02,0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.01,0,.02h0s0,.03,0,.04h0s0,.03,0,.03h0s0,.01,0,.01h0s0,.02,0,.02h0s0,.02,0,.02h0s0,.02,0,.02h0s0,.01,0,.02h0s0,.01,0,.01h0s0,.02,0,.02h0s0,.02,0,.02c0,0,0,.01,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02,0,0,0,0,0,.01,0,0,0,.02,0,.02h0s0,.01,0,.01c0,0,0,.01,0,.02h0s0,.01,0,.01h0s0,.01,0,.02h0s0,.02,0,.02c0,0,0,0,0,.01h0s0,.01,0,.01c0,0,0,0,0,.01,0,0,0,0,0,.01h0s0,.02,0,.02c0,0,0,0,0,.01h0s0,.02,0,.02c0,0,0,0,0,.01h0s0,.02,0,.03c0,0,0,0,0,.01h0s0,.02,0,.02c0,0,0,0,0,.01h0s0,.02,0,.02c0,0,0,0,0,.01h0s0,.01,0,.01h0s0,.02,0,.02h0s0,.02,0,.02h0s0,0,0,.01h0s0,.02,0,.02c0,0,0,0,0,.01,0,0,0,0,0,.01,0,0,0,0,0,.01h0s0,.02,0,.02c0,0,0,0,0,.01h0s0,.02-.01.02c0,0,0,0,0,.01h0s-.01.02-.02.03l-.42-.24.04.05.42.24c.21-.33.19-.73,0-1.03l-.04-.05s0,.01.01.02h0s.01.03.02.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.38,5.89s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.39,5.93s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.38,5.86s0-.02,0-.02c0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.4,5.98s0-.04-.01-.05c0,.02,0,.04.01.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.42,6.04s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.38,5.82s0-.02,0-.03c0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.41,6.01s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.24,6.17s.05,0,.07,0c-.02,0-.05,0-.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.31,6.17s.03,0,.05,0c-.02,0-.03,0-.05,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.81,5.74s0-.03,0-.04c0,.01,0,.03,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.09,4.52s0,.01,0,.02c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.39,5.56c.01-.06.03-.11.05-.16-.02.05-.04.11-.05.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.38,5.63s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.39,5.59s0-.02,0-.03c0,.01,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.37,5.79c0-.05,0-.11,0-.16,0,.05,0,.11,0,.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.52,5.24c-.03.05-.06.1-.08.16l.18-.1-.09-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.36,5.11s-.01-.01-.02-.02c0,0,.01.01.02.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.94,5.97s.02.02.03.04h0s-.01-.02-.02-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.3,5.03s-.01-.02-.02-.03c0,0,.01.02.02.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.34,5.08s-.02-.03-.04-.05c0,0,0,0,0,.01,0,0,.01.01.02.02,0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.07,4.64s0,0,0,.01c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.08,4.56s0,.01,0,.02c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.02,4.8s0,.01,0,.02c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.08,4.6s0,.01,0,.02c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31,4.83s0,0,0,.01c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "30.94 4.95 30.94 4.95 30.52 4.71 30.52 4.71 30.52 4.71 30.94 4.95 30.94 4.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.99,4.87s0,0,0,.01c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.95,3.95h0s0-.01,0-.01c0,0,.01.02.02.03,0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.18,5.18s0,0,0-.01h0s0,0,.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.08,4.28s0,.02,0,.03h0s0-.03,0-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.54,4.67h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.31,5.66s0,0,0-.01h0s0-.02,0-.02c0,.01,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.22,5.26h0s0-.02,0-.02h0s0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.71 4.27 29.7 4.28 29.71 4.28 29.71 4.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.23,4.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.27,4.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.2,4.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.25,4.03h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.2,5.22s0,0,0-.01h0s0,0,0,0c0,0,0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.67,4.37h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.26,5.98s0-.01,0-.02h0s0-.04.01-.05h0s0-.03,0-.04c0,0,0,0,0-.01,0-.01,0-.02,0-.04h0s0-.03,0-.05h0s0-.03,0-.04c0,0,0,0,0-.01,0-.01,0-.03,0-.04h0s0-.02,0-.02c0,.11-.02.22-.06.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.18,4.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.66,4.4h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.9,4.08h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.69,4.69h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.88,4.09h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.65,4.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.16,4.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.92,4.07h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.31,5.61s0,0,0-.01h0s0-.02,0-.02c0,.01,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.94,4.06h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.31,5.57s0-.02,0-.02h0s0-.01,0-.01c0,.01,0,.02,0,.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.25,5.34h0s0-.01,0-.01c0,0,0,0,0-.01,0,0,0,.02,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.27,5.38h0s0-.01,0-.01c0,0,0,0,0-.01,0,0,0,.02,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.3,5.54s0-.02,0-.03h0s0-.03,0-.04h0s0-.04,0-.05h0s0-.02,0-.03c.02.05.03.1.03.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.96,4.05h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.11,4.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.09,4.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.98,4.04h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.14,4.01h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.07,4.02h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.05,4.02h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30,4.04h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.03,4.03h.01s-.01,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.1,5.08s0,0,.01.01c0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.59,4.39h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.59,4.43h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.58,4.32h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.6,4.46h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.84,4.12s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.82,4.13s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.8,4.15s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.75,4.78h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.59,4.5h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.58,4.57h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.15,4.52s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.15,4.58s0-.04,0-.05c0,.02,0,.04,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.16,4.4s0-.03,0-.05c0,.02,0,.03,0,.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.15,4.46s0-.04,0-.06c0,.02,0,.04,0,.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.57,4.61h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.79,4.17s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.56,4.64h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.94,4.93s0,0,.01.01c0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.14,5.12s.01.01.02.02c0,0-.01-.01-.02-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.08,5.05s0,0,.01.01c0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.86,4.1h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.24,5.3h0s0-.02,0-.02h0s0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.74,4.22s0,0,0-.01c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.69,4.31h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.17,4.7s-.01-.08-.02-.12c0,.04,0,.08.02.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.72,4.25s0-.01.01-.02c0,0,0,.01-.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.76,4.2s0,0,0-.01c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.8,4.84h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.83,4.86h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.77,4.18s0,0,0,0c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.9,4.91s0,0,.01,0c0,0,0,0-.01,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.98,4.96s0,0,.01.01c0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.01,4.99s0,0,.01.01c0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.04,5.02s0,0,.01.01c0,0,0,0-.01-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.68,4.34h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.08,6.63s.02,0,.03,0c-.01,0-.02,0-.03,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.48,6.17s0,0,0-.01c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.46,6.14s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.52,6.25s0,0,0-.01c0,0,0,0,0,.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.43,6.08s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.45,6.11s0-.01,0-.02c0,0,0,.01,0,.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.12,6.64s.05,0,.08.01c-.03,0-.05,0-.08-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.5,6.21h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.73,4.76h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.45,5.2s0,0-.01-.01h0s0,0,.01.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.38,5.13s-.01-.01-.02-.02h0s0,.01.01.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m29.42,5.17s-.01-.01-.02-.02h0s.01.02.02.02Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.52 5.26 29.51 5.25 29.51 5.25 29.52 5.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.48 5.23 29.47 5.22 29.48 5.22 29.48 5.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.56 5.28 29.55 5.28 29.56 5.28 29.56 5.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.89,5.6s0-.02,0-.02h0s0-.01,0-.01c0,.01-.01.03-.01.04h0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.88,5.64s0-.02,0-.03c0,.01,0,.03-.01.04h0s0-.02,0-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.89,5.86h0s0,.02.01.03c0,0,0-.02,0-.03h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.91,5.92s0-.02-.01-.02h0s0,0,0,0c0,.01.01.03.02.04h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.88,5.83s0-.02,0-.03h0s0-.02,0-.02c0,.02,0,.04.01.06,0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.87,5.73s0-.02,0-.02h0s0-.03,0-.04h0s0-.02,0-.02c0,.03,0,.06,0,.09h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "28.58 6.33 28.57 6.32 28.58 6.33 28.58 6.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.56,6.31s0,0,0-.01h0s0,.01,0,.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "28.61 6.36 28.6 6.35 28.61 6.36 28.61 6.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m28.53,6.26h0s0,0,0,.01c0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.04,4.15s0-.02,0-.02h0s0-.03,0-.03c0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01-.01-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02.03.06.06.12.08.18,0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.04,4.73h0s0,0,0,.01h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.06,4.19h0s0,0,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.09,4.46h0s0,0,0,.01h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.07,4.23h0s0,0,0,.01h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.09,4.37s0-.02,0-.02c0,0,0,0,0-.01,0,0,0-.01,0-.02,0,.03,0,.06,0,.09,0,0,0-.01,0-.02,0,0,0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m30.97,3.98s0,0,0-.01c0,0,.01.02.02.03h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.03,4.76h0s0,0,0,.01h0s0,0,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "30.97 4.91 30.97 4.91 30.96 4.92 30.97 4.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.07,4.26h0s0,0,0,.01h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.06,4.69s0,0,0,.01c0,0,0,0,0-.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.09,4.41s0,.02,0,.02c0,0,0-.01,0-.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m31.09,4.49h0s0,0,0,.01h0s0-.01,0-.01Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "28.89 6.86 28.92 6.82 28.86 6.85 28.48 6.63 28.48 6.63 28.89 6.87 28.89 6.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.19,5.11s0-.06,0-.09h0s0-.01,0-.01h0s0,0,0,0c0-.01,0-.03,0-.04h0s0-.01,0-.01c0,0,0-.01,0-.02h0s0-.02,0-.03h0s0-.01,0-.01c0,0,0-.01,0-.02,0,0,0,0,0-.01,0,0,0-.01,0-.02,0,0,0-.01,0-.02h0s0-.01,0-.02h0s0-.02,0-.02c0,0,0-.01,0-.02,0,0,0-.02,0-.02h0s0-.05.01-.06h0s.01-.04.02-.07c0,0,0-.01,0-.02h0s.01-.04.02-.07h0s0-.01,0-.01c0-.01,0-.03.01-.04,0,0,0-.02,0-.02,0-.02.01-.03.02-.05,0,0,0-.01,0-.02,0-.02.02-.05.03-.07,0,0,0-.01,0-.02,0,0,0-.01,0-.02,0,0,0-.02,0-.02,0-.01,0-.02.01-.03,0,0,0-.01,0-.02,0,0,0-.01,0-.02h0s0-.01,0-.01h0s0,0,0,0h0s0-.01,0-.02c0,0,0-.01,0-.02,0,0,0,0,0,0h0s.02-.03.02-.05c0,0,0,0,0-.01h0s0-.01,0-.02h0s0-.02,0-.02c0,0,0-.01,0-.02h0s0-.02,0-.02c0-.01.01-.03.02-.04,0,0,0-.01.01-.02.01-.02.02-.04.03-.06h0s.03-.04.04-.06h0s.03-.04.04-.06h0s-.79.47-.79.47h0s-.01.04-.02.06c0,0,0,.02,0,.03,0,.02-.01.04-.02.06,0,0,0,.01,0,.02-.01.04-.02.08-.03.11,0,0,0,.02,0,.03,0,.02,0,.04-.01.06,0,0,0,.02,0,.03,0,.04-.02.08-.03.13h0s0,.05,0,.07c0,0,0,.02,0,.03,0,.02,0,.04,0,.06h0c0,.05,0,.09-.01.13,0,0,0,.02,0,.02,0,.02,0,.04,0,.06,0,0,0,.02,0,.02,0,.04,0,.08,0,.12h0s0,.05,0,.07c0,0,0,.02,0,.03,0,.02,0,.04,0,.06h0s.49-.29.49-.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.81,2.45c-.26-.07-.53-.11-.79-.12l-.52.31h0c.06,0,.12-.01.18-.02h0c.06,0,.12,0,.18,0h0c.06,0,.12,0,.18,0h0c.06,0,.12.01.18.02h0c.06,0,.12.02.18.03h0c.06.01.12.03.18.05h0c.12.04.23.08.34.14h0s.49-.29.49-.29c-.03-.02-.05-.03-.08-.05-.02-.01-.04-.02-.06-.04,0,0-.01,0-.02-.01-.01,0-.03-.02-.04-.02,0,0-.02,0-.03-.01-.01,0-.03-.01-.04-.02,0,0-.02,0-.03-.01-.01,0-.03-.01-.04-.02,0,0-.02,0-.03-.01-.01,0-.02-.01-.04-.02,0,0-.02,0-.03-.01-.01,0-.02,0-.04-.01-.01,0-.02,0-.03-.01-.01,0-.02,0-.04-.01-.01,0-.02,0-.03-.01-.01,0-.02,0-.04-.01-.01,0-.02,0-.03-.01-.01,0-.02,0-.04-.01-.01,0-.02,0-.03,0-.01,0-.03,0-.04-.01-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0-.01,0-.02,0-.03,0-.01,0-.03,0-.04,0,0,0-.02,0-.03,0-.01,0-.03,0-.04,0,0,0-.02,0-.02,0-.02,0-.04,0-.06,0h0s0,0,0,0l-.15.09c.23.03.46.09.67.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.29,5.9h0s-.02-.05-.02-.08h0s-.01-.05-.02-.08h0s0,0,0,0h0s0-.01,0-.01h0s0-.04-.01-.06h0s0,0,0,0c0,0,0-.01,0-.02h0s0,0,0,0c0-.02,0-.03,0-.05,0,0,0-.01,0-.02h0s0,0,0,0c0-.03,0-.06-.01-.1h0s-.46.27-.46.27c0,.04.01.07.02.11h0s.02.07.02.1h0s.02.07.03.1h0s.02.07.03.11l.44-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m31.23,3.05h0s0,0,0,0h0s.01.01.02.02h0s.02.01.03.02h0s0,0,.01,0c0,0,0,0,.01,0h0s0,0,.01,0c0,0,.01,0,.02.01,0,0,.01.01.02.02h0s.02.01.03.02h0s.01.01.02.02c0,0,.02.02.03.02,0,0,.01.01.02.02,0,0,.01.01.02.02h0s0,0,0,0c0,0,.01.01.02.02,0,0,.02.02.03.02,0,0,.01.01.02.02,0,0,.01.01.02.02l.44-.26h0s-.04-.05-.07-.07c0,0,0,0-.01-.01-.02-.02-.05-.04-.07-.07h0c-.05-.05-.11-.1-.16-.14h0s-.46.28-.46.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m31.69,6.52h0c-.06.08-.12.15-.19.22h0s0,0,0,0h0s-.04.05-.07.07h0s0,0,0,0h0s-.04.04-.07.06h0s-.04.05-.07.06h0s0,0,0,0h0s-.05.04-.07.06h0s0,0-.01,0c-.02.02-.05.04-.07.05l1.25-.75s.01-.02.02-.04c0,0,0-.02.01-.02,0-.02.02-.03.02-.05,0,0,0-.02.01-.03,0,0,0,0,0-.01.01-.03.02-.05.03-.08h0s0-.02,0-.03c0,0,0-.01,0-.02l-.82.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m30.74,7.3h0c-.06.03-.12.06-.18.08h0s0,0,0,0h0c-.09.04-.18.07-.27.09h0s0,0,0,0h0c-.06.02-.12.03-.18.04h0s0,0,0,0c-.03,0-.06.01-.09.02l-.82.49c.05,0,.1.01.15.02h0s.05,0,.07,0h0s.05,0,.08,0l1.26-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m29.13,2.32c.14-.03.28-.06.43-.07h0s.17-.1.17-.1h0c-.07,0-.14,0-.21.02h0c-.07,0-.14.02-.21.03h0s-.23.14-.23.14c.02,0,.04,0,.05-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m29.31,2.39c-.05.01-.11.02-.16.04-.2.05-.4.12-.59.2l-.67.4c-.07.05-.14.11-.21.17.03-.03.05-.06.08-.09l-.39.24h0s-.03.04-.05.07h0s-.03.04-.05.07h0s-.03.05-.04.07c0,0,0,0,0,.01-.02.02-.03.05-.05.07h0s-.03.05-.04.07h0s2.19-1.31,2.19-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m27.2,6.85s.01.01.02.02c0,0,0,.01.01.02.01.02.03.04.04.06,0,0,0,0,.01.01.01.01.02.03.03.04,0,0,.01.01.02.02,0,.01.02.02.03.04,0,0,.01.02.02.02,0,0,.02.02.02.03h0s.01.02.02.03c0,0,0,0,.01.01,0,0,.01.01.02.02,0,0,.02.02.02.02,0,0,.02.02.03.03,0,0,.02.02.02.02,0,0,.02.02.03.03,0,0,.01.01.02.02,0,0,0,0,0,0,0,0,.01,0,.02.01,0,0,.01,0,.02.01,0,0,.02.01.03.02.01,0,.02.02.03.03,0,0,.02.01.03.02.01,0,.02.02.03.03,0,0,.02.01.03.02.01,0,.02.02.03.03,0,0,0,0,.01,0l.47-.28s-.05-.03-.08-.05h0s0,0,0,0h0c-.05-.04-.1-.07-.15-.11h0s0,0,0,0c-.05-.04-.09-.08-.14-.12h0s0,0,0,0h0s-.04-.04-.06-.06h0s0,0,0,0h0s-.04-.05-.06-.07h0s0,0,0,0h0s-.04-.04-.06-.07h0s0,0,0,0c0,0-.01-.02-.02-.02-.01-.02-.02-.03-.04-.05h0c-.04-.05-.07-.1-.1-.15h0s-.03-.05-.04-.08h0s0,0,0,0h0s0,0,0,0h0s-.03-.05-.04-.07h0s-.03-.06-.04-.09h0s-.02-.05-.03-.08h0s0,0,0,0h0s0,0,0,0h0s-.02-.05-.03-.08h0s-.43.25-.43.25c.03.06.05.13.08.19,0,0,0,.02.01.03,0,.02.02.03.02.05.01.02.02.05.04.07,0,0,.01.02.02.03.01.02.02.04.03.05,0,0,.01.02.02.03.02.03.03.05.05.08h0s.01.01.02.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m31.68,3.46s.01.02.02.03c0,0,0,.01.01.02.01.01.02.03.03.04h0s0,0,0,0c0,0,0,.01.01.02,0,.01.02.02.02.03,0,0,0,.01.01.02h0s.02.02.02.03h0s0,0,0,0h0s0,0,0,0c.01.02.02.04.04.06h0s0,.01.01.02h0s.02.04.03.06h0s0,.01,0,.01h0s0,0,0,0c.01.02.02.04.03.05h0s0,.02,0,.03h0s.01.02.02.03c0,.01.01.02.02.03h0s.02.05.03.07c0,0,0,0,0,.01h0s0,0,0,0h0s.02.04.03.06h0s0,0,0,0c0,.02.02.05.03.07,0,0,0,.01,0,.02,0,.02.01.04.02.06h0s0,.04.01.05c0,.01,0,.02,0,.03h0s0,.01,0,.02c0,.02.01.04.02.06,0,0,0,.01,0,.02h0s0,.05.01.07h0s0,.01,0,.02c0,0,0,.02,0,.03,0,.01,0,.02,0,.04h0s0,0,0,0h0s0,.04,0,.06c0,0,0,.02,0,.02h0s0,.05,0,.07h0s0,.01,0,.01c0,0,0,.01,0,.02,0,.02,0,.04,0,.05l.47-.28s0-.03,0-.04c0,0,0-.01,0-.02h0s0-.01,0-.01c0-.02,0-.04-.01-.06,0,0,0-.01,0-.02,0-.03-.01-.06-.02-.09,0,0,0-.01,0-.02,0-.02-.01-.05-.02-.07,0,0,0-.01,0-.02,0-.03-.02-.06-.03-.09h0s0-.02,0-.02c0-.01,0-.02-.01-.04,0-.01,0-.02-.01-.04,0,0,0-.01,0-.02-.01-.03-.02-.06-.03-.08h0s-.02-.06-.03-.09c0,0,0-.01,0-.02-.01-.03-.02-.06-.04-.08h0s-.02-.04-.03-.06c0,0,0-.02-.01-.03,0,0,0-.01-.01-.02-.01-.03-.03-.05-.04-.08h0s-.03-.06-.05-.08c0,0,0-.01-.01-.02,0-.01-.01-.02-.02-.03,0-.01-.01-.02-.02-.03h0s0,0,0,0c-.02-.03-.04-.05-.06-.08,0,0,0-.01-.01-.02-.02-.03-.04-.05-.06-.08l-.43.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m32.22,5.13h0s0,.05,0,.07h0s0,.03,0,.04c0,0,0,0,0,.01,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,0,0,.01,0,.02,0,.01,0,.02,0,.03h0s0,.03,0,.04h0s0,.01,0,.01h0s0,0,0,0h0s0,.05-.01.08c0,0,0,.01,0,.02,0,.02,0,.04-.01.06,0,0,0,.01,0,.02,0,.02-.01.05-.02.07,0,0,0,0,0,.01,0,.02-.01.04-.02.06,0,0,0,.01,0,.02,0,.02-.02.05-.02.07h0s-.02.05-.03.08c0,0,0,0,0,.01,0,.02-.02.04-.03.06,0,0,0,0,0,.01-.01.03-.02.05-.03.08h0s.65-.39.65-.39h0s0-.01,0-.01h0s.01-.06.02-.09c0,0,0-.02,0-.02,0-.03.01-.06.02-.09,0,0,0,0,0-.01,0-.03,0-.05.01-.08,0,0,0-.02,0-.02,0-.03,0-.06.01-.09h0s0-.07,0-.09c0,0,0-.02,0-.02,0,0,0-.02,0-.03,0-.02,0-.04,0-.06h0s0-.07,0-.1c0,0,0-.02,0-.02,0-.02,0-.05,0-.07l-.49.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m29.45,7.56h0c-.31-.02-.62-.09-.91-.22l-.49.3s.03.02.04.02c.03.01.05.03.08.04,0,0,.01,0,.02.01.02.01.04.02.06.03,0,0,.01,0,.02.01.03.01.05.02.08.04h0s.06.03.09.04h0s.05.02.08.03h0c.09.04.18.06.27.09l.65-.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m30.14,2.26c-.05,0-.11-.01-.16-.02-.14-.01-.28,0-.42,0h0c-.14.01-.29.04-.43.07-.02,0-.04,0-.05.01-.26.07-.51.18-.74.32-.21.13-.4.29-.57.47-.03.03-.05.06-.08.09.07-.06.14-.12.21-.17.15-.11.31-.22.48-.31.06-.03.13-.06.19-.09.19-.09.39-.15.59-.2.05-.01.11-.03.16-.04.08-.02.17-.03.25-.04.14-.02.28-.02.42-.02.01,0,.03,0,.04,0,.27,0,.53.05.79.12-.21-.1-.44-.16-.67-.19Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 29.64,
    cy: 4.96,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m31.32,5.23s-.09.02-.15-.02l-1.04-.6c-.07-.04-.15-.08-.18-.1-.03-.02-.07-.08,0-.12l.6-.35c.07-.04.15-.02.19.05l.55.95c.04.07.06.15.04.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m30.53,3.74s-.02.08-.09.12l-1.04.6c-.07.04-.12.07-.12.07,0,0-.02.02-.06.04-.03.02-.1.02-.1-.05v-.69c0-.08.06-.14.14-.14h1.1c.08,0,.15.02.17.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m28.84,3.69s.06.06.06.14v1.21c0,.08,0,.14,0,.14,0,0,0,.03,0,.07,0,.04-.03.1-.1.06l-.6-.35c-.07-.04-.09-.12-.05-.19l.55-.95c.04-.07.1-.12.13-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m27.95,5.12s.09-.02.15.02l1.04.6c.07.04.12.07.12.07h0l.06.03c.07.02.07.07,0,.11l-.6.35c-.07.04-.15.02-.19-.05l-.55-.95c-.04-.07-.06-.15-.04-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m28.75,6.61s.02-.08.09-.12l1.04-.6c.07-.04.12-.07.12-.07,0,0,.02-.02.06-.04.03-.02.1-.02.1.05v.69c0,.08-.06.14-.14.14h-1.1c-.08,0-.15-.02-.17-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m30.43,6.66s-.06-.06-.06-.14v-1.21c0-.08,0-.14,0-.14,0,0,0-.03,0-.07,0-.04.03-.1.1-.06l.6.35c.07.04.09.12.05.19l-.55.95c-.04.07-.1.12-.13.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m29.88,4.75c-.25-.14-.57-.06-.72.19s-.06.57.19.72h0c.07.04.15.06.22.07-.09-.07-.12-.2-.06-.31.07-.11.21-.15.32-.09.1.06.14.17.11.28.05-.04.09-.09.12-.14.14-.25.06-.57-.19-.72Zm-.42.33c-.06-.03-.07-.1-.04-.16s.1-.07.16-.04.07.1.04.16-.1.07-.16.04Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 29.52,
    cy: 4.99,
    r: 0.13
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.08678c8972c7210fda3775a73367434e.svg";
export { ForwardRef as ReactComponent };